import * as Kt from "react";
import $e, { createContext as pe, isValidElement as ko, useLayoutEffect as Rs, useEffect as q, useRef as Q, useCallback as be, useMemo as ke, useState as ne, useReducer as Ns, useContext as ie, forwardRef as gn } from "react";
import { flushSync as Vo, createPortal as Ds } from "react-dom";
var Hn = { exports: {} }, Ft = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Zr;
function Ts() {
  if (Zr)
    return Ft;
  Zr = 1;
  var e = $e, t = Symbol.for("react.element"), n = Symbol.for("react.fragment"), r = Object.prototype.hasOwnProperty, o = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, i = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, a, c) {
    var u, m = {}, d = null, p = null;
    c !== void 0 && (d = "" + c), a.key !== void 0 && (d = "" + a.key), a.ref !== void 0 && (p = a.ref);
    for (u in a)
      r.call(a, u) && !i.hasOwnProperty(u) && (m[u] = a[u]);
    if (l && l.defaultProps)
      for (u in a = l.defaultProps, a)
        m[u] === void 0 && (m[u] = a[u]);
    return { $$typeof: t, type: l, key: d, ref: p, props: m, _owner: o.current };
  }
  return Ft.Fragment = n, Ft.jsx = s, Ft.jsxs = s, Ft;
}
var Mt = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Ur;
function Fs() {
  return Ur || (Ur = 1, process.env.NODE_ENV !== "production" && function() {
    var e = $e, t = Symbol.for("react.element"), n = Symbol.for("react.portal"), r = Symbol.for("react.fragment"), o = Symbol.for("react.strict_mode"), i = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), l = Symbol.for("react.context"), a = Symbol.for("react.forward_ref"), c = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), m = Symbol.for("react.memo"), d = Symbol.for("react.lazy"), p = Symbol.for("react.offscreen"), g = Symbol.iterator, x = "@@iterator";
    function h(v) {
      if (v === null || typeof v != "object")
        return null;
      var P = g && v[g] || v[x];
      return typeof P == "function" ? P : null;
    }
    var b = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function S(v) {
      {
        for (var P = arguments.length, D = new Array(P > 1 ? P - 1 : 0), $ = 1; $ < P; $++)
          D[$ - 1] = arguments[$];
        w("error", v, D);
      }
    }
    function w(v, P, D) {
      {
        var $ = b.ReactDebugCurrentFrame, te = $.getStackAddendum();
        te !== "" && (P += "%s", D = D.concat([te]));
        var re = D.map(function(X) {
          return String(X);
        });
        re.unshift("Warning: " + P), Function.prototype.apply.call(console[v], console, re);
      }
    }
    var A = !1, y = !1, I = !1, O = !1, _ = !1, C;
    C = Symbol.for("react.module.reference");
    function N(v) {
      return !!(typeof v == "string" || typeof v == "function" || v === r || v === i || _ || v === o || v === c || v === u || O || v === p || A || y || I || typeof v == "object" && v !== null && (v.$$typeof === d || v.$$typeof === m || v.$$typeof === s || v.$$typeof === l || v.$$typeof === a || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      v.$$typeof === C || v.getModuleId !== void 0));
    }
    function R(v, P, D) {
      var $ = v.displayName;
      if ($)
        return $;
      var te = P.displayName || P.name || "";
      return te !== "" ? D + "(" + te + ")" : D;
    }
    function V(v) {
      return v.displayName || "Context";
    }
    function M(v) {
      if (v == null)
        return null;
      if (typeof v.tag == "number" && S("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof v == "function")
        return v.displayName || v.name || null;
      if (typeof v == "string")
        return v;
      switch (v) {
        case r:
          return "Fragment";
        case n:
          return "Portal";
        case i:
          return "Profiler";
        case o:
          return "StrictMode";
        case c:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof v == "object")
        switch (v.$$typeof) {
          case l:
            var P = v;
            return V(P) + ".Consumer";
          case s:
            var D = v;
            return V(D._context) + ".Provider";
          case a:
            return R(v, v.render, "ForwardRef");
          case m:
            var $ = v.displayName || null;
            return $ !== null ? $ : M(v.type) || "Memo";
          case d: {
            var te = v, re = te._payload, X = te._init;
            try {
              return M(X(re));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var L = Object.assign, T = 0, j, B, de, Se, k, ee, se;
    function ae() {
    }
    ae.__reactDisabledLog = !0;
    function _e() {
      {
        if (T === 0) {
          j = console.log, B = console.info, de = console.warn, Se = console.error, k = console.group, ee = console.groupCollapsed, se = console.groupEnd;
          var v = {
            configurable: !0,
            enumerable: !0,
            value: ae,
            writable: !0
          };
          Object.defineProperties(console, {
            info: v,
            log: v,
            warn: v,
            error: v,
            group: v,
            groupCollapsed: v,
            groupEnd: v
          });
        }
        T++;
      }
    }
    function Ce() {
      {
        if (T--, T === 0) {
          var v = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: L({}, v, {
              value: j
            }),
            info: L({}, v, {
              value: B
            }),
            warn: L({}, v, {
              value: de
            }),
            error: L({}, v, {
              value: Se
            }),
            group: L({}, v, {
              value: k
            }),
            groupCollapsed: L({}, v, {
              value: ee
            }),
            groupEnd: L({}, v, {
              value: se
            })
          });
        }
        T < 0 && S("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Ie = b.ReactCurrentDispatcher, Ge;
    function Le(v, P, D) {
      {
        if (Ge === void 0)
          try {
            throw Error();
          } catch (te) {
            var $ = te.stack.trim().match(/\n( *(at )?)/);
            Ge = $ && $[1] || "";
          }
        return `
` + Ge + v;
      }
    }
    var Ne = !1, Ye;
    {
      var H = typeof WeakMap == "function" ? WeakMap : Map;
      Ye = new H();
    }
    function fe(v, P) {
      if (!v || Ne)
        return "";
      {
        var D = Ye.get(v);
        if (D !== void 0)
          return D;
      }
      var $;
      Ne = !0;
      var te = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var re;
      re = Ie.current, Ie.current = null, _e();
      try {
        if (P) {
          var X = function() {
            throw Error();
          };
          if (Object.defineProperty(X.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(X, []);
            } catch (et) {
              $ = et;
            }
            Reflect.construct(v, [], X);
          } else {
            try {
              X.call();
            } catch (et) {
              $ = et;
            }
            v.call(X.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (et) {
            $ = et;
          }
          v();
        }
      } catch (et) {
        if (et && $ && typeof et.stack == "string") {
          for (var G = et.stack.split(`
`), Oe = $.stack.split(`
`), me = G.length - 1, ve = Oe.length - 1; me >= 1 && ve >= 0 && G[me] !== Oe[ve]; )
            ve--;
          for (; me >= 1 && ve >= 0; me--, ve--)
            if (G[me] !== Oe[ve]) {
              if (me !== 1 || ve !== 1)
                do
                  if (me--, ve--, ve < 0 || G[me] !== Oe[ve]) {
                    var Te = `
` + G[me].replace(" at new ", " at ");
                    return v.displayName && Te.includes("<anonymous>") && (Te = Te.replace("<anonymous>", v.displayName)), typeof v == "function" && Ye.set(v, Te), Te;
                  }
                while (me >= 1 && ve >= 0);
              break;
            }
        }
      } finally {
        Ne = !1, Ie.current = re, Ce(), Error.prepareStackTrace = te;
      }
      var Et = v ? v.displayName || v.name : "", zr = Et ? Le(Et) : "";
      return typeof v == "function" && Ye.set(v, zr), zr;
    }
    function De(v, P, D) {
      return fe(v, !1);
    }
    function Ee(v) {
      var P = v.prototype;
      return !!(P && P.isReactComponent);
    }
    function oe(v, P, D) {
      if (v == null)
        return "";
      if (typeof v == "function")
        return fe(v, Ee(v));
      if (typeof v == "string")
        return Le(v);
      switch (v) {
        case c:
          return Le("Suspense");
        case u:
          return Le("SuspenseList");
      }
      if (typeof v == "object")
        switch (v.$$typeof) {
          case a:
            return De(v.render);
          case m:
            return oe(v.type, P, D);
          case d: {
            var $ = v, te = $._payload, re = $._init;
            try {
              return oe(re(te), P, D);
            } catch {
            }
          }
        }
      return "";
    }
    var Xe = Object.prototype.hasOwnProperty, Je = {}, St = b.ReactDebugCurrentFrame;
    function Qe(v) {
      if (v) {
        var P = v._owner, D = oe(v.type, v._source, P ? P.type : null);
        St.setExtraStackFrame(D);
      } else
        St.setExtraStackFrame(null);
    }
    function Yt(v, P, D, $, te) {
      {
        var re = Function.call.bind(Xe);
        for (var X in v)
          if (re(v, X)) {
            var G = void 0;
            try {
              if (typeof v[X] != "function") {
                var Oe = Error(($ || "React class") + ": " + D + " type `" + X + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof v[X] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw Oe.name = "Invariant Violation", Oe;
              }
              G = v[X](P, X, $, D, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (me) {
              G = me;
            }
            G && !(G instanceof Error) && (Qe(te), S("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", $ || "React class", D, X, typeof G), Qe(null)), G instanceof Error && !(G.message in Je) && (Je[G.message] = !0, Qe(te), S("Failed %s type: %s", D, G.message), Qe(null));
          }
      }
    }
    var ms = Array.isArray;
    function wn(v) {
      return ms(v);
    }
    function vs(v) {
      {
        var P = typeof Symbol == "function" && Symbol.toStringTag, D = P && v[Symbol.toStringTag] || v.constructor.name || "Object";
        return D;
      }
    }
    function ps(v) {
      try {
        return Tr(v), !1;
      } catch {
        return !0;
      }
    }
    function Tr(v) {
      return "" + v;
    }
    function Fr(v) {
      if (ps(v))
        return S("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", vs(v)), Tr(v);
    }
    var Tt = b.ReactCurrentOwner, gs = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, Mr, kr, _n;
    _n = {};
    function hs(v) {
      if (Xe.call(v, "ref")) {
        var P = Object.getOwnPropertyDescriptor(v, "ref").get;
        if (P && P.isReactWarning)
          return !1;
      }
      return v.ref !== void 0;
    }
    function bs(v) {
      if (Xe.call(v, "key")) {
        var P = Object.getOwnPropertyDescriptor(v, "key").get;
        if (P && P.isReactWarning)
          return !1;
      }
      return v.key !== void 0;
    }
    function xs(v, P) {
      if (typeof v.ref == "string" && Tt.current && P && Tt.current.stateNode !== P) {
        var D = M(Tt.current.type);
        _n[D] || (S('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', M(Tt.current.type), v.ref), _n[D] = !0);
      }
    }
    function Ss(v, P) {
      {
        var D = function() {
          Mr || (Mr = !0, S("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", P));
        };
        D.isReactWarning = !0, Object.defineProperty(v, "key", {
          get: D,
          configurable: !0
        });
      }
    }
    function Cs(v, P) {
      {
        var D = function() {
          kr || (kr = !0, S("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", P));
        };
        D.isReactWarning = !0, Object.defineProperty(v, "ref", {
          get: D,
          configurable: !0
        });
      }
    }
    var Es = function(v, P, D, $, te, re, X) {
      var G = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: t,
        // Built-in properties that belong on the element
        type: v,
        key: P,
        ref: D,
        props: X,
        // Record the component responsible for creating this element.
        _owner: re
      };
      return G._store = {}, Object.defineProperty(G._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(G, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: $
      }), Object.defineProperty(G, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: te
      }), Object.freeze && (Object.freeze(G.props), Object.freeze(G)), G;
    };
    function ys(v, P, D, $, te) {
      {
        var re, X = {}, G = null, Oe = null;
        D !== void 0 && (Fr(D), G = "" + D), bs(P) && (Fr(P.key), G = "" + P.key), hs(P) && (Oe = P.ref, xs(P, te));
        for (re in P)
          Xe.call(P, re) && !gs.hasOwnProperty(re) && (X[re] = P[re]);
        if (v && v.defaultProps) {
          var me = v.defaultProps;
          for (re in me)
            X[re] === void 0 && (X[re] = me[re]);
        }
        if (G || Oe) {
          var ve = typeof v == "function" ? v.displayName || v.name || "Unknown" : v;
          G && Ss(X, ve), Oe && Cs(X, ve);
        }
        return Es(v, G, Oe, te, $, Tt.current, X);
      }
    }
    var On = b.ReactCurrentOwner, Vr = b.ReactDebugCurrentFrame;
    function Ct(v) {
      if (v) {
        var P = v._owner, D = oe(v.type, v._source, P ? P.type : null);
        Vr.setExtraStackFrame(D);
      } else
        Vr.setExtraStackFrame(null);
    }
    var In;
    In = !1;
    function An(v) {
      return typeof v == "object" && v !== null && v.$$typeof === t;
    }
    function Br() {
      {
        if (On.current) {
          var v = M(On.current.type);
          if (v)
            return `

Check the render method of \`` + v + "`.";
        }
        return "";
      }
    }
    function ws(v) {
      {
        if (v !== void 0) {
          var P = v.fileName.replace(/^.*[\\\/]/, ""), D = v.lineNumber;
          return `

Check your code at ` + P + ":" + D + ".";
        }
        return "";
      }
    }
    var Hr = {};
    function _s(v) {
      {
        var P = Br();
        if (!P) {
          var D = typeof v == "string" ? v : v.displayName || v.name;
          D && (P = `

Check the top-level render call using <` + D + ">.");
        }
        return P;
      }
    }
    function $r(v, P) {
      {
        if (!v._store || v._store.validated || v.key != null)
          return;
        v._store.validated = !0;
        var D = _s(P);
        if (Hr[D])
          return;
        Hr[D] = !0;
        var $ = "";
        v && v._owner && v._owner !== On.current && ($ = " It was passed a child from " + M(v._owner.type) + "."), Ct(v), S('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', D, $), Ct(null);
      }
    }
    function Kr(v, P) {
      {
        if (typeof v != "object")
          return;
        if (wn(v))
          for (var D = 0; D < v.length; D++) {
            var $ = v[D];
            An($) && $r($, P);
          }
        else if (An(v))
          v._store && (v._store.validated = !0);
        else if (v) {
          var te = h(v);
          if (typeof te == "function" && te !== v.entries)
            for (var re = te.call(v), X; !(X = re.next()).done; )
              An(X.value) && $r(X.value, P);
        }
      }
    }
    function Os(v) {
      {
        var P = v.type;
        if (P == null || typeof P == "string")
          return;
        var D;
        if (typeof P == "function")
          D = P.propTypes;
        else if (typeof P == "object" && (P.$$typeof === a || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        P.$$typeof === m))
          D = P.propTypes;
        else
          return;
        if (D) {
          var $ = M(P);
          Yt(D, v.props, "prop", $, v);
        } else if (P.PropTypes !== void 0 && !In) {
          In = !0;
          var te = M(P);
          S("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", te || "Unknown");
        }
        typeof P.getDefaultProps == "function" && !P.getDefaultProps.isReactClassApproved && S("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Is(v) {
      {
        for (var P = Object.keys(v.props), D = 0; D < P.length; D++) {
          var $ = P[D];
          if ($ !== "children" && $ !== "key") {
            Ct(v), S("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", $), Ct(null);
            break;
          }
        }
        v.ref !== null && (Ct(v), S("Invalid attribute `ref` supplied to `React.Fragment`."), Ct(null));
      }
    }
    function Wr(v, P, D, $, te, re) {
      {
        var X = N(v);
        if (!X) {
          var G = "";
          (v === void 0 || typeof v == "object" && v !== null && Object.keys(v).length === 0) && (G += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var Oe = ws(te);
          Oe ? G += Oe : G += Br();
          var me;
          v === null ? me = "null" : wn(v) ? me = "array" : v !== void 0 && v.$$typeof === t ? (me = "<" + (M(v.type) || "Unknown") + " />", G = " Did you accidentally export a JSX literal instead of a component?") : me = typeof v, S("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", me, G);
        }
        var ve = ys(v, P, D, te, re);
        if (ve == null)
          return ve;
        if (X) {
          var Te = P.children;
          if (Te !== void 0)
            if ($)
              if (wn(Te)) {
                for (var Et = 0; Et < Te.length; Et++)
                  Kr(Te[Et], v);
                Object.freeze && Object.freeze(Te);
              } else
                S("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Kr(Te, v);
        }
        return v === r ? Is(ve) : Os(ve), ve;
      }
    }
    function As(v, P, D) {
      return Wr(v, P, D, !0);
    }
    function Ps(v, P, D) {
      return Wr(v, P, D, !1);
    }
    var Ls = Ps, js = As;
    Mt.Fragment = r, Mt.jsx = Ls, Mt.jsxs = js;
  }()), Mt;
}
process.env.NODE_ENV === "production" ? Hn.exports = Ts() : Hn.exports = Fs();
var f = Hn.exports, Ms = pe(!1), ks = Object.defineProperty, Vs = Object.defineProperties, Bs = Object.getOwnPropertyDescriptors, sn = Object.getOwnPropertySymbols, Bo = Object.prototype.hasOwnProperty, Ho = Object.prototype.propertyIsEnumerable, qr = (e, t, n) => t in e ? ks(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, E = (e, t) => {
  for (var n in t || (t = {}))
    Bo.call(t, n) && qr(e, n, t[n]);
  if (sn)
    for (var n of sn(t))
      Ho.call(t, n) && qr(e, n, t[n]);
  return e;
}, F = (e, t) => Vs(e, Bs(t)), Z = (e, t) => {
  var n = {};
  for (var r in e)
    Bo.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && sn)
    for (var r of sn(e))
      t.indexOf(r) < 0 && Ho.call(e, r) && (n[r] = e[r]);
  return n;
}, Hs = Object.defineProperty, $s = Object.defineProperties, Ks = Object.getOwnPropertyDescriptors, an = Object.getOwnPropertySymbols, $o = Object.prototype.hasOwnProperty, Ko = Object.prototype.propertyIsEnumerable, Gr = (e, t, n) => t in e ? Hs(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, Y = (e, t) => {
  for (var n in t || (t = {}))
    $o.call(t, n) && Gr(e, n, t[n]);
  if (an)
    for (var n of an(t))
      Ko.call(t, n) && Gr(e, n, t[n]);
  return e;
}, le = (e, t) => $s(e, Ks(t)), Wo = (e, t) => {
  var n = {};
  for (var r in e)
    $o.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && an)
    for (var r of an(e))
      t.indexOf(r) < 0 && Ko.call(e, r) && (n[r] = e[r]);
  return n;
};
function $n(...e) {
}
function nn(e, t) {
  if (Ws(e)) {
    const n = zs(t) ? t() : t;
    return e(n);
  }
  return e;
}
function Ws(e) {
  return typeof e == "function";
}
function zs(e) {
  return typeof e == "function";
}
function ln(e) {
  return typeof e == "object" && e != null;
}
function Zs(e) {
  return typeof e == "number" ? Math.floor(e) === e : String(Math.floor(Number(e))) === e;
}
function ft(e, t) {
  return Object.prototype.hasOwnProperty.call(e, t);
}
function Ze(...e) {
  return (...t) => {
    for (const n of e)
      typeof n == "function" && n(...t);
  };
}
function Us(...e) {
  return e.filter(Boolean).join(" ") || void 0;
}
function qs(e) {
  return e.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
}
function Gs(e, t) {
  const n = Y({}, e);
  for (const r of t)
    ft(n, r) && delete n[r];
  return n;
}
function Ys(e, t) {
  const n = {};
  for (const r of t)
    ft(e, r) && (n[r] = e[r]);
  return n;
}
function zo(e) {
  return e;
}
function Ke(e, t) {
  if (!e)
    throw typeof t != "string" ? new Error("Invariant failed") : new Error(t);
}
function Xs(e) {
  return Object.keys(e);
}
function W(...e) {
  for (const t of e)
    if (t !== void 0)
      return t;
}
function Kn(e, t) {
  typeof e == "function" ? e(t) : e && (e.current = t);
}
function Js(e) {
  return !(!e || !ko(e) || !("ref" in e));
}
function Qs(e) {
  return Js(e) ? e.ref : null;
}
function ea(e, t) {
  const n = E({}, e);
  for (const r in t) {
    if (!ft(t, r))
      continue;
    if (r === "className") {
      const i = "className";
      n[i] = e[i] ? `${e[i]} ${t[i]}` : t[i];
      continue;
    }
    if (r === "style") {
      const i = "style";
      n[i] = e[i] ? E(E({}, e[i]), t[i]) : t[i];
      continue;
    }
    const o = t[r];
    if (typeof o == "function" && r.startsWith("on")) {
      const i = e[r];
      if (typeof i == "function") {
        n[r] = (...s) => {
          o(...s), i(...s);
        };
        continue;
      }
    }
    n[r] = o;
  }
  return n;
}
var Pt = ta();
function ta() {
  var e;
  return typeof window < "u" && !!((e = window.document) != null && e.createElement);
}
function we(e) {
  return e ? e.ownerDocument || e : document;
}
function na(e) {
  return we(e).defaultView || window;
}
function st(e, t = !1) {
  const { activeElement: n } = we(e);
  if (!(n != null && n.nodeName))
    return null;
  if (Qn(n) && n.contentDocument)
    return st(
      n.contentDocument.body,
      t
    );
  if (t) {
    const r = n.getAttribute("aria-activedescendant");
    if (r) {
      const o = we(n).getElementById(r);
      if (o)
        return o;
    }
  }
  return n;
}
function Pe(e, t) {
  return e === t || e.contains(t);
}
function Qn(e) {
  return e.tagName === "IFRAME";
}
function ot(e) {
  const t = e.tagName.toLowerCase();
  return t === "button" ? !0 : t === "input" && e.type ? ra.indexOf(e.type) !== -1 : !1;
}
var ra = [
  "button",
  "color",
  "file",
  "image",
  "reset",
  "submit"
];
function Zo(e, t) {
  return "matches" in e ? e.matches(t) : "msMatchesSelector" in e ? e.msMatchesSelector(t) : e.webkitMatchesSelector(t);
}
function Uo(e) {
  const t = e;
  return t.offsetWidth > 0 || t.offsetHeight > 0 || e.getClientRects().length > 0;
}
function er(e, t) {
  if ("closest" in e)
    return e.closest(t);
  do {
    if (Zo(e, t))
      return e;
    e = e.parentElement || e.parentNode;
  } while (e !== null && e.nodeType === 1);
  return null;
}
function Zt(e) {
  try {
    const t = e instanceof HTMLInputElement && e.selectionStart !== null, n = e.tagName === "TEXTAREA";
    return t || n || !1;
  } catch {
    return !1;
  }
}
function qo(e, t) {
  const n = ["dialog", "menu", "listbox", "tree", "grid"], r = e == null ? void 0 : e.getAttribute("role");
  return r && n.indexOf(r) !== -1 ? r : t;
}
function oa(e, t) {
  var n;
  const r = {
    menu: "menuitem",
    listbox: "option",
    tree: "treeitem",
    grid: "gridcell"
  }, o = qo(e);
  return o && (n = r[o]) != null ? n : t;
}
function Go(e) {
  if (!e)
    return null;
  if (e.clientHeight && e.scrollHeight > e.clientHeight) {
    const { overflowY: t } = getComputedStyle(e);
    if (t !== "visible" && t !== "hidden")
      return e;
  } else if (e.clientWidth && e.scrollWidth > e.clientWidth) {
    const { overflowX: t } = getComputedStyle(e);
    if (t !== "visible" && t !== "hidden")
      return e;
  }
  return Go(e.parentElement) || document.scrollingElement || document.body;
}
function ia() {
  return Pt && !!navigator.maxTouchPoints;
}
function tr() {
  return Pt ? /mac|iphone|ipad|ipod/i.test(navigator.platform) : !1;
}
function nr() {
  return Pt && tr() && /apple/i.test(navigator.vendor);
}
function sa() {
  return Pt && /firefox\//i.test(navigator.userAgent);
}
function aa() {
  return Pt && navigator.platform.startsWith("Mac") && !ia();
}
function Yo(e) {
  return !!(e.currentTarget && !Pe(e.currentTarget, e.target));
}
function Ae(e) {
  return e.target === e.currentTarget;
}
function la(e) {
  const t = e.currentTarget;
  if (!t)
    return !1;
  const n = tr();
  if (n && !e.metaKey || !n && !e.ctrlKey)
    return !1;
  const r = t.tagName.toLowerCase();
  return r === "a" || r === "button" && t.type === "submit" || r === "input" && t.type === "submit";
}
function ua(e) {
  const t = e.currentTarget;
  if (!t)
    return !1;
  const n = t.tagName.toLowerCase();
  return e.altKey ? n === "a" || n === "button" && t.type === "submit" || n === "input" && t.type === "submit" : !1;
}
function kt(e, t) {
  const n = new FocusEvent("blur", t), r = e.dispatchEvent(n), o = le(Y({}, t), { bubbles: !0 });
  return e.dispatchEvent(new FocusEvent("focusout", o)), r;
}
function ca(e, t) {
  const n = new FocusEvent("focus", t), r = e.dispatchEvent(n), o = le(Y({}, t), { bubbles: !0 });
  return e.dispatchEvent(new FocusEvent("focusin", o)), r;
}
function da(e, t, n) {
  const r = new KeyboardEvent(t, n);
  return e.dispatchEvent(r);
}
function Yr(e, t) {
  const n = new MouseEvent("click", t);
  return e.dispatchEvent(n);
}
function yt(e, t) {
  const n = t || e.currentTarget, r = e.relatedTarget;
  return !r || !Pe(n, r);
}
function Wt(e, t, n) {
  const r = requestAnimationFrame(() => {
    e.removeEventListener(t, o, !0), n();
  }), o = () => {
    cancelAnimationFrame(r), n();
  };
  return e.addEventListener(t, o, {
    once: !0,
    capture: !0
  }), r;
}
function He(e, t, n, r = window) {
  var o;
  try {
    r.document.addEventListener(e, t, n);
  } catch {
  }
  const i = [];
  for (let l = 0; l < ((o = r.frames) == null ? void 0 : o.length); l += 1) {
    const a = r.frames[l];
    a && i.push(
      He(e, t, n, a)
    );
  }
  return () => {
    try {
      r.document.removeEventListener(e, t, n);
    } catch {
    }
    i.forEach((l) => l());
  };
}
var rr = E({}, Kt), Xr = rr.useId;
rr.useDeferredValue;
var Jr = rr.useInsertionEffect, ue = Pt ? Rs : q;
function fa(e) {
  const [t] = ne(e);
  return t;
}
function ma(e) {
  const t = Q();
  return t.current === void 0 && (t.current = e()), t.current;
}
function va(e) {
  const t = Q(e);
  return ue(() => {
    t.current = e;
  }), t;
}
function K(e) {
  const t = Q(() => {
    throw new Error("Cannot call an event handler while rendering.");
  });
  return Jr ? Jr(() => {
    t.current = e;
  }) : t.current = e, be((...n) => {
    var r;
    return (r = t.current) == null ? void 0 : r.call(t, ...n);
  }, []);
}
function ce(...e) {
  return ke(() => {
    if (e.some(Boolean))
      return (t) => {
        e.forEach((n) => Kn(n, t));
      };
  }, e);
}
function Ve(e) {
  if (Xr) {
    const r = Xr();
    return e || r;
  }
  const [t, n] = ne(e);
  return ue(() => {
    if (e || t)
      return;
    const r = Math.random().toString(36).substr(2, 6);
    n(`id-${r}`);
  }, [e, t]), e || t;
}
function bt(e, t) {
  const n = (i) => {
    if (typeof i == "string")
      return i;
  }, [r, o] = ne(() => n(t));
  return ue(() => {
    const i = e && "current" in e ? e.current : e;
    o((i == null ? void 0 : i.tagName.toLowerCase()) || n(t));
  }, [e, t]), r;
}
function pa(e, t, n) {
  const [r, o] = ne(n);
  return ue(() => {
    const i = e && "current" in e ? e.current : e, s = i == null ? void 0 : i.getAttribute(t);
    s != null && o(s);
  }, [e, t]), r;
}
function ga(e, t) {
  const n = Q(!1);
  q(() => {
    if (n.current)
      return e();
    n.current = !0;
  }, t), q(
    () => () => {
      n.current = !1;
    },
    []
  );
}
function ha() {
  return Ns(() => [], []);
}
function ye(e) {
  return K(
    typeof e == "function" ? e : () => e
  );
}
function he(e, t, n = []) {
  const r = be(
    (o) => (e.wrapElement && (o = e.wrapElement(o)), t(o)),
    [...n, e.wrapElement]
  );
  return F(E({}, e), { wrapElement: r });
}
function Xo(e = !1, t) {
  const [n, r] = ne(null);
  return { portalRef: ce(r, t), portalNode: n, domReady: !e || n };
}
function ba() {
  return q(() => {
    He("mousemove", Sa, !0), He("mousedown", Xt, !0), He("mouseup", Xt, !0), He("keydown", Xt, !0), He("scroll", Xt, !0);
  }, []), K(() => or);
}
var or = !1, Qr = 0, eo = 0;
function xa(e) {
  const t = e.movementX || e.screenX - Qr, n = e.movementY || e.screenY - eo;
  return Qr = e.screenX, eo = e.screenY, t || n || process.env.NODE_ENV === "test";
}
function Sa(e) {
  xa(e) && (or = !0);
}
function Xt() {
  or = !1;
}
function Ca(e) {
  return typeof e == "function";
}
function J(e) {
  const t = (n, r) => e(E({ ref: r }, n));
  return Kt.forwardRef(t);
}
function at(e) {
  const t = J(e);
  return Kt.memo(t);
}
function z(e, t) {
  const n = t, { as: r, wrapElement: o, render: i } = n, s = Z(n, ["as", "wrapElement", "render"]);
  let l;
  const a = ce(t.ref, Qs(i));
  if (r && typeof r != "string")
    l = /* @__PURE__ */ f.jsx(r, F(E({}, s), { render: i }));
  else if (Kt.isValidElement(i)) {
    const c = F(E({}, i.props), { ref: a });
    l = Kt.cloneElement(i, ea(s, c));
  } else if (i)
    l = i(s);
  else if (Ca(t.children)) {
    const c = s, u = Z(c, ["children"]);
    l = t.children(u);
  } else
    r ? l = /* @__PURE__ */ f.jsx(r, E({}, s)) : l = /* @__PURE__ */ f.jsx(e, E({}, s));
  return o ? o(l) : l;
}
function U(e) {
  return (n = {}) => {
    const r = e(n), o = {};
    for (const i in r)
      ft(r, i) && r[i] !== void 0 && (o[i] = r[i]);
    return o;
  };
}
var Wn = { exports: {} }, Pn = {};
/**
 * @license React
 * use-sync-external-store-shim.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var to;
function Ea() {
  if (to)
    return Pn;
  to = 1;
  var e = $e;
  function t(m, d) {
    return m === d && (m !== 0 || 1 / m === 1 / d) || m !== m && d !== d;
  }
  var n = typeof Object.is == "function" ? Object.is : t, r = e.useState, o = e.useEffect, i = e.useLayoutEffect, s = e.useDebugValue;
  function l(m, d) {
    var p = d(), g = r({ inst: { value: p, getSnapshot: d } }), x = g[0].inst, h = g[1];
    return i(function() {
      x.value = p, x.getSnapshot = d, a(x) && h({ inst: x });
    }, [m, p, d]), o(function() {
      return a(x) && h({ inst: x }), m(function() {
        a(x) && h({ inst: x });
      });
    }, [m]), s(p), p;
  }
  function a(m) {
    var d = m.getSnapshot;
    m = m.value;
    try {
      var p = d();
      return !n(m, p);
    } catch {
      return !0;
    }
  }
  function c(m, d) {
    return d();
  }
  var u = typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u" ? c : l;
  return Pn.useSyncExternalStore = e.useSyncExternalStore !== void 0 ? e.useSyncExternalStore : u, Pn;
}
var Ln = {};
/**
 * @license React
 * use-sync-external-store-shim.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var no;
function ya() {
  return no || (no = 1, process.env.NODE_ENV !== "production" && function() {
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
    var e = $e, t = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function n(w) {
      {
        for (var A = arguments.length, y = new Array(A > 1 ? A - 1 : 0), I = 1; I < A; I++)
          y[I - 1] = arguments[I];
        r("error", w, y);
      }
    }
    function r(w, A, y) {
      {
        var I = t.ReactDebugCurrentFrame, O = I.getStackAddendum();
        O !== "" && (A += "%s", y = y.concat([O]));
        var _ = y.map(function(C) {
          return String(C);
        });
        _.unshift("Warning: " + A), Function.prototype.apply.call(console[w], console, _);
      }
    }
    function o(w, A) {
      return w === A && (w !== 0 || 1 / w === 1 / A) || w !== w && A !== A;
    }
    var i = typeof Object.is == "function" ? Object.is : o, s = e.useState, l = e.useEffect, a = e.useLayoutEffect, c = e.useDebugValue, u = !1, m = !1;
    function d(w, A, y) {
      u || e.startTransition !== void 0 && (u = !0, n("You are using an outdated, pre-release alpha of React 18 that does not support useSyncExternalStore. The use-sync-external-store shim will not work correctly. Upgrade to a newer pre-release."));
      var I = A();
      if (!m) {
        var O = A();
        i(I, O) || (n("The result of getSnapshot should be cached to avoid an infinite loop"), m = !0);
      }
      var _ = s({
        inst: {
          value: I,
          getSnapshot: A
        }
      }), C = _[0].inst, N = _[1];
      return a(function() {
        C.value = I, C.getSnapshot = A, p(C) && N({
          inst: C
        });
      }, [w, I, A]), l(function() {
        p(C) && N({
          inst: C
        });
        var R = function() {
          p(C) && N({
            inst: C
          });
        };
        return w(R);
      }, [w]), c(I), I;
    }
    function p(w) {
      var A = w.getSnapshot, y = w.value;
      try {
        var I = A();
        return !i(y, I);
      } catch {
        return !0;
      }
    }
    function g(w, A, y) {
      return A();
    }
    var x = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u", h = !x, b = h ? g : d, S = e.useSyncExternalStore !== void 0 ? e.useSyncExternalStore : b;
    Ln.useSyncExternalStore = S, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
  }()), Ln;
}
process.env.NODE_ENV === "production" ? Wn.exports = Ea() : Wn.exports = ya();
var wa = Wn.exports, _a = () => () => {
}, jn = !1;
function Oa(e, t = !0) {
  if (jn || !t) {
    e();
    return;
  }
  jn = !0;
  const n = console.error;
  process.env.NODE_ENV !== "production" && (console.error = (r) => {
    r.startsWith("Warning: flushSync") || n(r);
  });
  try {
    Vo(e);
  } finally {
    console.error = n, jn = !1;
  }
}
function nt(e, t = zo) {
  const n = () => {
    if (!e)
      return;
    const r = e.getState(), o = typeof t == "function" ? t : null, i = typeof t == "string" ? t : null;
    if (o)
      return o(r);
    if (i && ft(r, i))
      return r[i];
  };
  return wa.useSyncExternalStore(
    (e == null ? void 0 : e.subscribe) || _a,
    n,
    n
  );
}
function ge(e, t, n, r) {
  const o = ft(t, n) ? t[n] : void 0, i = va({
    value: o,
    setValue: r ? t[r] : void 0
  });
  ue(() => {
    let s = !1;
    return queueMicrotask(() => {
      s = !0;
    }), e.sync(
      (l, a) => {
        const { value: c, setValue: u } = i.current;
        u && l[n] !== a[n] && l[n] !== c && Oa(() => u(l[n]), s);
      },
      [n]
    );
  }, [e, n]), ue(() => e.sync(() => {
    o !== void 0 && e.setState(n, o);
  }, [n]), [e, n, o]);
}
function xt(e) {
  const t = ma(e);
  ue(() => t.init(), [t]);
  const n = be(
    (r) => nt(t, r),
    [t]
  );
  return ke(() => F(E({}, t), { useState: n }), [t, n]);
}
function Fe(e, ...t) {
  let n = e, r = n, o = Symbol(), i = !1;
  const s = /* @__PURE__ */ new Set(), l = /* @__PURE__ */ new Set(), a = /* @__PURE__ */ new Set(), c = /* @__PURE__ */ new Set(), u = /* @__PURE__ */ new WeakMap(), m = /* @__PURE__ */ new WeakMap(), d = (O) => (l.add(O), () => l.delete(O)), p = () => {
    if (i || !t.length)
      return $n;
    i = !0;
    const O = Xs(n).map(
      (N) => Ze(
        ...t.map((R) => {
          var V, M;
          const L = (V = R == null ? void 0 : R.getState) == null ? void 0 : V.call(R);
          if (L && ft(L, N))
            return (M = R == null ? void 0 : R.sync) == null ? void 0 : M.call(R, (T) => w(N, T[N]), [N]);
        })
      )
    ), _ = [];
    l.forEach((N) => _.push(N()));
    const C = t.map((N) => {
      var R;
      return (R = N == null ? void 0 : N.init) == null ? void 0 : R.call(N);
    });
    return Ze(...O, ..._, ...C, () => {
      i = !1;
    });
  }, g = (O, _, C = !1) => {
    const N = C ? c : a;
    return N.add(O), m.set(O, _), () => {
      var R;
      (R = u.get(O)) == null || R(), u.delete(O), m.delete(O), N.delete(O);
    };
  }, x = (O, _) => g(O, _), h = (O, _) => (u.set(O, O(n, n)), g(O, _)), b = (O, _) => (u.set(O, O(n, r)), g(O, _, !0)), S = () => n, w = (O, _) => {
    if (!ft(n, O))
      return;
    const C = nn(_, n[O]);
    if (C === n[O])
      return;
    t.forEach((M) => {
      var L;
      (L = M == null ? void 0 : M.setState) == null || L.call(M, O, C);
    });
    const N = n;
    n = le(Y({}, n), { [O]: C });
    const R = Symbol();
    o = R, s.add(O);
    const V = (M, L, T) => {
      var j;
      const B = m.get(M), de = (Se) => T ? T.has(Se) : Se === O;
      (!B || B.some(de)) && ((j = u.get(M)) == null || j(), u.set(M, M(n, L)));
    };
    a.forEach((M) => V(M, N)), queueMicrotask(() => {
      if (o !== R)
        return;
      const M = n;
      c.forEach((L) => {
        V(L, r, s);
      }), r = M, s.clear();
    });
  }, I = {
    setup: d,
    init: p,
    subscribe: x,
    sync: h,
    syncBatch: b,
    getState: S,
    setState: w,
    pick: (...O) => Fe(Ys(n, O), I),
    omit: (...O) => Fe(Gs(n, O), I)
  };
  return I;
}
function ir(...e) {
  const t = e.reduce((r, o) => {
    var i;
    const s = (i = o == null ? void 0 : o.getState) == null ? void 0 : i.call(o);
    return s ? Y(Y({}, r), s) : r;
  }, {});
  return Fe(t, ...e);
}
function Ia(e = {}) {
  var t;
  const n = (t = e.store) == null ? void 0 : t.getState(), r = {
    value: W(
      e.value,
      n == null ? void 0 : n.value,
      e.defaultValue,
      !1
    )
  }, o = Fe(r, e.store);
  return le(Y({}, o), {
    setValue: (i) => o.setState("value", i)
  });
}
function Aa(e, t) {
  return ge(e, t, "value", "setValue"), e;
}
function Pa(e = {}) {
  const t = xt(() => Ia(e));
  return Aa(t, e);
}
var Jo = pe(!0), sr = "input:not([type='hidden']):not([disabled]), select:not([disabled]), textarea:not([disabled]), a[href], button:not([disabled]), [tabindex], iframe, object, embed, area[href], audio[controls], video[controls], [contenteditable]:not([contenteditable='false'])";
function La(e) {
  return parseInt(e.getAttribute("tabindex") || "0", 10) < 0;
}
function ze(e) {
  return !(!Zo(e, sr) || !Uo(e) || er(e, "[inert]"));
}
function Ot(e) {
  if (!ze(e) || La(e))
    return !1;
  if (!("form" in e) || !e.form || e.checked || e.type !== "radio")
    return !0;
  const t = e.form.elements.namedItem(e.name);
  if (!t || !("length" in t))
    return !0;
  const n = st(e);
  return !n || n === e || !("form" in n) || n.form !== e.form || n.name !== e.name;
}
function ar(e, t) {
  const n = Array.from(
    e.querySelectorAll(sr)
  );
  t && n.unshift(e);
  const r = n.filter(ze);
  return r.forEach((o, i) => {
    if (Qn(o) && o.contentDocument) {
      const s = o.contentDocument.body;
      r.splice(i, 1, ...ar(s));
    }
  }), r;
}
function Ut(e, t, n) {
  const r = Array.from(
    e.querySelectorAll(sr)
  ), o = r.filter(Ot);
  return t && Ot(e) && o.unshift(e), o.forEach((i, s) => {
    if (Qn(i) && i.contentDocument) {
      const l = i.contentDocument.body, a = Ut(
        l,
        !1,
        n
      );
      o.splice(s, 1, ...a);
    }
  }), !o.length && n ? r : o;
}
function ja(e) {
  return Ut(document.body, !1, e);
}
function Qo(e, t, n) {
  const [r] = Ut(
    e,
    t,
    n
  );
  return r || null;
}
function Ra(e, t, n, r) {
  const o = st(e), i = ar(e, t), s = i.indexOf(o), l = i.slice(s + 1);
  return l.find(Ot) || (n ? i.find(Ot) : null) || (r ? l[0] : null) || null;
}
function Rn(e, t) {
  return Ra(
    document.body,
    !1,
    e,
    t
  );
}
function Na(e, t, n, r) {
  const o = st(e), i = ar(e, t).reverse(), s = i.indexOf(o), l = i.slice(s + 1);
  return l.find(Ot) || (n ? i.find(Ot) : null) || (r ? l[0] : null) || null;
}
function ro(e, t) {
  return Na(
    document.body,
    !1,
    e,
    t
  );
}
function un(e) {
  const t = st(e);
  if (!t)
    return !1;
  if (t === e)
    return !0;
  const n = t.getAttribute("aria-activedescendant");
  return n ? n === e.id : !1;
}
function ei(e) {
  const t = st(e);
  if (!t)
    return !1;
  if (Pe(e, t))
    return !0;
  const n = t.getAttribute("aria-activedescendant");
  return !n || !("id" in e) ? !1 : n === e.id ? !0 : !!e.querySelector(`#${CSS.escape(n)}`);
}
function ti(e) {
  !ei(e) && ze(e) && e.focus();
}
function Da(e) {
  var t;
  const n = (t = e.getAttribute("tabindex")) != null ? t : "";
  e.setAttribute("data-tabindex", n), e.setAttribute("tabindex", "-1");
}
function Ta(e, t) {
  Ut(e, t).forEach(Da);
}
function Fa(e) {
  const t = e.querySelectorAll("[data-tabindex]"), n = (r) => {
    const o = r.getAttribute("data-tabindex");
    r.removeAttribute("data-tabindex"), o ? r.setAttribute("tabindex", o) : r.removeAttribute("tabindex");
  };
  e.hasAttribute("data-tabindex") && n(e), t.forEach(n);
}
function Ma(e, t) {
  "scrollIntoView" in e ? (e.focus({ preventScroll: !0 }), e.scrollIntoView(Y({ block: "nearest", inline: "nearest" }, t))) : e.focus();
}
var oo = nr(), ka = [
  "text",
  "search",
  "url",
  "tel",
  "email",
  "password",
  "number",
  "date",
  "month",
  "week",
  "time",
  "datetime",
  "datetime-local"
];
function Va(e) {
  const { tagName: t, readOnly: n, type: r } = e;
  return t === "TEXTAREA" && !n || t === "SELECT" && !n ? !0 : t === "INPUT" && !n ? ka.includes(r) : !!e.isContentEditable;
}
function Ba(e) {
  return e.getAttribute("role") !== "combobox" ? !1 : !!e.dataset.name;
}
function Ha(e) {
  return "labels" in e ? e.labels : null;
}
function io(e) {
  return e.tagName.toLowerCase() === "input" && e.type ? e.type === "radio" || e.type === "checkbox" : !1;
}
function $a(e) {
  return e ? e === "button" || e === "input" || e === "select" || e === "textarea" || e === "a" : !0;
}
function Ka(e) {
  return e ? e === "button" || e === "input" || e === "select" || e === "textarea" : !0;
}
function Wa(e, t, n, r, o) {
  return e ? t ? n && !r ? -1 : void 0 : n ? o : o || 0 : o;
}
function Nn(e, t) {
  return K((n) => {
    e == null || e(n), !n.defaultPrevented && t && (n.stopPropagation(), n.preventDefault());
  });
}
var lr = !0;
function za(e) {
  const t = e.target;
  t && "hasAttribute" in t && (t.hasAttribute("data-focus-visible") || (lr = !1));
}
function Za(e) {
  e.metaKey || e.ctrlKey || e.altKey || (lr = !0);
}
var Lt = U(
  (e) => {
    var t = e, {
      focusable: n = !0,
      accessibleWhenDisabled: r,
      autoFocus: o,
      onFocusVisible: i
    } = t, s = Z(t, [
      "focusable",
      "accessibleWhenDisabled",
      "autoFocus",
      "onFocusVisible"
    ]);
    const l = Q(null);
    q(() => {
      n && (He("mousedown", za, !0), He("keydown", Za, !0));
    }, [n]), oo && q(() => {
      if (!n)
        return;
      const L = l.current;
      if (!L || !io(L))
        return;
      const T = Ha(L);
      if (!T)
        return;
      const j = () => queueMicrotask(() => L.focus());
      return T.forEach((B) => B.addEventListener("mouseup", j)), () => {
        T.forEach(
          (B) => B.removeEventListener("mouseup", j)
        );
      };
    }, [n]);
    const a = n && s.disabled, c = !!a && !r, [u, m] = ne(!1);
    q(() => {
      n && c && u && m(!1);
    }, [n, c, u]), q(() => {
      if (!n || !u)
        return;
      const L = l.current;
      if (!L || typeof IntersectionObserver > "u")
        return;
      const T = new IntersectionObserver(() => {
        ze(L) || m(!1);
      });
      return T.observe(L), () => T.disconnect();
    }, [n, u]);
    const d = Nn(
      s.onKeyPressCapture,
      a
    ), p = Nn(
      s.onMouseDownCapture,
      a
    ), g = Nn(s.onClickCapture, a), x = s.onMouseDown, h = K((L) => {
      if (x == null || x(L), L.defaultPrevented || !n)
        return;
      const T = L.currentTarget;
      if (!oo || Yo(L) || !ot(T) && !io(T))
        return;
      let j = !1;
      const B = () => {
        j = !0;
      }, de = { capture: !0, once: !0 };
      T.addEventListener("focusin", B, de), Wt(T, "mouseup", () => {
        T.removeEventListener("focusin", B, !0), !j && ti(T);
      });
    }), b = (L, T) => {
      if (T && (L.currentTarget = T), i == null || i(L), L.defaultPrevented || !n)
        return;
      const j = L.currentTarget;
      j && un(j) && m(!0);
    }, S = s.onKeyDownCapture, w = K(
      (L) => {
        if (S == null || S(L), L.defaultPrevented || !n || u || L.metaKey || L.altKey || L.ctrlKey || !Ae(L))
          return;
        const T = L.currentTarget;
        queueMicrotask(() => b(L, T));
      }
    ), A = s.onFocusCapture, y = K((L) => {
      if (A == null || A(L), L.defaultPrevented || !n)
        return;
      if (!Ae(L)) {
        m(!1);
        return;
      }
      const T = L.currentTarget, j = () => b(L, T);
      lr || Va(L.target) ? queueMicrotask(j) : Ba(L.target) ? Wt(L.target, "focusout", j) : m(!1);
    }), I = s.onBlur, O = K((L) => {
      I == null || I(L), n && yt(L) && m(!1);
    }), _ = ie(Jo), C = K((L) => {
      n && o && L && _ && queueMicrotask(() => {
        un(L) || ze(L) && L.focus();
      });
    }), N = bt(l, s.as), R = n && $a(N), V = n && Ka(N), M = c ? E({ pointerEvents: "none" }, s.style) : s.style;
    return s = F(E({
      "data-focus-visible": n && u ? "" : void 0,
      "data-autofocus": o ? !0 : void 0,
      "aria-disabled": a ? !0 : void 0
    }, s), {
      ref: ce(l, C, s.ref),
      style: M,
      tabIndex: Wa(
        n,
        c,
        R,
        V,
        s.tabIndex
      ),
      disabled: V && c ? !0 : void 0,
      // TODO: Test Focusable contentEditable.
      contentEditable: a ? void 0 : s.contentEditable,
      onKeyPressCapture: d,
      onClickCapture: g,
      onMouseDownCapture: p,
      onMouseDown: h,
      onKeyDownCapture: w,
      onFocusCapture: y,
      onBlur: O
    }), s;
  }
), Ua = J((e) => (e = Lt(e), z("div", e)));
process.env.NODE_ENV !== "production" && (Ua.displayName = "Focusable");
function so(e) {
  if (!e.isTrusted)
    return !1;
  const t = e.currentTarget;
  return e.key === "Enter" ? ot(t) || t.tagName === "SUMMARY" || t.tagName === "A" : e.key === " " ? ot(t) || t.tagName === "SUMMARY" || t.tagName === "INPUT" || t.tagName === "SELECT" : !1;
}
var hn = U(
  (e) => {
    var t = e, { clickOnEnter: n = !0, clickOnSpace: r = !0 } = t, o = Z(t, ["clickOnEnter", "clickOnSpace"]);
    const i = Q(null), s = bt(i, o.as), l = o.type, [a, c] = ne(
      () => !!s && ot({ tagName: s, type: l })
    );
    q(() => {
      i.current && c(ot(i.current));
    }, []);
    const [u, m] = ne(!1), d = Q(!1), p = "data-command" in o, g = o.onKeyDown, x = K((S) => {
      g == null || g(S);
      const w = S.currentTarget;
      if (S.defaultPrevented || p || o.disabled || !Ae(S) || Zt(w) || w.isContentEditable)
        return;
      const A = n && S.key === "Enter", y = r && S.key === " ", I = S.key === "Enter" && !n, O = S.key === " " && !r;
      if (I || O) {
        S.preventDefault();
        return;
      }
      if (A || y) {
        const _ = so(S);
        if (A) {
          if (!_) {
            S.preventDefault();
            const C = S, N = Z(C, ["view"]), R = () => Yr(w, N);
            sa() ? Wt(w, "keyup", R) : queueMicrotask(R);
          }
        } else
          y && (d.current = !0, _ || (S.preventDefault(), m(!0)));
      }
    }), h = o.onKeyUp, b = K((S) => {
      if (h == null || h(S), S.defaultPrevented || p || o.disabled || S.metaKey)
        return;
      const w = r && S.key === " ";
      if (d.current && w && (d.current = !1, !so(S))) {
        m(!1);
        const A = S.currentTarget, y = S, I = Z(y, ["view"]);
        queueMicrotask(() => Yr(A, I));
      }
    });
    return o = F(E({
      "data-command": "",
      "data-active": u ? "" : void 0,
      type: a ? "button" : void 0
    }, o), {
      ref: ce(i, o.ref),
      onKeyDown: x,
      onKeyUp: b
    }), o = Lt(o), o;
  }
), qa = J((e) => (e = hn(e), z("button", e)));
process.env.NODE_ENV !== "production" && (qa.displayName = "Command");
function ao(e, t) {
  t ? e.indeterminate = !0 : e.indeterminate && (e.indeterminate = !1);
}
function Ga(e, t) {
  return e === "input" && (!t || t === "checkbox");
}
function lo(e) {
  return Array.isArray(e) ? e.toString() : e;
}
var ni = U(
  (e) => {
    var t = e, {
      store: n,
      value: r,
      checked: o,
      defaultChecked: i
    } = t, s = Z(t, [
      "store",
      "value",
      "checked",
      "defaultChecked"
    ]), l;
    const a = nt(n, (y) => {
      if (o !== void 0)
        return o;
      if (y.value !== void 0) {
        if (r != null) {
          if (Array.isArray(y.value)) {
            const I = lo(r);
            return y.value.includes(I);
          }
          return y.value === r;
        }
        return Array.isArray(y.value) ? !1 : typeof y.value == "boolean" ? y.value : !1;
      }
    }), [c, u] = ne(i ?? !1), m = (l = o ?? a) != null ? l : c, d = Q(null), p = bt(d, s.as || "input"), g = Ga(p, s.type), x = m ? m === "mixed" : void 0, h = m === "mixed" ? !1 : m;
    q(() => {
      const y = d.current;
      y && (ao(y, x), y.checked = h);
    }, [x, h]);
    const b = s.onChange, S = K((y) => {
      if (s.disabled) {
        y.stopPropagation(), y.preventDefault();
        return;
      }
      if (ao(y.currentTarget, x), g || (y.currentTarget.checked = !y.currentTarget.checked), b == null || b(y), y.defaultPrevented)
        return;
      const I = y.currentTarget.checked;
      u(I), n == null || n.setValue((O) => {
        if (r == null)
          return I;
        const _ = lo(r);
        return Array.isArray(O) ? I ? [...O, _] : O.filter((C) => C !== _) : O === _ ? !1 : _;
      });
    }), w = s.onClick, A = K((y) => {
      w == null || w(y), !y.defaultPrevented && (g || S(y));
    });
    return s = he(
      s,
      (y) => /* @__PURE__ */ f.jsx(Ms.Provider, { value: h, children: y }),
      [h]
    ), s = F(E({
      role: g ? void 0 : "checkbox",
      type: g ? "checkbox" : void 0,
      "aria-checked": m
    }, s), {
      ref: ce(d, s.ref),
      onChange: S,
      onClick: A
    }), s = hn(E({ clickOnEnter: !g }, s)), E({
      value: g ? r : void 0,
      checked: h
    }, s);
  }
), Ya = J((e) => {
  const t = ni(e);
  return z("input", t);
});
process.env.NODE_ENV !== "production" && (Ya.displayName = "Checkbox");
var ur = U((e) => {
  const t = Q(null), n = bt(t, e.as || "button"), [r, o] = ne(
    () => !!n && ot({ tagName: n, type: e.type })
  );
  return q(() => {
    t.current && o(ot(t.current));
  }, []), e = F(E({
    role: !r && n !== "a" ? "button" : void 0
  }, e), {
    ref: ce(t, e.ref)
  }), e = hn(e), e;
}), cr = J((e) => {
  const t = ur(e);
  return z("button", t);
});
process.env.NODE_ENV !== "production" && (cr.displayName = "Button");
var ri = U((e) => (e = F(E({}, e), {
  style: E({
    border: 0,
    clip: "rect(0 0 0 0)",
    height: "1px",
    margin: "-1px",
    overflow: "hidden",
    padding: 0,
    position: "absolute",
    whiteSpace: "nowrap",
    width: "1px"
  }, e.style)
}), e)), dr = J(
  (e) => {
    const t = ri(e);
    return z("span", t);
  }
);
process.env.NODE_ENV !== "production" && (dr.displayName = "VisuallyHidden");
var Xa = U((e) => (e = F(E({
  "data-focus-trap": "",
  tabIndex: 0,
  "aria-hidden": !0
}, e), {
  style: E({
    // Prevents unintended scroll jumps.
    position: "fixed",
    top: 0,
    left: 0
  }, e.style)
}), e = ri(e), e)), Vt = J((e) => {
  const t = Xa(e);
  return z("span", t);
});
process.env.NODE_ENV !== "production" && (Vt.displayName = "FocusTrap");
var oi = U(
  (e) => {
    var t = e, { store: n, toggleOnClick: r = !0 } = t, o = Z(t, ["store", "toggleOnClick"]);
    const i = Q(null), [s, l] = ne(!1), a = n.useState("disclosureElement"), c = n.useState("open");
    q(() => {
      let b = a === i.current;
      (!a || !a.isConnected) && (n.setDisclosureElement(i.current), b = !0), l(c && b);
    }, [a, c]);
    const u = o.onMouseDown, m = K((b) => {
      n.setDisclosureElement(b.currentTarget), u == null || u(b);
    }), d = o.onClick, p = ye(r), g = "data-disclosure" in o, x = K((b) => {
      n.setDisclosureElement(b.currentTarget), d == null || d(b), !b.defaultPrevented && (g || p(b) && n.toggle());
    }), h = n.useState("contentElement");
    return o = F(E({
      "data-disclosure": "",
      "aria-expanded": s,
      "aria-controls": h == null ? void 0 : h.id
    }, o), {
      ref: ce(i, o.ref),
      onMouseDown: m,
      onClick: x
    }), o = ur(o), o;
  }
), Ja = J((e) => {
  const t = oi(e);
  return z("button", t);
});
process.env.NODE_ENV !== "production" && (Ja.displayName = "Disclosure");
function uo(e, t) {
  const n = setTimeout(t, e);
  return () => clearTimeout(n);
}
function Qa(e) {
  let t = requestAnimationFrame(() => {
    t = requestAnimationFrame(e);
  });
  return () => cancelAnimationFrame(t);
}
function co(...e) {
  return e.join(", ").split(", ").reduce((t, n) => {
    const r = parseFloat(n || "0s") * 1e3;
    return r > t ? r : t;
  }, 0);
}
function fr(e, t, n) {
  return !n && t !== !1 && (!e || !!t);
}
var bn = U(
  (e) => {
    var t = e, { store: n, alwaysVisible: r } = t, o = Z(t, ["store", "alwaysVisible"]);
    const i = Ve(o.id), [s, l] = ne(null), a = n.useState("open"), c = n.useState("mounted"), u = n.useState("animated"), m = n.useState("contentElement");
    ue(() => {
      if (u) {
        if (!(m != null && m.isConnected)) {
          l(null);
          return;
        }
        return Qa(() => {
          l(a ? "enter" : "leave");
        });
      }
    }, [u, m, a]), ue(() => {
      if (!u || !m || !s || s === "enter" && !a || s === "leave" && a)
        return;
      if (typeof u == "number")
        return uo(u, n.stopAnimation);
      const {
        transitionDuration: g,
        animationDuration: x,
        transitionDelay: h,
        animationDelay: b
      } = getComputedStyle(m), S = co(h, b), w = co(g, x), A = S + w;
      if (A)
        return uo(A, n.stopAnimation);
    }, [u, m, a, s]);
    const d = fr(c, o.hidden, r), p = d ? F(E({}, o.style), { display: "none" }) : o.style;
    return o = F(E({
      id: i,
      "data-enter": s === "enter" ? "" : void 0,
      "data-leave": s === "leave" ? "" : void 0,
      hidden: d
    }, o), {
      ref: ce(i ? n.setContentElement : null, o.ref),
      style: p
    }), o;
  }
), el = J(
  (e) => {
    const t = bn(e);
    return z("div", t);
  }
);
process.env.NODE_ENV !== "production" && (el.displayName = "DisclosureContent");
function ii(e = {}) {
  var t;
  const n = ir(
    e.store,
    (t = e.disclosure) == null ? void 0 : t.omit("contentElement", "disclosureElement")
  ), r = n == null ? void 0 : n.getState(), o = W(
    e.open,
    r == null ? void 0 : r.open,
    e.defaultOpen,
    !1
  ), i = W(e.animated, r == null ? void 0 : r.animated, !1), s = {
    open: o,
    animated: i,
    animating: !!i && o,
    mounted: o,
    contentElement: W(r == null ? void 0 : r.contentElement, null),
    disclosureElement: W(r == null ? void 0 : r.disclosureElement, null)
  }, l = Fe(s, n);
  return l.setup(
    () => l.sync(
      (a) => {
        a.animated || l.setState("animating", !1);
      },
      ["animated", "animating"]
    )
  ), l.setup(
    () => l.sync(
      (a, c) => {
        if (!a.animated)
          return;
        const m = a === c ? a.open : a.open !== c.open;
        l.setState("animating", m);
      },
      ["open", "animated"]
    )
  ), l.setup(
    () => l.sync(
      (a) => {
        l.setState("mounted", a.open || a.animating);
      },
      ["open", "animating"]
    )
  ), le(Y({}, l), {
    setOpen: (a) => l.setState("open", a),
    show: () => l.setState("open", !0),
    hide: () => l.setState("open", !1),
    toggle: () => l.setState("open", (a) => !a),
    stopAnimation: () => l.setState("animating", !1),
    setContentElement: (a) => l.setState("contentElement", a),
    setDisclosureElement: (a) => l.setState("disclosureElement", a)
  });
}
function si(e) {
  return {};
}
function ai(e, t) {
  return ge(e, t, "open", "setOpen"), ge(e, t, "animated"), e;
}
function li(e = {}) {
  const t = si(), n = xt(
    () => ii(E(E({}, e), t))
  );
  return ai(n, e);
}
var ui = pe(void 0), ci = pe(void 0), tl = pe(void 0), di = U(
  (e) => {
    var t = e, { store: n } = t, r = Z(t, ["store"]);
    return r = oi(E({ store: n }, r)), r;
  }
), nl = J(
  (e) => {
    const t = di(e);
    return z("button", t);
  }
);
process.env.NODE_ENV !== "production" && (nl.displayName = "DialogDisclosure");
var rl = U(
  (e) => {
    var t = e, { store: n } = t, r = Z(t, ["store"]);
    const o = ie(ui);
    n = n || o;
    const i = r.onClick, s = K((a) => {
      i == null || i(a), !a.defaultPrevented && (n == null || n.hide());
    }), l = ke(
      () => /* @__PURE__ */ f.jsxs(
        "svg",
        {
          "aria-label": "Dismiss popup",
          display: "block",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "1.5pt",
          viewBox: "0 0 16 16",
          height: "1em",
          width: "1em",
          children: [
            /* @__PURE__ */ f.jsx("line", { x1: "4", y1: "4", x2: "12", y2: "12" }),
            /* @__PURE__ */ f.jsx("line", { x1: "4", y1: "12", x2: "12", y2: "4" })
          ]
        }
      ),
      []
    );
    return r = F(E({
      "data-dialog-dismiss": "",
      children: l
    }, r), {
      onClick: s
    }), r = ur(r), r;
  }
), fi = J((e) => {
  const t = rl(e);
  return z("button", t);
});
process.env.NODE_ENV !== "production" && (fi.displayName = "DialogDismiss");
var zn = pe(0), mi = U((e) => {
  const t = Q(null), n = ie(zn) || 1, r = `h${n}`, o = bt(t, e.as || r), i = ke(
    () => !!o && /^h\d$/.test(o),
    [o]
  );
  return e = F(E({
    as: r,
    role: i ? void 0 : "heading",
    "aria-level": i ? void 0 : n
  }, e), {
    ref: ce(t, e.ref)
  }), e;
}), ol = J((e) => {
  const t = mi(e);
  return z("h1", t);
});
process.env.NODE_ENV !== "production" && (ol.displayName = "Heading");
var il = U(
  (e) => {
    var t = e, n = Z(t, ["store"]);
    const r = ie(ci), o = Ve(n.id);
    return ue(() => (r == null || r(o), () => r == null ? void 0 : r(void 0)), [r, o]), n = E({
      id: o
    }, n), n = mi(n), n;
  }
), vi = J((e) => {
  const t = il(e);
  return z("h1", t);
});
process.env.NODE_ENV !== "production" && (vi.displayName = "DialogHeading");
function mr(e, ...t) {
  if (!e)
    return !1;
  const n = e.getAttribute("data-backdrop");
  return n == null ? !1 : n === "" || n === "true" || !t.length ? !0 : t.some((r) => n === r);
}
var Dn = /* @__PURE__ */ new WeakMap();
function xn(e, t, n) {
  Dn.has(e) || Dn.set(e, /* @__PURE__ */ new Map());
  const r = Dn.get(e), o = r.get(t);
  if (!o)
    return r.set(t, n()), () => {
      var l;
      (l = r.get(t)) == null || l(), r.delete(t);
    };
  const i = n(), s = () => {
    i(), o(), r.delete(t);
  };
  return r.set(t, s), () => {
    r.get(t) === s && (i(), r.set(t, o));
  };
}
function pi(e, t, n) {
  return xn(e, t, () => {
    const o = e.getAttribute(t);
    return e.setAttribute(t, n), () => {
      o == null ? e.removeAttribute(t) : e.setAttribute(t, o);
    };
  });
}
function zt(e, t, n) {
  return xn(e, t, () => {
    const o = t in e, i = e[t];
    return e[t] = n, () => {
      o ? e[t] = i : delete e[t];
    };
  });
}
function Zn(e, t) {
  return e ? xn(e, "style", () => {
    const r = e.style.cssText;
    return Object.assign(e.style, t), () => {
      e.style.cssText = r;
    };
  }) : () => {
  };
}
function sl(e, t, n) {
  return e ? xn(e, t, () => {
    const o = e.style.getPropertyValue(t);
    return e.style.setProperty(t, n), () => {
      o ? e.style.setProperty(t, o) : e.style.removeProperty(t);
    };
  }) : () => {
  };
}
var al = ["SCRIPT", "STYLE"];
function ll(e, t) {
  return al.includes(e.tagName) ? !1 : !t.some(
    (n) => n && Pe(e, n)
  );
}
function vr(e, t, n) {
  for (let r of e) {
    if (!(r != null && r.isConnected))
      continue;
    const o = e.some((l) => !l || l === r ? !1 : l.contains(r)), i = we(r), s = r;
    for (; r.parentElement && r !== i.body; ) {
      if (n == null || n(r.parentElement, s), !o)
        for (const l of r.parentElement.children)
          ll(l, e) && t(l, s);
      r = r.parentElement;
    }
  }
}
function It(e = "", t = !1) {
  return `__ariakit-dialog-${t ? "ancestor" : "outside"}${e ? `-${e}` : ""}`;
}
function ul(e, t = "") {
  return Ze(
    // Debug
    // setAttribute(element, getPropertyName(), "true"),
    // setAttribute(element, getPropertyName(id), "true"),
    zt(e, It(), !0),
    zt(e, It(t), !0)
  );
}
function gi(e, t = "") {
  return Ze(
    // Debug
    // setAttribute(element, getPropertyName("", true), "true"),
    // setAttribute(element, getPropertyName(id, true), "true"),
    zt(e, It("", !0), !0),
    zt(e, It(t, !0), !0)
  );
}
function pr(e, t) {
  const n = It(t, !0);
  if (e[n])
    return !0;
  const r = It(t);
  do {
    if (e[r])
      return !0;
    if (!e.parentElement)
      return !1;
    e = e.parentElement;
  } while (!0);
}
function Tn(e, ...t) {
  const n = [], r = t.map((i) => i == null ? void 0 : i.id);
  return vr(
    t,
    (i) => {
      mr(i, ...r) || n.unshift(ul(i, e));
    },
    (i, s) => {
      s.hasAttribute("data-dialog") && s.id !== e || n.unshift(gi(i, e));
    }
  ), () => {
    n.forEach((i) => i());
  };
}
var cl = [
  "a",
  "button",
  "details",
  "dialog",
  "div",
  "form",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "header",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "section",
  "select",
  "span",
  "textarea",
  "ul",
  "svg"
], cn = J((e) => z("div", e));
process.env.NODE_ENV !== "production" && (cn.displayName = "Role");
Object.assign(
  cn,
  cl.reduce((e, t) => (e[t] = J((n) => z(t, n)), e), {})
);
function dl({
  store: e,
  backdrop: t,
  backdropProps: n,
  alwaysVisible: r,
  hidden: o
}) {
  const i = Q(null), s = li({ disclosure: e }), l = e.useState("contentElement");
  ue(() => {
    const u = i.current, m = l;
    u && m && (u.style.zIndex = getComputedStyle(m).zIndex);
  }, [l]), ue(() => {
    const u = l == null ? void 0 : l.id;
    if (!u)
      return;
    const m = i.current;
    if (m)
      return gi(m, u);
  }, [l]), o != null && (n = F(E({}, n), { hidden: o }));
  const a = bn(F(E({
    store: s,
    role: "presentation",
    "data-backdrop": (l == null ? void 0 : l.id) || "",
    alwaysVisible: r
  }, n), {
    ref: ce(n == null ? void 0 : n.ref, i),
    style: E({
      position: "fixed",
      top: 0,
      right: 0,
      bottom: 0,
      left: 0
    }, n == null ? void 0 : n.style)
  }));
  if (!t)
    return null;
  if (ko(t))
    return /* @__PURE__ */ f.jsx(cn, F(E({}, a), { render: t }));
  const c = typeof t != "boolean" ? t : "div";
  return /* @__PURE__ */ f.jsx(cn, F(E({}, a), { render: /* @__PURE__ */ f.jsx(c, {}) }));
}
function hi(e) {
  return pi(e, "aria-hidden", "true");
}
function fl(...e) {
  const t = [], n = e.map((o) => o == null ? void 0 : o.id);
  return vr(e, (o) => {
    mr(o, ...n) || t.unshift(hi(o));
  }), () => {
    t.forEach((o) => o());
  };
}
function bi() {
  return "inert" in HTMLElement.prototype;
}
function ml(e) {
  return "style" in e ? bi() ? zt(e, "inert", !0) : Ze(
    hi(e),
    Zn(e, {
      pointerEvents: "none",
      userSelect: "none",
      cursor: "default"
    })
  ) : $n;
}
function vl(...e) {
  const t = [], n = e.map((o) => o == null ? void 0 : o.id);
  return bi() || ja().forEach((o) => {
    e.some((i) => i && Pe(i, o)) || t.unshift(pi(o, "tabindex", "-1"));
  }), vr(e, (o) => {
    mr(o, ...n) || t.unshift(ml(o));
  }), () => {
    t.forEach((o) => o());
  };
}
function pl({
  attribute: e,
  contentId: t,
  contentElement: n,
  enabled: r
}) {
  const [o, i] = ha(), s = be(() => {
    if (!r || !n)
      return !1;
    const { body: l } = we(n), a = l.getAttribute(e);
    return !a || a === t;
  }, [o, r, n, e, t]);
  return q(() => {
    if (!r || !t || !n)
      return;
    const { body: l } = we(n);
    if (s())
      return l.setAttribute(e, t), () => l.removeAttribute(e);
    const a = new MutationObserver(() => Vo(i));
    return a.observe(l, { attributeFilter: [e] }), () => a.disconnect();
  }, [o, r, t, n, s, e]), s;
}
function gl(e) {
  const t = e.getBoundingClientRect().left;
  return Math.round(t) + e.scrollLeft ? "paddingLeft" : "paddingRight";
}
function hl(e, t, n) {
  const r = pl({
    attribute: "data-dialog-prevent-body-scroll",
    contentElement: e,
    contentId: t,
    enabled: n
  });
  q(() => {
    if (!r() || !e)
      return;
    const o = we(e), i = na(e), { documentElement: s, body: l } = o, a = s.style.getPropertyValue("--scrollbar-width"), c = a ? parseInt(a) : i.innerWidth - s.clientWidth, u = () => sl(
      s,
      "--scrollbar-width",
      `${c}px`
    ), m = gl(s), d = () => Zn(l, {
      overflow: "hidden",
      [m]: `${c}px`
    }), p = () => {
      var x, h;
      const { scrollX: b, scrollY: S, visualViewport: w } = i, A = (x = w == null ? void 0 : w.offsetLeft) != null ? x : 0, y = (h = w == null ? void 0 : w.offsetTop) != null ? h : 0, I = Zn(l, {
        position: "fixed",
        overflow: "hidden",
        top: `${-(S - Math.floor(y))}px`,
        left: `${-(b - Math.floor(A))}px`,
        right: "0",
        [m]: `${c}px`
      });
      return () => {
        I(), process.env.NODE_ENV !== "test" && i.scrollTo(b, S);
      };
    }, g = tr() && !aa();
    return Ze(
      u(),
      g ? p() : d()
    );
  }, [r, e]);
}
var fo = pe({});
function bl(e) {
  const t = ie(fo), [n, r] = ne([]), o = be(
    (l) => {
      var a;
      return r((c) => [...c, l]), Ze((a = t.add) == null ? void 0 : a.call(t, l), () => {
        r((c) => c.filter((u) => u !== l));
      });
    },
    [t]
  );
  ue(() => e.sync(
    (l) => {
      var a;
      if (l.open && l.contentElement)
        return (a = t.add) == null ? void 0 : a.call(t, e);
    },
    ["open", "contentElement"]
  ), [e, t]), ue(() => {
    var l;
    return (l = t.store) == null ? void 0 : l.sync(
      (a) => {
        a.open || e.hide();
      },
      ["open"]
    );
  }, [t, e]);
  const i = ke(() => ({ store: e, add: o }), [e, o]);
  return { wrapElement: be(
    (l) => /* @__PURE__ */ f.jsx(fo.Provider, { value: i, children: l }),
    [i]
  ), nestedDialogs: n };
}
function xl(e) {
  const t = Q();
  return q(() => {
    if (!e) {
      t.current = null;
      return;
    }
    return He("mousedown", (r) => {
      t.current = r.target;
    }, !0);
  }, [e]), t;
}
function Sl(e) {
  return e.tagName === "HTML" ? !0 : Pe(we(e).body, e);
}
function Cl(e, t) {
  if (!e)
    return !1;
  if (Pe(e, t))
    return !0;
  const n = t.getAttribute("aria-activedescendant");
  if (n) {
    const r = we(e).getElementById(n);
    if (r)
      return Pe(e, r);
  }
  return !1;
}
function El(e, t) {
  if (!("clientY" in e))
    return !1;
  const n = t.getBoundingClientRect();
  return n.width === 0 || n.height === 0 ? !1 : n.top <= e.clientY && e.clientY <= n.top + n.height && n.left <= e.clientX && e.clientX <= n.left + n.width;
}
function Fn({
  store: e,
  type: t,
  listener: n,
  capture: r,
  domReady: o
}) {
  const i = K(n), s = e.useState("open"), l = Q(!1);
  ue(() => {
    if (!s || !o)
      return;
    const { contentElement: a } = e.getState();
    if (!a)
      return;
    const c = () => {
      l.current = !0;
    };
    return a.addEventListener("focusin", c, !0), () => a.removeEventListener("focusin", c, !0);
  }, [e, s, o]), q(() => s ? He(t, (c) => {
    const { contentElement: u, disclosureElement: m } = e.getState(), d = c.target;
    !u || !d || !Sl(d) || Pe(u, d) || Cl(m, d) || d.hasAttribute("data-focus-trap") || El(c, u) || l.current && !pr(d, u.id) || i(c);
  }, r) : void 0, [s, r]);
}
function Mn(e, t) {
  return typeof e == "function" ? e(t) : !!e;
}
function yl(e, t, n) {
  const r = e.useState("open"), o = xl(r), i = { store: e, domReady: n, capture: !0 };
  Fn(F(E({}, i), {
    type: "click",
    listener: (s) => {
      const { contentElement: l } = e.getState(), a = o.current;
      a && Uo(a) && pr(a, l == null ? void 0 : l.id) && Mn(t, s) && e.hide();
    }
  })), Fn(F(E({}, i), {
    type: "focusin",
    listener: (s) => {
      const { contentElement: l } = e.getState();
      l && s.target !== we(l) && Mn(t, s) && e.hide();
    }
  })), Fn(F(E({}, i), {
    type: "contextmenu",
    listener: (s) => {
      Mn(t, s) && e.hide();
    }
  }));
}
function wl(e, t) {
  const r = we(e).createElement("button");
  return r.type = "button", r.tabIndex = -1, r.textContent = "Dismiss popup", Object.assign(r.style, {
    border: "0px",
    clip: "rect(0 0 0 0)",
    height: "1px",
    margin: "-1px",
    overflow: "hidden",
    padding: "0px",
    position: "absolute",
    whiteSpace: "nowrap",
    width: "1px"
  }), r.addEventListener("click", t), e.prepend(r), () => {
    r.removeEventListener("click", t), r.remove();
  };
}
var xi = U(
  (e) => {
    var t = e, { autoFocusOnShow: n = !0 } = t, r = Z(t, ["autoFocusOnShow"]);
    return r = he(
      r,
      (o) => /* @__PURE__ */ f.jsx(Jo.Provider, { value: n, children: o }),
      [n]
    ), r;
  }
), _l = J(
  (e) => {
    const t = xi(e);
    return z("div", t);
  }
);
process.env.NODE_ENV !== "production" && (_l.displayName = "FocusableContainer");
function Ol({ level: e, children: t }) {
  const n = ie(zn), r = Math.max(
    Math.min(e || n + 1, 6),
    1
  );
  return /* @__PURE__ */ f.jsx(zn.Provider, { value: r, children: t });
}
var mo = pe(null);
function Il(e) {
  return we(e).body;
}
function Al(e, t) {
  return t ? typeof t == "function" ? t(e) : t : we(e).createElement("div");
}
function Pl(e = "id") {
  return `${e ? `${e}-` : ""}${Math.random().toString(36).substr(2, 6)}`;
}
function ut(e) {
  queueMicrotask(() => {
    e == null || e.focus();
  });
}
var Si = U(
  (e) => {
    var t = e, { preserveTabOrder: n, portalElement: r, portalRef: o, portal: i = !0 } = t, s = Z(t, ["preserveTabOrder", "portalElement", "portalRef", "portal"]);
    const l = Q(null), a = ce(l, s.ref), c = ie(mo), [u, m] = ne(null), d = Q(null), p = Q(null), g = Q(null), x = Q(null);
    return ue(() => {
      const h = l.current;
      if (!h || !i) {
        m(null);
        return;
      }
      const b = Al(h, r);
      if (!b) {
        m(null);
        return;
      }
      const S = b.isConnected;
      if (S || (c || Il(h)).appendChild(b), b.id || (b.id = h.id ? `portal/${h.id}` : Pl()), m(b), Kn(o, b), !S)
        return () => {
          b.remove(), Kn(o, null);
        };
    }, [i, r, c, o]), q(() => {
      if (!u || !n)
        return;
      let h = 0;
      const b = (S) => {
        if (!yt(S))
          return;
        if (S.type === "focusin")
          return Fa(u);
        cancelAnimationFrame(h), h = requestAnimationFrame(() => {
          Ta(u, !0);
        });
      };
      return u.addEventListener("focusin", b, !0), u.addEventListener("focusout", b, !0), () => {
        u.removeEventListener("focusin", b, !0), u.removeEventListener("focusout", b, !0);
      };
    }, [u, n]), s = he(
      s,
      (h) => (h = // While the portal node is not in the DOM, we need to pass the
      // current context to the portal context, otherwise it's going to
      // reset to the body element on nested portals.
      /* @__PURE__ */ f.jsx(mo.Provider, { value: u || c, children: h }), i ? u ? (h = /* @__PURE__ */ f.jsxs(f.Fragment, { children: [
        n && u && /* @__PURE__ */ f.jsx(
          Vt,
          {
            ref: p,
            className: "__focus-trap-inner-before",
            onFocus: (b) => {
              yt(b, u) ? ut(Rn()) : ut(d.current);
            }
          }
        ),
        h,
        n && u && /* @__PURE__ */ f.jsx(
          Vt,
          {
            ref: g,
            className: "__focus-trap-inner-after",
            onFocus: (b) => {
              yt(b, u) ? ut(ro()) : ut(x.current);
            }
          }
        )
      ] }), u && (h = Ds(h, u)), h = /* @__PURE__ */ f.jsxs(f.Fragment, { children: [
        n && u && /* @__PURE__ */ f.jsx(
          Vt,
          {
            ref: d,
            className: "__focus-trap-outer-before",
            onFocus: (b) => {
              !(b.relatedTarget === x.current) && yt(b, u) ? ut(p.current) : ut(ro());
            }
          }
        ),
        n && // We're using position: fixed here so that the browser doesn't
        // add margin to the element when setting gap on a parent element.
        /* @__PURE__ */ f.jsx("span", { "aria-owns": u == null ? void 0 : u.id, style: { position: "fixed" } }),
        h,
        n && u && /* @__PURE__ */ f.jsx(
          Vt,
          {
            ref: x,
            className: "__focus-trap-outer-after",
            onFocus: (b) => {
              if (yt(b, u))
                ut(g.current);
              else {
                const S = Rn();
                if (S === p.current) {
                  requestAnimationFrame(() => {
                    var w;
                    return (w = Rn()) == null ? void 0 : w.focus();
                  });
                  return;
                }
                ut(S);
              }
            }
          }
        )
      ] }), h) : /* @__PURE__ */ f.jsx(
        "span",
        {
          ref: a,
          id: s.id,
          style: { position: "fixed" },
          hidden: !0
        }
      ) : h),
      [u, c, i, s.id, n]
    ), s = F(E({}, s), {
      ref: a
    }), s;
  }
), Ll = J((e) => {
  const t = Si(e);
  return z("div", t);
});
process.env.NODE_ENV !== "production" && (Ll.displayName = "Portal");
var vo = nr();
function jl(e) {
  const t = st();
  return !t || e && Pe(e, t) ? !1 : !!ze(t);
}
function po(e, t = !1) {
  if (!e)
    return null;
  const n = "current" in e ? e.current : e;
  return n ? t ? ze(n) ? n : null : n : null;
}
var Ci = U(
  (e) => {
    var t = e, {
      store: n,
      focusable: r = !0,
      modal: o = !0,
      portal: i = !!o,
      backdrop: s = !!o,
      backdropProps: l,
      hideOnEscape: a = !0,
      hideOnInteractOutside: c = !0,
      getPersistentElements: u,
      preventBodyScroll: m = !!o,
      autoFocusOnShow: d = !0,
      autoFocusOnHide: p = !0,
      initialFocus: g,
      finalFocus: x
    } = t, h = Z(t, [
      "store",
      "focusable",
      "modal",
      "portal",
      "backdrop",
      "backdropProps",
      "hideOnEscape",
      "hideOnInteractOutside",
      "getPersistentElements",
      "preventBodyScroll",
      "autoFocusOnShow",
      "autoFocusOnHide",
      "initialFocus",
      "finalFocus"
    ]);
    const b = Q(null), { portalRef: S, domReady: w } = Xo(i, h.portalRef), A = h.preserveTabOrder, y = n.useState(
      (H) => A && !o && H.mounted
    ), I = Ve(h.id), O = n.useState("open"), _ = n.useState("mounted"), C = n.useState("contentElement"), N = fr(_, h.hidden, h.alwaysVisible);
    hl(C, I, m && !N), yl(n, c, w);
    const { wrapElement: R, nestedDialogs: V } = bl(n);
    h = he(h, R, [R]), ue(() => {
      if (!O)
        return;
      const H = b.current, fe = st(H, !0);
      fe && fe.tagName !== "BODY" && (H && Pe(H, fe) || n.setDisclosureElement(fe));
    }, [O]), vo && q(() => {
      if (!_)
        return;
      const { disclosureElement: H } = n.getState();
      if (!H || !ot(H))
        return;
      const fe = () => {
        let De = !1;
        const Ee = () => {
          De = !0;
        }, oe = { capture: !0, once: !0 };
        H.addEventListener("focusin", Ee, oe), Wt(H, "mouseup", () => {
          H.removeEventListener("focusin", Ee, !0), !De && ti(H);
        });
      };
      return H.addEventListener("mousedown", fe), () => {
        H.removeEventListener("mousedown", fe);
      };
    }, [_]);
    const M = o || // Usually, we only want to disable the accessibility tree outside if the
    // dialog is a modal. But the Portal component can't preserve the tab
    // order on Safari/VoiceOver. By allowing only the dialog/portal to be
    // accessible, we provide a similar tab order flow. We don't need to
    // disable pointer events because it's just for screen readers.
    i && y && nr();
    q(() => {
      if (!_ || !w)
        return;
      const H = b.current;
      if (!(!H || !M || H.querySelector("[data-dialog-dismiss]")))
        return wl(H, n.hide);
    }, [_, w, M]);
    const L = K(u);
    ue(() => {
      if (!w || !I || !O)
        return;
      const { disclosureElement: H } = n.getState(), fe = b.current, De = L() || [], Ee = [
        fe,
        ...De,
        ...V.map((oe) => oe.getState().contentElement)
      ];
      return M ? o ? Ze(
        Tn(I, ...Ee),
        vl(...Ee)
      ) : Ze(
        Tn(I, H, ...Ee),
        fl(...Ee)
      ) : Tn(I, H, ...Ee);
    }, [
      w,
      I,
      O,
      n,
      L,
      V,
      M,
      o
    ]);
    const T = !!d, j = ye(d), [B, de] = ne(!1);
    q(() => {
      if (!O || !T || !w || !(C != null && C.isConnected))
        return;
      const H = po(g, !0) || // If no initial focus is specified, we try to focus the first element
      // with the autofocus attribute. If it's an Ariakit component, the
      // Focusable component will consume the autoFocus prop and add the
      // data-autofocus attribute to the element instead.
      C.querySelector(
        "[data-autofocus=true],[autofocus]"
      ) || // We have to fallback to the first focusable element otherwise portaled
      // dialogs with preserveTabOrder set to true will not receive focus
      // properly because the elements aren't tabbable until the dialog
      // receives focus.
      Qo(C, !0, i && y) || // Finally, we fallback to the dialog element itself.
      C, fe = ze(H);
      j(fe ? H : null) && (de(!0), queueMicrotask(() => {
        H.focus(), vo && H.scrollIntoView({ block: "nearest", inline: "nearest" });
      }));
    }, [
      O,
      T,
      w,
      C,
      g,
      i,
      y,
      j
    ]);
    const Se = !!p, k = ye(p), [ee, se] = ne(!1);
    q(() => {
      if (O)
        return se(!0), () => se(!1);
    }, [O]);
    const ae = be(
      (H, fe = !0) => {
        const { open: De, disclosureElement: Ee } = n.getState();
        if (De || jl(H))
          return;
        let oe = po(x) || Ee;
        if (oe != null && oe.id) {
          const Je = we(oe), St = `[aria-activedescendant="${oe.id}"]`, Qe = Je.querySelector(St);
          Qe && (oe = Qe);
        }
        if (oe && !ze(oe)) {
          const Je = er(oe, "[data-dialog]");
          if (Je && Je.id) {
            const St = we(Je), Qe = `[aria-controls~="${Je.id}"]`, Yt = St.querySelector(Qe);
            Yt && (oe = Yt);
          }
        }
        const Xe = oe && ze(oe);
        if (!Xe && fe) {
          requestAnimationFrame(() => ae(H, !1));
          return;
        }
        k(Xe ? oe : null) && Xe && (oe == null || oe.focus());
      },
      [n, x, k]
    );
    q(() => {
      if (O || !ee || !Se)
        return;
      const H = b.current;
      ae(H);
    }, [O, ee, Se, ae]), q(() => {
      if (!ee || !Se)
        return;
      const H = b.current;
      return () => ae(H);
    }, [ee, Se, ae]);
    const _e = ye(a);
    q(() => !w || !_ ? void 0 : He("keydown", (fe) => {
      if (fe.key !== "Escape" || fe.defaultPrevented)
        return;
      const De = b.current;
      if (!De || pr(De))
        return;
      const Ee = fe.target;
      if (!Ee)
        return;
      const { disclosureElement: oe } = n.getState();
      (() => Ee.tagName === "BODY" || Pe(De, Ee) ? !0 : oe ? !!Pe(oe, Ee) : !1)() && _e(fe) && n.hide();
    }), [_, w, _e]), h = he(
      h,
      (H) => /* @__PURE__ */ f.jsx(Ol, { level: o ? 1 : void 0, children: H }),
      [o]
    );
    const Ce = h.hidden, Ie = h.alwaysVisible;
    h = he(
      h,
      (H) => s ? /* @__PURE__ */ f.jsxs(f.Fragment, { children: [
        /* @__PURE__ */ f.jsx(
          dl,
          {
            store: n,
            backdrop: s,
            backdropProps: l,
            hidden: Ce,
            alwaysVisible: Ie
          }
        ),
        H
      ] }) : H,
      [n, s, l, Ce, Ie]
    );
    const [Ge, Le] = ne(), [Ne, Ye] = ne();
    return h = he(
      h,
      (H) => /* @__PURE__ */ f.jsx(ui.Provider, { value: n, children: /* @__PURE__ */ f.jsx(ci.Provider, { value: Le, children: /* @__PURE__ */ f.jsx(tl.Provider, { value: Ye, children: H }) }) }),
      [n]
    ), h = F(E({
      id: I,
      "data-dialog": "",
      role: "dialog",
      tabIndex: r ? -1 : void 0,
      "aria-labelledby": Ge,
      "aria-describedby": Ne
    }, h), {
      ref: ce(b, h.ref)
    }), h = xi(F(E({}, h), {
      autoFocusOnShow: B
    })), h = bn(E({ store: n }, h)), h = Lt(F(E({}, h), { focusable: r })), h = Si(F(E({ portal: i }, h), { portalRef: S, preserveTabOrder: y })), h;
  }
), Ei = J((e) => {
  const t = Ci(e);
  return z("div", t);
});
process.env.NODE_ENV !== "production" && (Ei.displayName = "Dialog");
function yi(e = {}) {
  return ii(e);
}
function wi(e) {
  return si();
}
function _i(e, t) {
  return ai(e, t);
}
function Rl(e = {}) {
  const t = wi(), n = xt(
    () => yi(E(E({}, e), t))
  );
  return _i(n, e);
}
var Nl = pe(void 0), Oi = U((e) => {
  const [t, n] = ne();
  return e = he(
    e,
    (r) => /* @__PURE__ */ f.jsx(Nl.Provider, { value: n, children: r }),
    []
  ), e = E({
    role: "group",
    "aria-labelledby": t
  }, e), e;
}), Dl = J((e) => {
  const t = Oi(e);
  return z("div", t);
});
process.env.NODE_ENV !== "production" && (Dl.displayName = "Group");
var Tl = pe(
  void 0
), Fl = pe(
  void 0
), Sn = pe(
  void 0
);
function Ii(e) {
  const t = e.relatedTarget;
  return (t == null ? void 0 : t.nodeType) === Node.ELEMENT_NODE ? t : null;
}
function Ml(e) {
  const t = Ii(e);
  return t ? Pe(e.currentTarget, t) : !1;
}
function kl(e) {
  const t = Ii(e);
  return t ? !!er(t, "[data-composite-hover]") : !1;
}
var Ai = U(
  (e) => {
    var t = e, { store: n, focusOnHover: r = !0 } = t, o = Z(t, ["store", "focusOnHover"]);
    const i = ie(Sn);
    n = n || i, Ke(
      n,
      process.env.NODE_ENV !== "production" && "CompositeHover must be wrapped in a Composite component"
    );
    const s = ba(), l = o.onMouseMove, a = ye(r), c = K((d) => {
      if (l == null || l(d), !d.defaultPrevented && s() && a(d)) {
        if (!ei(d.currentTarget)) {
          const p = n == null ? void 0 : n.getState().baseElement;
          p && !un(p) && p.focus();
        }
        n == null || n.setActiveId(d.currentTarget.id);
      }
    }), u = o.onMouseLeave, m = K((d) => {
      var p;
      u == null || u(d), !d.defaultPrevented && s() && (Ml(d) || kl(d) || a(d) && (n == null || n.setActiveId(null), (p = n == null ? void 0 : n.getState().baseElement) == null || p.focus()));
    });
    return o = F(E({
      "data-composite-hover": ""
    }, o), {
      onMouseMove: c,
      onMouseLeave: m
    }), o;
  }
), Vl = at(
  (e) => {
    const t = Ai(e);
    return z("div", t);
  }
);
process.env.NODE_ENV !== "production" && (Vl.displayName = "CompositeHover");
var Bl = pe(
  void 0
), jt = U(
  (e) => {
    var t = e, {
      store: n,
      shouldRegisterItem: r = !0,
      getItem: o = zo,
      element: i
    } = t, s = Z(t, [
      "store",
      "shouldRegisterItem",
      "getItem",
      // @ts-expect-error This prop may come from a collection renderer.
      "element"
    ]);
    const l = ie(Bl);
    n = n || l;
    const a = Ve(s.id), c = Q(), u = be(
      (m) => {
        var d;
        if (!m || !a || !r)
          return (d = c.current) == null ? void 0 : d.call(c);
        const p = o({ id: a, element: m });
        c.current = n == null ? void 0 : n.renderItem(p);
      },
      [a, r, o, n]
    );
    return s = F(E({}, s), {
      ref: ce(u, s.ref)
    }), s;
  }
), Hl = J(
  (e) => {
    const t = jt(e);
    return z("div", t);
  }
);
process.env.NODE_ENV !== "production" && (Hl.displayName = "CollectionItem");
var $l = { id: null };
function Kl(e, t, n = !1) {
  const r = e.findIndex((o) => o.id === t);
  return [
    ...e.slice(r + 1),
    ...n ? [$l] : [],
    ...e.slice(0, r)
  ];
}
function Wl(e, t) {
  return e.find((n) => t ? !n.disabled && n.id !== t : !n.disabled);
}
function ct(e, t) {
  return t && e.item(t) || null;
}
function zl(e) {
  const t = [];
  for (const n of e) {
    const r = t.find((o) => {
      var i;
      return ((i = o[0]) == null ? void 0 : i.rowId) === n.rowId;
    });
    r ? r.push(n) : t.push([n]);
  }
  return t;
}
var Un = Symbol("FOCUS_SILENTLY");
function Zl(e) {
  e[Un] = !0, e.focus();
}
function Ul(e) {
  const t = e[Un];
  return delete e[Un], t;
}
function $t(e, t, n) {
  if (!t || t === n)
    return !1;
  const r = e.item(t.id);
  return !(!r || n && r.element === n);
}
function ql(e) {
  return e.isContentEditable || Zt(e) ? !0 : e.tagName === "INPUT" && !ot(e);
}
function Gl(e, t = !1) {
  const n = e.clientHeight, { top: r } = e.getBoundingClientRect(), o = Math.max(n * 0.875, n - 40) * 1.5, i = t ? n - o + r : o + r;
  return e.tagName === "HTML" ? i + e.scrollTop : i;
}
function Yl(e, t = !1) {
  const { top: n } = e.getBoundingClientRect();
  return t ? n + e.clientHeight : n;
}
function go(e, t, n, r = !1) {
  var o;
  if (!t || !n)
    return;
  const { renderedItems: i } = t.getState(), s = Go(e);
  if (!s)
    return;
  const l = Gl(s, r);
  let a, c;
  for (let u = 0; u < i.length; u += 1) {
    const m = a;
    if (a = n(u), !a)
      break;
    if (a === m)
      continue;
    const d = (o = ct(t, a)) == null ? void 0 : o.element;
    if (!d)
      continue;
    const g = Yl(d, r) - l, x = Math.abs(g);
    if (r && g <= 0 || !r && g >= 0) {
      c !== void 0 && c < x && (a = m);
      break;
    }
    c = x;
  }
  return a;
}
function Xl(e, t) {
  return Ae(e) ? !1 : $t(t, e.target);
}
function Jl(e, t) {
  const n = t.role, [r, o] = ne(n);
  return ue(() => {
    const i = e.current;
    i && o(i.getAttribute("role") || n);
  }, [n]), r;
}
function Ql(e) {
  return e === "option" || e === "treeitem";
}
function eu(e) {
  return e === "option" || e === "tab" || e === "treeitem" || e === "gridcell" || e === "row" || e === "columnheader" || e === "rowheader";
}
var gr = U(
  (e) => {
    var t = e, {
      store: n,
      rowId: r,
      preventScrollOnKeyDown: o = !1,
      moveOnKeyPress: i = !0,
      getItem: s,
      "aria-setsize": l,
      "aria-posinset": a
    } = t, c = Z(t, [
      "store",
      "rowId",
      "preventScrollOnKeyDown",
      "moveOnKeyPress",
      "getItem",
      "aria-setsize",
      "aria-posinset"
    ]), u;
    const m = ie(Sn);
    n = n || m;
    const d = Ve(c.id), p = Q(null), g = ie(Fl), x = nt(n, (k) => {
      if (r)
        return r;
      if (g != null && g.baseElement && g.baseElement === k.baseElement)
        return g.id;
    }), h = c.disabled && !c.accessibleWhenDisabled, b = be(
      (k) => {
        const ee = F(E({}, k), {
          id: d || k.id,
          rowId: x,
          disabled: !!h
        });
        return s ? s(ee) : ee;
      },
      [d, x, h, s]
    ), S = c.onFocus, w = Q(!1), A = K((k) => {
      if (S == null || S(k), k.defaultPrevented || Yo(k) || !d || !n)
        return;
      const { activeId: ee, virtualFocus: se, baseElement: ae } = n.getState();
      if (Xl(k, n) || (ee !== d && n.setActiveId(d), !se) || !Ae(k) || ql(k.currentTarget) || !ae)
        return;
      w.current = !0, k.relatedTarget === ae || $t(n, k.relatedTarget) ? Zl(ae) : ae.focus();
    }), y = c.onBlurCapture, I = K((k) => {
      if (y == null || y(k), k.defaultPrevented)
        return;
      const ee = n == null ? void 0 : n.getState();
      ee != null && ee.virtualFocus && w.current && (w.current = !1, k.preventDefault(), k.stopPropagation());
    }), O = c.onKeyDown, _ = ye(o), C = ye(i), N = K((k) => {
      if (O == null || O(k), k.defaultPrevented || !Ae(k) || !n)
        return;
      const { currentTarget: ee } = k, se = n.getState(), ae = n.item(d), _e = !!(ae != null && ae.rowId), Ce = se.orientation !== "horizontal", Ie = se.orientation !== "vertical", Le = {
        ArrowUp: (_e || Ce) && n.up,
        ArrowRight: (_e || Ie) && n.next,
        ArrowDown: (_e || Ce) && n.down,
        ArrowLeft: (_e || Ie) && n.previous,
        Home: () => !_e || k.ctrlKey ? n == null ? void 0 : n.first() : n == null ? void 0 : n.previous(-1),
        End: () => !_e || k.ctrlKey ? n == null ? void 0 : n.last() : n == null ? void 0 : n.next(-1),
        PageUp: () => go(ee, n, n == null ? void 0 : n.up, !0),
        PageDown: () => go(ee, n, n == null ? void 0 : n.down)
      }[k.key];
      if (Le) {
        const Ne = Le();
        if (_(k) || Ne !== void 0) {
          if (!C(k))
            return;
          k.preventDefault(), n.move(Ne);
        }
      }
    }), R = nt(
      n,
      (k) => k.baseElement || void 0
    ), V = ke(
      () => ({ id: d, baseElement: R }),
      [d, R]
    );
    c = he(
      c,
      (k) => /* @__PURE__ */ f.jsx(Tl.Provider, { value: V, children: k }),
      [V]
    );
    const M = nt(n, (k) => k.activeId === d), L = nt(n, "virtualFocus"), T = Jl(p, c);
    let j;
    M && (Ql(T) || L && eu(T)) && (j = !0);
    const B = nt(n, (k) => {
      if (l != null)
        return l;
      if (g != null && g.ariaSetSize && g.baseElement === k.baseElement)
        return g.ariaSetSize;
    }), de = nt(n, (k) => {
      if (a != null)
        return a;
      if (!(g != null && g.ariaPosInSet) || g.baseElement !== k.baseElement)
        return;
      const ee = k.renderedItems.filter(
        (se) => se.rowId === x
      );
      return g.ariaPosInSet + ee.findIndex((se) => se.id === d);
    }), Se = (u = nt(n, (k) => k.renderedItems.length ? !k.virtualFocus && k.activeId === d : !0)) != null ? u : !0;
    return c = F(E({
      id: d,
      "aria-selected": j,
      "data-active-item": M ? "" : void 0
    }, c), {
      ref: ce(p, c.ref),
      tabIndex: Se ? c.tabIndex : -1,
      onFocus: A,
      onBlurCapture: I,
      onKeyDown: N
    }), c = hn(c), c = jt(F(E({
      store: n
    }, c), {
      getItem: b,
      shouldRegisterItem: d ? c.shouldRegisterItem : !1
    })), F(E({}, c), {
      "aria-setsize": B,
      "aria-posinset": de
    });
  }
), tu = at(
  (e) => {
    const t = gr(e);
    return z("button", t);
  }
);
process.env.NODE_ENV !== "production" && (tu.displayName = "CompositeItem");
function nu(e, t) {
  return !!(t.compareDocumentPosition(e) & Node.DOCUMENT_POSITION_PRECEDING);
}
function ru(e) {
  const t = e.map((r, o) => [o, r]);
  let n = !1;
  return t.sort(([r, o], [i, s]) => {
    const l = o.element, a = s.element;
    return l === a || !l || !a ? 0 : nu(l, a) ? (r > i && (n = !0), -1) : (r < i && (n = !0), 1);
  }), n ? t.map(([r, o]) => o) : e;
}
function ou(e) {
  var t;
  const n = e.find((i) => !!i.element), r = [...e].reverse().find((i) => !!i.element);
  let o = (t = n == null ? void 0 : n.element) == null ? void 0 : t.parentElement;
  for (; o && (r != null && r.element); ) {
    if (r && o.contains(r.element))
      return o;
    o = o.parentElement;
  }
  return we(o).body;
}
function hr(e = {}) {
  var t;
  const n = (t = e.store) == null ? void 0 : t.getState(), r = W(
    e.items,
    n == null ? void 0 : n.items,
    e.defaultItems,
    []
  ), o = new Map(r.map((m) => [m.id, m])), i = {
    items: r,
    renderedItems: W(n == null ? void 0 : n.renderedItems, [])
  }, s = Fe({
    renderedItems: i.renderedItems
  }), l = Fe(i, e.store), a = () => {
    const m = s.getState(), d = ru(m.renderedItems);
    s.setState("renderedItems", d), l.setState("renderedItems", d);
  };
  l.setup(() => s.syncBatch(
    (m) => {
      let d = !0, p = requestAnimationFrame(a);
      if (typeof IntersectionObserver != "function")
        return;
      const g = () => {
        if (d) {
          d = !1;
          return;
        }
        cancelAnimationFrame(p), p = requestAnimationFrame(a);
      }, x = ou(m.renderedItems), h = new IntersectionObserver(g, { root: x });
      return m.renderedItems.forEach((b) => {
        b.element && h.observe(b.element);
      }), () => {
        cancelAnimationFrame(p), h.disconnect();
      };
    },
    ["renderedItems"]
  ));
  const c = (m, d, p = !1) => {
    let g;
    return d((h) => {
      const b = h.findIndex(({ id: w }) => w === m.id), S = h.slice();
      if (b !== -1) {
        g = h[b];
        const w = Y(Y({}, g), m);
        S[b] = w, o.set(m.id, w);
      } else
        S.push(m), o.set(m.id, m);
      return S;
    }), () => {
      d((h) => {
        if (!g)
          return p && o.delete(m.id), h.filter(({ id: w }) => w !== m.id);
        const b = h.findIndex(({ id: w }) => w === m.id);
        if (b === -1)
          return h;
        const S = h.slice();
        return S[b] = g, o.set(m.id, g), S;
      });
    };
  }, u = (m) => c(m, (d) => l.setState("items", d), !0);
  return le(Y({}, l), {
    registerItem: u,
    renderItem: (m) => Ze(
      u(m),
      c(
        m,
        (d) => s.setState("renderedItems", d)
      )
    ),
    item: (m) => {
      if (!m)
        return null;
      let d = o.get(m);
      if (!d) {
        const { items: p } = l.getState();
        d = p.find((g) => g.id === m), d && o.set(m, d);
      }
      return d || null;
    }
  });
}
function Pi(e) {
  return {};
}
function Li(e, t) {
  return ge(e, t, "items", "setItems"), e;
}
function iu(e) {
  return Array.isArray(e) ? e : typeof e < "u" ? [e] : [];
}
function qn(e) {
  const t = [];
  for (const n of e)
    t.push(...n);
  return t;
}
function Bt(e) {
  return e.slice().reverse();
}
var su = { id: null };
function We(e, t) {
  return e.find((n) => t ? !n.disabled && n.id !== t : !n.disabled);
}
function au(e, t) {
  return e.filter((n) => t ? !n.disabled && n.id !== t : !n.disabled);
}
function lu(e) {
  if (e === "vertical")
    return "horizontal";
  if (e === "horizontal")
    return "vertical";
}
function ho(e, t) {
  return e.filter((n) => n.rowId === t);
}
function uu(e, t, n = !1) {
  const r = e.findIndex((o) => o.id === t);
  return [
    ...e.slice(r + 1),
    ...n ? [su] : [],
    ...e.slice(0, r)
  ];
}
function Gn(e) {
  const t = [];
  for (const n of e) {
    const r = t.find((o) => {
      var i;
      return ((i = o[0]) == null ? void 0 : i.rowId) === n.rowId;
    });
    r ? r.push(n) : t.push([n]);
  }
  return t;
}
function ji(e) {
  let t = 0;
  for (const { length: n } of e)
    n > t && (t = n);
  return t;
}
function cu(e) {
  return {
    id: "__EMPTY_ITEM__",
    disabled: !0,
    rowId: e
  };
}
function bo(e, t, n) {
  const r = ji(e);
  for (const o of e)
    for (let i = 0; i < r; i += 1) {
      const s = o[i];
      if (!s || n && s.disabled) {
        const a = i === 0 && n ? We(o) : o[i - 1];
        o[i] = a && t !== a.id && n ? a : cu(a == null ? void 0 : a.rowId);
      }
    }
  return e;
}
function xo(e) {
  const t = Gn(e), n = ji(t), r = [];
  for (let o = 0; o < n; o += 1)
    for (const i of t) {
      const s = i[o];
      s && r.push(le(Y({}, s), {
        // If there's no rowId, it means that it's not a grid composite, but
        // a single row instead. So, instead of verticalizing it, that is,
        // assigning a different rowId based on the column index, we keep it
        // undefined so they will be part of the same row. This is useful
        // when using up/down on one-dimensional composites.
        rowId: s.rowId ? `${o}` : void 0
      }));
    }
  return r;
}
function Ri(e = {}) {
  var t;
  const n = (t = e.store) == null ? void 0 : t.getState(), r = hr(e), o = W(
    e.activeId,
    n == null ? void 0 : n.activeId,
    e.defaultActiveId
  ), i = le(Y({}, r.getState()), {
    activeId: o,
    baseElement: W(n == null ? void 0 : n.baseElement, null),
    includesBaseElement: W(
      e.includesBaseElement,
      n == null ? void 0 : n.includesBaseElement,
      o === null
    ),
    moves: W(n == null ? void 0 : n.moves, 0),
    orientation: W(
      e.orientation,
      n == null ? void 0 : n.orientation,
      "both"
    ),
    rtl: W(e.rtl, n == null ? void 0 : n.rtl, !1),
    virtualFocus: W(
      e.virtualFocus,
      n == null ? void 0 : n.virtualFocus,
      !1
    ),
    focusLoop: W(e.focusLoop, n == null ? void 0 : n.focusLoop, !1),
    focusWrap: W(e.focusWrap, n == null ? void 0 : n.focusWrap, !1),
    focusShift: W(e.focusShift, n == null ? void 0 : n.focusShift, !1)
  }), s = Fe(i, r, e.store);
  s.setup(
    () => s.sync(
      (a) => {
        s.setState("activeId", (c) => {
          var u;
          return c !== void 0 ? c : (u = We(a.renderedItems)) == null ? void 0 : u.id;
        });
      },
      ["renderedItems", "activeId"]
    )
  );
  const l = (a, c, u, m) => {
    var d, p;
    const { activeId: g, rtl: x, focusLoop: h, focusWrap: b, includesBaseElement: S } = s.getState(), y = x && c !== "vertical" ? Bt(a) : a;
    if (g == null)
      return (d = We(y)) == null ? void 0 : d.id;
    const I = y.find((T) => T.id === g);
    if (!I)
      return (p = We(y)) == null ? void 0 : p.id;
    const O = !!I.rowId, _ = y.indexOf(I), C = y.slice(_ + 1), N = ho(C, I.rowId);
    if (m !== void 0) {
      const T = au(N, g), j = T.slice(m)[0] || // If we can't find an item, just return the last one.
      T[T.length - 1];
      return j == null ? void 0 : j.id;
    }
    const R = lu(
      // If it's a grid and orientation is not set, it's a next/previous call,
      // which is inherently horizontal. up/down will call next with orientation
      // set to vertical by default (see below on up/down methods).
      O ? c || "horizontal" : c
    ), V = h && h !== R, M = O && b && b !== R;
    if (u = u || !O && V && S, V) {
      const T = M && !u ? y : ho(y, I.rowId), j = uu(T, g, u), B = We(j, g);
      return B == null ? void 0 : B.id;
    }
    if (M) {
      const T = We(
        // We can use nextItems, which contains all the next items, including
        // items from other rows, to wrap between rows. However, if there is a
        // null item (the composite container), we'll only use the next items in
        // the row. So moving next from the last item will focus on the
        // composite container. On grid composites, horizontal navigation never
        // focuses on the composite container, only vertical.
        u ? N : C,
        g
      );
      return u ? (T == null ? void 0 : T.id) || null : T == null ? void 0 : T.id;
    }
    const L = We(N, g);
    return !L && u ? null : L == null ? void 0 : L.id;
  };
  return le(Y(Y({}, r), s), {
    setBaseElement: (a) => s.setState("baseElement", a),
    setActiveId: (a) => s.setState("activeId", a),
    move: (a) => {
      a !== void 0 && (s.setState("activeId", a), s.setState("moves", (c) => c + 1));
    },
    first: () => {
      var a;
      return (a = We(s.getState().renderedItems)) == null ? void 0 : a.id;
    },
    last: () => {
      var a;
      return (a = We(Bt(s.getState().renderedItems))) == null ? void 0 : a.id;
    },
    next: (a) => {
      const { renderedItems: c, orientation: u } = s.getState();
      return l(c, u, !1, a);
    },
    previous: (a) => {
      var c;
      const { renderedItems: u, orientation: m, includesBaseElement: d } = s.getState(), g = !!!((c = We(u)) != null && c.rowId) && d;
      return l(
        Bt(u),
        m,
        g,
        a
      );
    },
    down: (a) => {
      const {
        activeId: c,
        renderedItems: u,
        focusShift: m,
        focusLoop: d,
        includesBaseElement: p
      } = s.getState(), g = m && !a, x = xo(
        qn(
          bo(Gn(u), c, g)
        )
      );
      return l(x, "vertical", d && d !== "horizontal" && p, a);
    },
    up: (a) => {
      const { activeId: c, renderedItems: u, focusShift: m, includesBaseElement: d } = s.getState(), p = m && !a, g = xo(
        Bt(
          qn(
            bo(
              Gn(u),
              c,
              p
            )
          )
        )
      );
      return l(g, "vertical", d, a);
    }
  });
}
function Ni(e) {
  return Pi();
}
function Di(e, t) {
  return e = Li(e, t), ge(e, t, "activeId", "setActiveId"), ge(e, t, "includesBaseElement"), ge(e, t, "virtualFocus"), ge(e, t, "orientation"), ge(e, t, "rtl"), ge(e, t, "focusLoop"), ge(e, t, "focusWrap"), ge(e, t, "focusShift"), e;
}
var rt = "";
function kn() {
  rt = "";
}
function du(e) {
  const t = e.target;
  return t && Zt(t) ? !1 : e.key === " " && rt.length ? !0 : e.key.length === 1 && !e.ctrlKey && !e.altKey && !e.metaKey && /^[\p{Letter}\p{Number}]$/u.test(e.key);
}
function fu(e, t) {
  if (Ae(e))
    return !0;
  const n = e.target;
  return n ? t.some((o) => o.element === n) : !1;
}
function mu(e) {
  return e.filter((t) => !t.disabled);
}
function rn(e, t) {
  var n;
  const r = ((n = e.element) == null ? void 0 : n.textContent) || e.children;
  return r ? qs(r).trim().toLowerCase().startsWith(t.toLowerCase()) : !1;
}
function vu(e, t, n) {
  if (!n)
    return e;
  const r = e.find((o) => o.id === n);
  return !r || !rn(r, t) || rt !== t && rn(r, rt) ? e : (rt = t, Kl(
    e.filter((o) => rn(o, rt)),
    n
  ).filter((o) => o.id !== n));
}
var br = U(
  (e) => {
    var t = e, { store: n, typeahead: r = !0 } = t, o = Z(t, ["store", "typeahead"]);
    const i = ie(Sn);
    n = n || i, Ke(
      n,
      process.env.NODE_ENV !== "production" && "CompositeTypeahead must be a Composite component"
    );
    const s = o.onKeyDownCapture, l = Q(0), a = K(
      (c) => {
        if (s == null || s(c), c.defaultPrevented || !r || !n)
          return;
        const { items: u, activeId: m } = n.getState();
        if (!du(c))
          return kn();
        let d = mu(u);
        if (!fu(c, d))
          return kn();
        c.preventDefault(), window.clearTimeout(l.current), l.current = window.setTimeout(() => {
          rt = "";
        }, 500);
        const p = c.key.toLowerCase();
        rt += p, d = vu(d, p, m);
        const g = d.find(
          (x) => rn(x, rt)
        );
        g ? n.move(g.id) : kn();
      }
    );
    return o = F(E({}, o), {
      onKeyDownCapture: a
    }), o;
  }
), pu = J(
  (e) => {
    const t = br(e);
    return z("div", t);
  }
);
process.env.NODE_ENV !== "production" && (pu.displayName = "CompositeTypeahead");
function Ti(e) {
  return e.some((t) => !!t.rowId);
}
function gu(e) {
  return e.key.length === 1 && !e.ctrlKey && !e.metaKey;
}
function hu(e) {
  return e.key === "Shift" || e.key === "Control" || e.key === "Alt" || e.key === "Meta";
}
function bu(e, t) {
  if (!Ae(e) || hu(e))
    return !1;
  const n = e.target;
  if (!n)
    return !0;
  if (Zt(n)) {
    if (gu(e))
      return !1;
    const r = Ti(t.renderedItems), o = t.activeId === null, i = r && !o, s = e.key === "Home" || e.key === "End";
    if (!i && s)
      return !1;
  }
  return !e.isPropagationStopped();
}
function So(e, t, n) {
  return K((r) => {
    var o;
    if (t == null || t(r), r.defaultPrevented)
      return;
    const i = e.getState(), s = (o = ct(e, i.activeId)) == null ? void 0 : o.element;
    if (!s || !bu(r, i))
      return;
    const l = r, a = Z(l, ["view"]), c = n == null ? void 0 : n.current;
    s !== c && s.focus(), da(s, r.type, a) || r.preventDefault(), r.currentTarget.contains(s) && r.stopPropagation();
  });
}
function xu(e) {
  return Wl(
    qn(Bt(zl(e)))
  );
}
function Su(e) {
  const [t, n] = ne(!1), r = be(() => n(!0), []), o = e.useState(
    (i) => ct(e, i.activeId)
  );
  return q(() => {
    const i = o == null ? void 0 : o.element;
    t && i && (n(!1), i.focus({ preventScroll: !0 }));
  }, [o, t]), r;
}
var xr = U(
  (e) => {
    var t = e, {
      store: n,
      composite: r = !0,
      focusOnMove: o = r,
      moveOnKeyPress: i = !0
    } = t, s = Z(t, [
      "store",
      "composite",
      "focusOnMove",
      "moveOnKeyPress"
    ]);
    const l = Q(null), a = Su(n), c = n.useState("moves");
    q(() => {
      var C;
      if (!c || !r || !o)
        return;
      const { activeId: N } = n.getState(), R = (C = ct(n, N)) == null ? void 0 : C.element;
      R && Ma(R);
    }, [c, r, o]), ue(() => {
      if (!r || !c)
        return;
      const { baseElement: C, activeId: N } = n.getState();
      if (!(N === null) || !C)
        return;
      const V = l.current;
      l.current = null, V && kt(V, { relatedTarget: C }), un(C) ? ca(C, { relatedTarget: V }) : C.focus();
    }, [c, r]);
    const u = n.useState("activeId"), m = n.useState("virtualFocus");
    ue(() => {
      var C;
      if (!r || !m)
        return;
      const N = l.current;
      if (l.current = null, !N)
        return;
      const V = ((C = ct(n, u)) == null ? void 0 : C.element) || st(N);
      kt(N, { relatedTarget: V });
    }, [u, m, r]);
    const d = So(
      n,
      s.onKeyDownCapture,
      l
    ), p = So(
      n,
      s.onKeyUpCapture,
      l
    ), g = s.onFocusCapture, x = K((C) => {
      if (g == null || g(C), C.defaultPrevented)
        return;
      const { virtualFocus: N } = n.getState();
      if (!N)
        return;
      const R = C.relatedTarget, V = Ul(C.currentTarget);
      Ae(C) && V && (C.stopPropagation(), l.current = R);
    }), h = s.onFocus, b = K((C) => {
      if (h == null || h(C), C.defaultPrevented || !r)
        return;
      const { relatedTarget: N } = C, { virtualFocus: R } = n.getState();
      R ? Ae(C) && !$t(n, N) && queueMicrotask(a) : Ae(C) && n.setActiveId(null);
    }), S = s.onBlurCapture, w = K((C) => {
      var N;
      if (S == null || S(C), C.defaultPrevented)
        return;
      const { virtualFocus: R, activeId: V } = n.getState();
      if (!R)
        return;
      const M = (N = ct(n, V)) == null ? void 0 : N.element, L = C.relatedTarget, T = $t(n, L), j = l.current;
      l.current = null, Ae(C) && T ? (L === M ? j && j !== L && kt(j, C) : M && kt(M, C), C.stopPropagation()) : !$t(n, C.target) && M && kt(M, C);
    }), A = s.onKeyDown, y = ye(i), I = K((C) => {
      var N;
      if (A == null || A(C), C.defaultPrevented || !Ae(C))
        return;
      const { orientation: R, items: V, renderedItems: M, activeId: L } = n.getState(), T = ct(n, L);
      if ((N = T == null ? void 0 : T.element) != null && N.isConnected)
        return;
      const j = R !== "horizontal", B = R !== "vertical", de = Ti(M), ee = {
        ArrowUp: (de || j) && (() => {
          if (de) {
            const se = V && xu(V);
            return se == null ? void 0 : se.id;
          }
          return n.last();
        }),
        ArrowRight: (de || B) && n.first,
        ArrowDown: (de || j) && n.first,
        ArrowLeft: (de || B) && n.last,
        Home: n.first,
        End: n.last,
        PageUp: n.first,
        PageDown: n.last
      }[C.key];
      if (ee) {
        const se = ee();
        if (se !== void 0) {
          if (!y(C))
            return;
          C.preventDefault(), n.move(se);
        }
      }
    });
    s = he(
      s,
      (C) => /* @__PURE__ */ f.jsx(Sn.Provider, { value: n, children: C }),
      [n]
    );
    const O = n.useState(
      (C) => {
        var N;
        return r && C.virtualFocus ? (N = ct(n, C.activeId)) == null ? void 0 : N.id : void 0;
      }
    );
    s = F(E({
      "aria-activedescendant": O
    }, s), {
      ref: ce(r ? n.setBaseElement : null, s.ref),
      onKeyDownCapture: d,
      onKeyUpCapture: p,
      onFocusCapture: x,
      onFocus: b,
      onBlurCapture: w,
      onKeyDown: I
    });
    const _ = n.useState(
      (C) => r && (C.virtualFocus || C.activeId === null)
    );
    return s = Lt(E({ focusable: _ }, s)), s;
  }
), Cu = J((e) => {
  const t = xr(e);
  return z("div", t);
});
process.env.NODE_ENV !== "production" && (Cu.displayName = "Composite");
var Sr = pe(
  void 0
);
const mt = Math.min, je = Math.max, dn = Math.round, Jt = Math.floor, vt = (e) => ({
  x: e,
  y: e
}), Eu = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, yu = {
  start: "end",
  end: "start"
};
function Yn(e, t, n) {
  return je(e, mt(t, n));
}
function Rt(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function pt(e) {
  return e.split("-")[0];
}
function Nt(e) {
  return e.split("-")[1];
}
function Fi(e) {
  return e === "x" ? "y" : "x";
}
function Cr(e) {
  return e === "y" ? "height" : "width";
}
function qt(e) {
  return ["top", "bottom"].includes(pt(e)) ? "y" : "x";
}
function Er(e) {
  return Fi(qt(e));
}
function wu(e, t, n) {
  n === void 0 && (n = !1);
  const r = Nt(e), o = Er(e), i = Cr(o);
  let s = o === "x" ? r === (n ? "end" : "start") ? "right" : "left" : r === "start" ? "bottom" : "top";
  return t.reference[i] > t.floating[i] && (s = fn(s)), [s, fn(s)];
}
function _u(e) {
  const t = fn(e);
  return [Xn(e), t, Xn(t)];
}
function Xn(e) {
  return e.replace(/start|end/g, (t) => yu[t]);
}
function Ou(e, t, n) {
  const r = ["left", "right"], o = ["right", "left"], i = ["top", "bottom"], s = ["bottom", "top"];
  switch (e) {
    case "top":
    case "bottom":
      return n ? t ? o : r : t ? r : o;
    case "left":
    case "right":
      return t ? i : s;
    default:
      return [];
  }
}
function Iu(e, t, n, r) {
  const o = Nt(e);
  let i = Ou(pt(e), n === "start", r);
  return o && (i = i.map((s) => s + "-" + o), t && (i = i.concat(i.map(Xn)))), i;
}
function fn(e) {
  return e.replace(/left|right|bottom|top/g, (t) => Eu[t]);
}
function Au(e) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...e
  };
}
function Mi(e) {
  return typeof e != "number" ? Au(e) : {
    top: e,
    right: e,
    bottom: e,
    left: e
  };
}
function mn(e) {
  return {
    ...e,
    top: e.y,
    left: e.x,
    right: e.x + e.width,
    bottom: e.y + e.height
  };
}
function Co(e, t, n) {
  let {
    reference: r,
    floating: o
  } = e;
  const i = qt(t), s = Er(t), l = Cr(s), a = pt(t), c = i === "y", u = r.x + r.width / 2 - o.width / 2, m = r.y + r.height / 2 - o.height / 2, d = r[l] / 2 - o[l] / 2;
  let p;
  switch (a) {
    case "top":
      p = {
        x: u,
        y: r.y - o.height
      };
      break;
    case "bottom":
      p = {
        x: u,
        y: r.y + r.height
      };
      break;
    case "right":
      p = {
        x: r.x + r.width,
        y: m
      };
      break;
    case "left":
      p = {
        x: r.x - o.width,
        y: m
      };
      break;
    default:
      p = {
        x: r.x,
        y: r.y
      };
  }
  switch (Nt(t)) {
    case "start":
      p[s] -= d * (n && c ? -1 : 1);
      break;
    case "end":
      p[s] += d * (n && c ? -1 : 1);
      break;
  }
  return p;
}
const Pu = async (e, t, n) => {
  const {
    placement: r = "bottom",
    strategy: o = "absolute",
    middleware: i = [],
    platform: s
  } = n, l = i.filter(Boolean), a = await (s.isRTL == null ? void 0 : s.isRTL(t));
  let c = await s.getElementRects({
    reference: e,
    floating: t,
    strategy: o
  }), {
    x: u,
    y: m
  } = Co(c, r, a), d = r, p = {}, g = 0;
  for (let x = 0; x < l.length; x++) {
    const {
      name: h,
      fn: b
    } = l[x], {
      x: S,
      y: w,
      data: A,
      reset: y
    } = await b({
      x: u,
      y: m,
      initialPlacement: r,
      placement: d,
      strategy: o,
      middlewareData: p,
      rects: c,
      platform: s,
      elements: {
        reference: e,
        floating: t
      }
    });
    if (u = S ?? u, m = w ?? m, p = {
      ...p,
      [h]: {
        ...p[h],
        ...A
      }
    }, y && g <= 50) {
      g++, typeof y == "object" && (y.placement && (d = y.placement), y.rects && (c = y.rects === !0 ? await s.getElementRects({
        reference: e,
        floating: t,
        strategy: o
      }) : y.rects), {
        x: u,
        y: m
      } = Co(c, d, a)), x = -1;
      continue;
    }
  }
  return {
    x: u,
    y: m,
    placement: d,
    strategy: o,
    middlewareData: p
  };
};
async function yr(e, t) {
  var n;
  t === void 0 && (t = {});
  const {
    x: r,
    y: o,
    platform: i,
    rects: s,
    elements: l,
    strategy: a
  } = e, {
    boundary: c = "clippingAncestors",
    rootBoundary: u = "viewport",
    elementContext: m = "floating",
    altBoundary: d = !1,
    padding: p = 0
  } = Rt(t, e), g = Mi(p), h = l[d ? m === "floating" ? "reference" : "floating" : m], b = mn(await i.getClippingRect({
    element: (n = await (i.isElement == null ? void 0 : i.isElement(h))) == null || n ? h : h.contextElement || await (i.getDocumentElement == null ? void 0 : i.getDocumentElement(l.floating)),
    boundary: c,
    rootBoundary: u,
    strategy: a
  })), S = m === "floating" ? {
    ...s.floating,
    x: r,
    y: o
  } : s.reference, w = await (i.getOffsetParent == null ? void 0 : i.getOffsetParent(l.floating)), A = await (i.isElement == null ? void 0 : i.isElement(w)) ? await (i.getScale == null ? void 0 : i.getScale(w)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, y = mn(i.convertOffsetParentRelativeRectToViewportRelativeRect ? await i.convertOffsetParentRelativeRectToViewportRelativeRect({
    rect: S,
    offsetParent: w,
    strategy: a
  }) : S);
  return {
    top: (b.top - y.top + g.top) / A.y,
    bottom: (y.bottom - b.bottom + g.bottom) / A.y,
    left: (b.left - y.left + g.left) / A.x,
    right: (y.right - b.right + g.right) / A.x
  };
}
const Lu = (e) => ({
  name: "arrow",
  options: e,
  async fn(t) {
    const {
      x: n,
      y: r,
      placement: o,
      rects: i,
      platform: s,
      elements: l
    } = t, {
      element: a,
      padding: c = 0
    } = Rt(e, t) || {};
    if (a == null)
      return {};
    const u = Mi(c), m = {
      x: n,
      y: r
    }, d = Er(o), p = Cr(d), g = await s.getDimensions(a), x = d === "y", h = x ? "top" : "left", b = x ? "bottom" : "right", S = x ? "clientHeight" : "clientWidth", w = i.reference[p] + i.reference[d] - m[d] - i.floating[p], A = m[d] - i.reference[d], y = await (s.getOffsetParent == null ? void 0 : s.getOffsetParent(a));
    let I = y ? y[S] : 0;
    (!I || !await (s.isElement == null ? void 0 : s.isElement(y))) && (I = l.floating[S] || i.floating[p]);
    const O = w / 2 - A / 2, _ = I / 2 - g[p] / 2 - 1, C = mt(u[h], _), N = mt(u[b], _), R = C, V = I - g[p] - N, M = I / 2 - g[p] / 2 + O, L = Yn(R, M, V), j = Nt(o) != null && M != L && i.reference[p] / 2 - (M < R ? C : N) - g[p] / 2 < 0 ? M < R ? R - M : V - M : 0;
    return {
      [d]: m[d] - j,
      data: {
        [d]: L,
        centerOffset: M - L + j
      }
    };
  }
}), ju = function(e) {
  return e === void 0 && (e = {}), {
    name: "flip",
    options: e,
    async fn(t) {
      var n;
      const {
        placement: r,
        middlewareData: o,
        rects: i,
        initialPlacement: s,
        platform: l,
        elements: a
      } = t, {
        mainAxis: c = !0,
        crossAxis: u = !0,
        fallbackPlacements: m,
        fallbackStrategy: d = "bestFit",
        fallbackAxisSideDirection: p = "none",
        flipAlignment: g = !0,
        ...x
      } = Rt(e, t), h = pt(r), b = pt(s) === s, S = await (l.isRTL == null ? void 0 : l.isRTL(a.floating)), w = m || (b || !g ? [fn(s)] : _u(s));
      !m && p !== "none" && w.push(...Iu(s, g, p, S));
      const A = [s, ...w], y = await yr(t, x), I = [];
      let O = ((n = o.flip) == null ? void 0 : n.overflows) || [];
      if (c && I.push(y[h]), u) {
        const R = wu(r, i, S);
        I.push(y[R[0]], y[R[1]]);
      }
      if (O = [...O, {
        placement: r,
        overflows: I
      }], !I.every((R) => R <= 0)) {
        var _, C;
        const R = (((_ = o.flip) == null ? void 0 : _.index) || 0) + 1, V = A[R];
        if (V)
          return {
            data: {
              index: R,
              overflows: O
            },
            reset: {
              placement: V
            }
          };
        let M = (C = O.filter((L) => L.overflows[0] <= 0).sort((L, T) => L.overflows[1] - T.overflows[1])[0]) == null ? void 0 : C.placement;
        if (!M)
          switch (d) {
            case "bestFit": {
              var N;
              const L = (N = O.map((T) => [T.placement, T.overflows.filter((j) => j > 0).reduce((j, B) => j + B, 0)]).sort((T, j) => T[1] - j[1])[0]) == null ? void 0 : N[0];
              L && (M = L);
              break;
            }
            case "initialPlacement":
              M = s;
              break;
          }
        if (r !== M)
          return {
            reset: {
              placement: M
            }
          };
      }
      return {};
    }
  };
};
async function Ru(e, t) {
  const {
    placement: n,
    platform: r,
    elements: o
  } = e, i = await (r.isRTL == null ? void 0 : r.isRTL(o.floating)), s = pt(n), l = Nt(n), a = qt(n) === "y", c = ["left", "top"].includes(s) ? -1 : 1, u = i && a ? -1 : 1, m = Rt(t, e);
  let {
    mainAxis: d,
    crossAxis: p,
    alignmentAxis: g
  } = typeof m == "number" ? {
    mainAxis: m,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: 0,
    crossAxis: 0,
    alignmentAxis: null,
    ...m
  };
  return l && typeof g == "number" && (p = l === "end" ? g * -1 : g), a ? {
    x: p * u,
    y: d * c
  } : {
    x: d * c,
    y: p * u
  };
}
const Nu = function(e) {
  return e === void 0 && (e = 0), {
    name: "offset",
    options: e,
    async fn(t) {
      const {
        x: n,
        y: r
      } = t, o = await Ru(t, e);
      return {
        x: n + o.x,
        y: r + o.y,
        data: o
      };
    }
  };
}, Du = function(e) {
  return e === void 0 && (e = {}), {
    name: "shift",
    options: e,
    async fn(t) {
      const {
        x: n,
        y: r,
        placement: o
      } = t, {
        mainAxis: i = !0,
        crossAxis: s = !1,
        limiter: l = {
          fn: (h) => {
            let {
              x: b,
              y: S
            } = h;
            return {
              x: b,
              y: S
            };
          }
        },
        ...a
      } = Rt(e, t), c = {
        x: n,
        y: r
      }, u = await yr(t, a), m = qt(pt(o)), d = Fi(m);
      let p = c[d], g = c[m];
      if (i) {
        const h = d === "y" ? "top" : "left", b = d === "y" ? "bottom" : "right", S = p + u[h], w = p - u[b];
        p = Yn(S, p, w);
      }
      if (s) {
        const h = m === "y" ? "top" : "left", b = m === "y" ? "bottom" : "right", S = g + u[h], w = g - u[b];
        g = Yn(S, g, w);
      }
      const x = l.fn({
        ...t,
        [d]: p,
        [m]: g
      });
      return {
        ...x,
        data: {
          x: x.x - n,
          y: x.y - r
        }
      };
    }
  };
}, Tu = function(e) {
  return e === void 0 && (e = {}), {
    name: "size",
    options: e,
    async fn(t) {
      const {
        placement: n,
        rects: r,
        platform: o,
        elements: i
      } = t, {
        apply: s = () => {
        },
        ...l
      } = Rt(e, t), a = await yr(t, l), c = pt(n), u = Nt(n), m = qt(n) === "y", {
        width: d,
        height: p
      } = r.floating;
      let g, x;
      c === "top" || c === "bottom" ? (g = c, x = u === (await (o.isRTL == null ? void 0 : o.isRTL(i.floating)) ? "start" : "end") ? "left" : "right") : (x = c, g = u === "end" ? "top" : "bottom");
      const h = p - a[g], b = d - a[x], S = !t.middlewareData.shift;
      let w = h, A = b;
      if (m) {
        const I = d - a.left - a.right;
        A = u || S ? mt(b, I) : I;
      } else {
        const I = p - a.top - a.bottom;
        w = u || S ? mt(h, I) : I;
      }
      if (S && !u) {
        const I = je(a.left, 0), O = je(a.right, 0), _ = je(a.top, 0), C = je(a.bottom, 0);
        m ? A = d - 2 * (I !== 0 || O !== 0 ? I + O : je(a.left, a.right)) : w = p - 2 * (_ !== 0 || C !== 0 ? _ + C : je(a.top, a.bottom));
      }
      await s({
        ...t,
        availableWidth: A,
        availableHeight: w
      });
      const y = await o.getDimensions(i.floating);
      return d !== y.width || p !== y.height ? {
        reset: {
          rects: !0
        }
      } : {};
    }
  };
};
function gt(e) {
  return ki(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function Re(e) {
  var t;
  return (e == null || (t = e.ownerDocument) == null ? void 0 : t.defaultView) || window;
}
function lt(e) {
  var t;
  return (t = (ki(e) ? e.ownerDocument : e.document) || window.document) == null ? void 0 : t.documentElement;
}
function ki(e) {
  return e instanceof Node || e instanceof Re(e).Node;
}
function it(e) {
  return e instanceof Element || e instanceof Re(e).Element;
}
function Ue(e) {
  return e instanceof HTMLElement || e instanceof Re(e).HTMLElement;
}
function Eo(e) {
  return typeof ShadowRoot > "u" ? !1 : e instanceof ShadowRoot || e instanceof Re(e).ShadowRoot;
}
function Gt(e) {
  const {
    overflow: t,
    overflowX: n,
    overflowY: r,
    display: o
  } = Me(e);
  return /auto|scroll|overlay|hidden|clip/.test(t + r + n) && !["inline", "contents"].includes(o);
}
function Fu(e) {
  return ["table", "td", "th"].includes(gt(e));
}
function wr(e) {
  const t = _r(), n = Me(e);
  return n.transform !== "none" || n.perspective !== "none" || (n.containerType ? n.containerType !== "normal" : !1) || !t && (n.backdropFilter ? n.backdropFilter !== "none" : !1) || !t && (n.filter ? n.filter !== "none" : !1) || ["transform", "perspective", "filter"].some((r) => (n.willChange || "").includes(r)) || ["paint", "layout", "strict", "content"].some((r) => (n.contain || "").includes(r));
}
function Mu(e) {
  let t = At(e);
  for (; Ue(t) && !Cn(t); ) {
    if (wr(t))
      return t;
    t = At(t);
  }
  return null;
}
function _r() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
function Cn(e) {
  return ["html", "body", "#document"].includes(gt(e));
}
function Me(e) {
  return Re(e).getComputedStyle(e);
}
function En(e) {
  return it(e) ? {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  } : {
    scrollLeft: e.pageXOffset,
    scrollTop: e.pageYOffset
  };
}
function At(e) {
  if (gt(e) === "html")
    return e;
  const t = (
    // Step into the shadow DOM of the parent of a slotted node.
    e.assignedSlot || // DOM Element detected.
    e.parentNode || // ShadowRoot detected.
    Eo(e) && e.host || // Fallback.
    lt(e)
  );
  return Eo(t) ? t.host : t;
}
function Vi(e) {
  const t = At(e);
  return Cn(t) ? e.ownerDocument ? e.ownerDocument.body : e.body : Ue(t) && Gt(t) ? t : Vi(t);
}
function vn(e, t) {
  var n;
  t === void 0 && (t = []);
  const r = Vi(e), o = r === ((n = e.ownerDocument) == null ? void 0 : n.body), i = Re(r);
  return o ? t.concat(i, i.visualViewport || [], Gt(r) ? r : []) : t.concat(r, vn(r));
}
function Bi(e) {
  const t = Me(e);
  let n = parseFloat(t.width) || 0, r = parseFloat(t.height) || 0;
  const o = Ue(e), i = o ? e.offsetWidth : n, s = o ? e.offsetHeight : r, l = dn(n) !== i || dn(r) !== s;
  return l && (n = i, r = s), {
    width: n,
    height: r,
    $: l
  };
}
function Or(e) {
  return it(e) ? e : e.contextElement;
}
function _t(e) {
  const t = Or(e);
  if (!Ue(t))
    return vt(1);
  const n = t.getBoundingClientRect(), {
    width: r,
    height: o,
    $: i
  } = Bi(t);
  let s = (i ? dn(n.width) : n.width) / r, l = (i ? dn(n.height) : n.height) / o;
  return (!s || !Number.isFinite(s)) && (s = 1), (!l || !Number.isFinite(l)) && (l = 1), {
    x: s,
    y: l
  };
}
const ku = /* @__PURE__ */ vt(0);
function Hi(e) {
  const t = Re(e);
  return !_r() || !t.visualViewport ? ku : {
    x: t.visualViewport.offsetLeft,
    y: t.visualViewport.offsetTop
  };
}
function Vu(e, t, n) {
  return t === void 0 && (t = !1), !n || t && n !== Re(e) ? !1 : t;
}
function ht(e, t, n, r) {
  t === void 0 && (t = !1), n === void 0 && (n = !1);
  const o = e.getBoundingClientRect(), i = Or(e);
  let s = vt(1);
  t && (r ? it(r) && (s = _t(r)) : s = _t(e));
  const l = Vu(i, n, r) ? Hi(i) : vt(0);
  let a = (o.left + l.x) / s.x, c = (o.top + l.y) / s.y, u = o.width / s.x, m = o.height / s.y;
  if (i) {
    const d = Re(i), p = r && it(r) ? Re(r) : r;
    let g = d.frameElement;
    for (; g && r && p !== d; ) {
      const x = _t(g), h = g.getBoundingClientRect(), b = Me(g), S = h.left + (g.clientLeft + parseFloat(b.paddingLeft)) * x.x, w = h.top + (g.clientTop + parseFloat(b.paddingTop)) * x.y;
      a *= x.x, c *= x.y, u *= x.x, m *= x.y, a += S, c += w, g = Re(g).frameElement;
    }
  }
  return mn({
    width: u,
    height: m,
    x: a,
    y: c
  });
}
function Bu(e) {
  let {
    rect: t,
    offsetParent: n,
    strategy: r
  } = e;
  const o = Ue(n), i = lt(n);
  if (n === i)
    return t;
  let s = {
    scrollLeft: 0,
    scrollTop: 0
  }, l = vt(1);
  const a = vt(0);
  if ((o || !o && r !== "fixed") && ((gt(n) !== "body" || Gt(i)) && (s = En(n)), Ue(n))) {
    const c = ht(n);
    l = _t(n), a.x = c.x + n.clientLeft, a.y = c.y + n.clientTop;
  }
  return {
    width: t.width * l.x,
    height: t.height * l.y,
    x: t.x * l.x - s.scrollLeft * l.x + a.x,
    y: t.y * l.y - s.scrollTop * l.y + a.y
  };
}
function Hu(e) {
  return Array.from(e.getClientRects());
}
function $i(e) {
  return ht(lt(e)).left + En(e).scrollLeft;
}
function $u(e) {
  const t = lt(e), n = En(e), r = e.ownerDocument.body, o = je(t.scrollWidth, t.clientWidth, r.scrollWidth, r.clientWidth), i = je(t.scrollHeight, t.clientHeight, r.scrollHeight, r.clientHeight);
  let s = -n.scrollLeft + $i(e);
  const l = -n.scrollTop;
  return Me(r).direction === "rtl" && (s += je(t.clientWidth, r.clientWidth) - o), {
    width: o,
    height: i,
    x: s,
    y: l
  };
}
function Ku(e, t) {
  const n = Re(e), r = lt(e), o = n.visualViewport;
  let i = r.clientWidth, s = r.clientHeight, l = 0, a = 0;
  if (o) {
    i = o.width, s = o.height;
    const c = _r();
    (!c || c && t === "fixed") && (l = o.offsetLeft, a = o.offsetTop);
  }
  return {
    width: i,
    height: s,
    x: l,
    y: a
  };
}
function Wu(e, t) {
  const n = ht(e, !0, t === "fixed"), r = n.top + e.clientTop, o = n.left + e.clientLeft, i = Ue(e) ? _t(e) : vt(1), s = e.clientWidth * i.x, l = e.clientHeight * i.y, a = o * i.x, c = r * i.y;
  return {
    width: s,
    height: l,
    x: a,
    y: c
  };
}
function yo(e, t, n) {
  let r;
  if (t === "viewport")
    r = Ku(e, n);
  else if (t === "document")
    r = $u(lt(e));
  else if (it(t))
    r = Wu(t, n);
  else {
    const o = Hi(e);
    r = {
      ...t,
      x: t.x - o.x,
      y: t.y - o.y
    };
  }
  return mn(r);
}
function Ki(e, t) {
  const n = At(e);
  return n === t || !it(n) || Cn(n) ? !1 : Me(n).position === "fixed" || Ki(n, t);
}
function zu(e, t) {
  const n = t.get(e);
  if (n)
    return n;
  let r = vn(e).filter((l) => it(l) && gt(l) !== "body"), o = null;
  const i = Me(e).position === "fixed";
  let s = i ? At(e) : e;
  for (; it(s) && !Cn(s); ) {
    const l = Me(s), a = wr(s);
    !a && l.position === "fixed" && (o = null), (i ? !a && !o : !a && l.position === "static" && !!o && ["absolute", "fixed"].includes(o.position) || Gt(s) && !a && Ki(e, s)) ? r = r.filter((u) => u !== s) : o = l, s = At(s);
  }
  return t.set(e, r), r;
}
function Zu(e) {
  let {
    element: t,
    boundary: n,
    rootBoundary: r,
    strategy: o
  } = e;
  const s = [...n === "clippingAncestors" ? zu(t, this._c) : [].concat(n), r], l = s[0], a = s.reduce((c, u) => {
    const m = yo(t, u, o);
    return c.top = je(m.top, c.top), c.right = mt(m.right, c.right), c.bottom = mt(m.bottom, c.bottom), c.left = je(m.left, c.left), c;
  }, yo(t, l, o));
  return {
    width: a.right - a.left,
    height: a.bottom - a.top,
    x: a.left,
    y: a.top
  };
}
function Uu(e) {
  return Bi(e);
}
function qu(e, t, n) {
  const r = Ue(t), o = lt(t), i = n === "fixed", s = ht(e, !0, i, t);
  let l = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const a = vt(0);
  if (r || !r && !i)
    if ((gt(t) !== "body" || Gt(o)) && (l = En(t)), r) {
      const c = ht(t, !0, i, t);
      a.x = c.x + t.clientLeft, a.y = c.y + t.clientTop;
    } else
      o && (a.x = $i(o));
  return {
    x: s.left + l.scrollLeft - a.x,
    y: s.top + l.scrollTop - a.y,
    width: s.width,
    height: s.height
  };
}
function wo(e, t) {
  return !Ue(e) || Me(e).position === "fixed" ? null : t ? t(e) : e.offsetParent;
}
function Wi(e, t) {
  const n = Re(e);
  if (!Ue(e))
    return n;
  let r = wo(e, t);
  for (; r && Fu(r) && Me(r).position === "static"; )
    r = wo(r, t);
  return r && (gt(r) === "html" || gt(r) === "body" && Me(r).position === "static" && !wr(r)) ? n : r || Mu(e) || n;
}
const Gu = async function(e) {
  let {
    reference: t,
    floating: n,
    strategy: r
  } = e;
  const o = this.getOffsetParent || Wi, i = this.getDimensions;
  return {
    reference: qu(t, await o(n), r),
    floating: {
      x: 0,
      y: 0,
      ...await i(n)
    }
  };
};
function Yu(e) {
  return Me(e).direction === "rtl";
}
const Xu = {
  convertOffsetParentRelativeRectToViewportRelativeRect: Bu,
  getDocumentElement: lt,
  getClippingRect: Zu,
  getOffsetParent: Wi,
  getElementRects: Gu,
  getClientRects: Hu,
  getDimensions: Uu,
  getScale: _t,
  isElement: it,
  isRTL: Yu
};
function Ju(e, t) {
  let n = null, r;
  const o = lt(e);
  function i() {
    clearTimeout(r), n && n.disconnect(), n = null;
  }
  function s(l, a) {
    l === void 0 && (l = !1), a === void 0 && (a = 1), i();
    const {
      left: c,
      top: u,
      width: m,
      height: d
    } = e.getBoundingClientRect();
    if (l || t(), !m || !d)
      return;
    const p = Jt(u), g = Jt(o.clientWidth - (c + m)), x = Jt(o.clientHeight - (u + d)), h = Jt(c), S = {
      rootMargin: -p + "px " + -g + "px " + -x + "px " + -h + "px",
      threshold: je(0, mt(1, a)) || 1
    };
    let w = !0;
    function A(y) {
      const I = y[0].intersectionRatio;
      if (I !== a) {
        if (!w)
          return s();
        I ? s(!1, I) : r = setTimeout(() => {
          s(!1, 1e-7);
        }, 100);
      }
      w = !1;
    }
    try {
      n = new IntersectionObserver(A, {
        ...S,
        // Handle <iframe>s
        root: o.ownerDocument
      });
    } catch {
      n = new IntersectionObserver(A, S);
    }
    n.observe(e);
  }
  return s(!0), i;
}
function Qu(e, t, n, r) {
  r === void 0 && (r = {});
  const {
    ancestorScroll: o = !0,
    ancestorResize: i = !0,
    elementResize: s = typeof ResizeObserver == "function",
    layoutShift: l = typeof IntersectionObserver == "function",
    animationFrame: a = !1
  } = r, c = Or(e), u = o || i ? [...c ? vn(c) : [], ...vn(t)] : [];
  u.forEach((b) => {
    o && b.addEventListener("scroll", n, {
      passive: !0
    }), i && b.addEventListener("resize", n);
  });
  const m = c && l ? Ju(c, n) : null;
  let d = -1, p = null;
  s && (p = new ResizeObserver((b) => {
    let [S] = b;
    S && S.target === c && p && (p.unobserve(t), cancelAnimationFrame(d), d = requestAnimationFrame(() => {
      p && p.observe(t);
    })), n();
  }), c && !a && p.observe(c), p.observe(t));
  let g, x = a ? ht(e) : null;
  a && h();
  function h() {
    const b = ht(e);
    x && (b.x !== x.x || b.y !== x.y || b.width !== x.width || b.height !== x.height) && n(), x = b, g = requestAnimationFrame(h);
  }
  return n(), () => {
    u.forEach((b) => {
      o && b.removeEventListener("scroll", n), i && b.removeEventListener("resize", n);
    }), m && m(), p && p.disconnect(), p = null, a && cancelAnimationFrame(g);
  };
}
const ec = (e, t, n) => {
  const r = /* @__PURE__ */ new Map(), o = {
    platform: Xu,
    ...n
  }, i = {
    ...o.platform,
    _c: r
  };
  return Pu(e, t, {
    ...o,
    platform: i
  });
};
function _o(e = 0, t = 0, n = 0, r = 0) {
  if (typeof DOMRect == "function")
    return new DOMRect(e, t, n, r);
  const o = {
    x: e,
    y: t,
    width: n,
    height: r,
    top: t,
    right: e + n,
    bottom: t + r,
    left: e
  };
  return F(E({}, o), { toJSON: () => o });
}
function tc(e) {
  if (!e)
    return _o();
  const { x: t, y: n, width: r, height: o } = e;
  return _o(t, n, r, o);
}
function nc(e, t) {
  return {
    contextElement: e || void 0,
    getBoundingClientRect: () => {
      const r = e, o = t == null ? void 0 : t(r);
      return o || !r ? tc(o) : r.getBoundingClientRect();
    }
  };
}
function rc(e) {
  return /^(?:top|bottom|left|right)(?:-(?:start|end))?$/.test(e);
}
function Oo(e) {
  const t = window.devicePixelRatio || 1;
  return Math.round(e * t) / t;
}
function oc(e, t) {
  return Nu(({ placement: n }) => {
    var r;
    const o = ((e == null ? void 0 : e.clientHeight) || 0) / 2, i = typeof t.gutter == "number" ? t.gutter + o : (r = t.gutter) != null ? r : o;
    return {
      crossAxis: !!n.split("-")[1] ? void 0 : t.shift,
      mainAxis: i,
      alignmentAxis: t.shift
    };
  });
}
function ic(e) {
  if (e.flip === !1)
    return;
  const t = typeof e.flip == "string" ? e.flip.split(" ") : void 0;
  return Ke(
    !t || t.every(rc),
    process.env.NODE_ENV !== "production" && "`flip` expects a spaced-delimited list of placements"
  ), ju({
    padding: e.overflowPadding,
    fallbackPlacements: t
  });
}
function sc(e) {
  if (!(!e.slide && !e.overlap))
    return Du({
      mainAxis: e.slide,
      crossAxis: e.overlap,
      padding: e.overflowPadding
    });
}
function ac(e) {
  return Tu({
    padding: e.overflowPadding,
    apply({ elements: t, availableWidth: n, availableHeight: r, rects: o }) {
      const i = t.floating, s = Math.round(o.reference.width);
      n = Math.floor(n), r = Math.floor(r), i.style.setProperty(
        "--popover-anchor-width",
        `${s}px`
      ), i.style.setProperty(
        "--popover-available-width",
        `${n}px`
      ), i.style.setProperty(
        "--popover-available-height",
        `${r}px`
      ), e.sameWidth && (i.style.width = `${s}px`), e.fitViewport && (i.style.maxWidth = `${n}px`, i.style.maxHeight = `${r}px`);
    }
  });
}
function lc(e, t) {
  if (e)
    return Lu({
      element: e,
      padding: t.arrowPadding
    });
}
var zi = U(
  (e) => {
    var t = e, {
      store: n,
      modal: r = !1,
      portal: o = !!r,
      preserveTabOrder: i = !0,
      autoFocusOnShow: s = !0,
      wrapperProps: l,
      fixed: a = !1,
      flip: c = !0,
      shift: u = 0,
      slide: m = !0,
      overlap: d = !1,
      sameWidth: p = !1,
      fitViewport: g = !1,
      gutter: x,
      arrowPadding: h = 4,
      overflowPadding: b = 8,
      getAnchorRect: S,
      updatePosition: w
    } = t, A = Z(t, [
      "store",
      "modal",
      "portal",
      "preserveTabOrder",
      "autoFocusOnShow",
      "wrapperProps",
      "fixed",
      "flip",
      "shift",
      "slide",
      "overlap",
      "sameWidth",
      "fitViewport",
      "gutter",
      "arrowPadding",
      "overflowPadding",
      "getAnchorRect",
      "updatePosition"
    ]);
    const y = n.useState("arrowElement"), I = n.useState("anchorElement"), O = n.useState("popoverElement"), _ = n.useState("contentElement"), C = n.useState("placement"), N = n.useState("mounted"), R = n.useState("rendered"), [V, M] = ne(!1), { portalRef: L, domReady: T } = Xo(o, A.portalRef), j = K(S), B = K(w), de = !!w;
    ue(() => {
      if (!(O != null && O.isConnected))
        return;
      O.style.setProperty(
        "--popover-overflow-padding",
        `${b}px`
      );
      const k = nc(I, j), ee = async () => {
        if (!N)
          return;
        const _e = [
          oc(y, { gutter: x, shift: u }),
          ic({ flip: c, overflowPadding: b }),
          sc({ slide: m, overlap: d, overflowPadding: b }),
          lc(y, { arrowPadding: h }),
          ac({
            sameWidth: p,
            fitViewport: g,
            overflowPadding: b
          })
        ], Ce = await ec(k, O, {
          placement: C,
          strategy: a ? "fixed" : "absolute",
          middleware: _e
        });
        n.setState("currentPlacement", Ce.placement), M(!0);
        const Ie = Oo(Ce.x), Ge = Oo(Ce.y);
        if (Object.assign(O.style, {
          top: "0",
          left: "0",
          transform: `translate3d(${Ie}px,${Ge}px,0)`
        }), y && Ce.middlewareData.arrow) {
          const { x: Le, y: Ne } = Ce.middlewareData.arrow, Ye = Ce.placement.split("-")[0];
          Object.assign(y.style, {
            left: Le != null ? `${Le}px` : "",
            top: Ne != null ? `${Ne}px` : "",
            [Ye]: "100%"
          });
        }
      }, ae = Qu(k, O, async () => {
        de ? (await B({ updatePosition: ee }), M(!0)) : await ee();
      }, {
        // JSDOM doesn't support ResizeObserver
        elementResize: typeof ResizeObserver == "function"
      });
      return () => {
        M(!1), ae();
      };
    }, [
      n,
      R,
      O,
      y,
      I,
      O,
      C,
      N,
      T,
      a,
      c,
      u,
      m,
      d,
      p,
      g,
      x,
      h,
      b,
      j,
      de,
      B
    ]), ue(() => {
      if (!N || !T || !(O != null && O.isConnected) || !(_ != null && _.isConnected))
        return;
      const k = () => {
        O.style.zIndex = getComputedStyle(_).zIndex;
      };
      k();
      let ee = requestAnimationFrame(() => {
        ee = requestAnimationFrame(k);
      });
      return () => cancelAnimationFrame(ee);
    }, [N, T, O, _]);
    const Se = a ? "fixed" : "absolute";
    return A = he(
      A,
      (k) => /* @__PURE__ */ f.jsx(
        "div",
        F(E({
          role: "presentation"
        }, l), {
          style: E({
            // https://floating-ui.com/docs/computeposition#initial-layout
            position: Se,
            top: 0,
            left: 0,
            width: "max-content"
          }, l == null ? void 0 : l.style),
          ref: n.setPopoverElement,
          children: k
        })
      ),
      [n, Se, l]
    ), A = he(
      A,
      (k) => /* @__PURE__ */ f.jsx(Sr.Provider, { value: n, children: k }),
      [n]
    ), A = F(E({
      // data-placing is not part of the public API. We're setting this here so
      // we can wait for the popover to be positioned before other components
      // move focus into it. For example, this attribute is observed by the
      // Combobox component with the autoSelect behavior.
      "data-placing": V ? void 0 : ""
    }, A), {
      style: E({
        position: "relative"
      }, A.style)
    }), A = Ci(F(E({
      store: n,
      modal: r,
      preserveTabOrder: i,
      portal: o,
      autoFocusOnShow: V && s
    }, A), {
      portalRef: L
    })), A;
  }
), uc = J((e) => {
  const t = zi(e);
  return z("div", t);
});
process.env.NODE_ENV !== "production" && (uc.displayName = "Popover");
function cc(e = {}) {
  var t = e, {
    popover: n
  } = t, r = Wo(t, [
    "popover"
  ]);
  const o = ir(
    r.store,
    n == null ? void 0 : n.omit(
      "arrowElement",
      "anchorElement",
      "contentElement",
      "popoverElement",
      "disclosureElement"
    )
  ), i = o == null ? void 0 : o.getState(), s = yi(le(Y({}, r), { store: o })), l = W(
    r.placement,
    i == null ? void 0 : i.placement,
    "bottom"
  ), a = le(Y({}, s.getState()), {
    placement: l,
    currentPlacement: l,
    anchorElement: W(i == null ? void 0 : i.anchorElement, null),
    popoverElement: W(i == null ? void 0 : i.popoverElement, null),
    arrowElement: W(i == null ? void 0 : i.arrowElement, null),
    rendered: Symbol("rendered")
  }), c = Fe(a, s, o);
  return le(Y(Y({}, s), c), {
    setAnchorElement: (u) => c.setState("anchorElement", u),
    setPopoverElement: (u) => c.setState("popoverElement", u),
    setArrowElement: (u) => c.setState("arrowElement", u),
    render: () => c.setState("rendered", Symbol("rendered"))
  });
}
function dc(e) {
  return wi();
}
function fc(e, t) {
  return e = _i(e, t), ge(e, t, "placement"), e;
}
var Zi = U(
  (e) => {
    var t = e, { store: n } = t, r = Z(t, ["store"]);
    return r = F(E({}, r), {
      ref: ce(n.setAnchorElement, r.ref)
    }), r;
  }
), mc = J((e) => {
  const t = Zi(e);
  return z("div", t);
});
process.env.NODE_ENV !== "production" && (mc.displayName = "PopoverAnchor");
var vc = {
  top: "4,10 8,6 12,10",
  right: "6,4 10,8 6,12",
  bottom: "4,6 8,10 12,6",
  left: "10,4 6,8 10,12"
}, Ui = U(
  (e) => {
    var t = e, { store: n, placement: r } = t, o = Z(t, ["store", "placement"]);
    const i = ie(Sr);
    n = n || i, Ke(
      n,
      process.env.NODE_ENV !== "production" && "PopoverDisclosureArrow must be wrapped in a PopoverDisclosure component"
    );
    const l = n.useState((u) => r || u.placement).split("-")[0], a = vc[l], c = ke(
      () => /* @__PURE__ */ f.jsx(
        "svg",
        {
          display: "block",
          fill: "none",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "1.5pt",
          viewBox: "0 0 16 16",
          height: "1em",
          width: "1em",
          children: /* @__PURE__ */ f.jsx("polyline", { points: a })
        }
      ),
      [a]
    );
    return o = F(E({
      children: c,
      "aria-hidden": !0
    }, o), {
      style: E({
        width: "1em",
        height: "1em",
        pointerEvents: "none"
      }, o.style)
    }), o;
  }
), pc = J((e) => {
  const t = Ui(e);
  return z("span", t);
});
process.env.NODE_ENV !== "production" && (pc.displayName = "PopoverDisclosureArrow");
var qi = U(
  (e) => {
    var t = e, { store: n } = t, r = Z(t, ["store"]);
    const o = r.onClick, i = K((s) => {
      n.setAnchorElement(s.currentTarget), o == null || o(s);
    });
    return r = he(
      r,
      (s) => /* @__PURE__ */ f.jsx(Sr.Provider, { value: n, children: s }),
      [n]
    ), r = F(E({}, r), {
      onClick: i
    }), r = Zi(E({ store: n }, r)), r = di(E({ store: n }, r)), r;
  }
), gc = J(
  (e) => {
    const t = qi(e);
    return z("button", t);
  }
);
process.env.NODE_ENV !== "production" && (gc.displayName = "PopoverDisclosure");
var Dt = pe(void 0);
function hc(e, t) {
  const n = e.current;
  return n ? n.name === t ? n : n.form ? n.form.elements.namedItem(t) : we(n).getElementsByName(t)[0] : null;
}
function Vn(e, t, n) {
  return e.useState(
    (r) => r.items.find((o) => o.type === n && o.name === t)
  );
}
var Ir = U(
  (e) => {
    var t = e, {
      store: n,
      name: r,
      getItem: o,
      touchOnBlur: i = !0
    } = t, s = Z(t, [
      "store",
      "name",
      "getItem",
      "touchOnBlur"
    ]);
    const l = ie(Dt);
    n = n || l, Ke(
      n,
      process.env.NODE_ENV !== "production" && "FormField must be wrapped in a Form component"
    );
    const a = `${r}`, c = Ve(s.id), u = Q(null);
    n.useValidate(async () => {
      const A = hc(u, a);
      A && (await Promise.resolve(), "validity" in A && !A.validity.valid && (n == null || n.setError(a, A.validationMessage)));
    });
    const m = be(
      (A) => {
        const y = F(E({}, A), { id: c || A.id, name: a, type: "field" });
        return o ? o(y) : y;
      },
      [c, a, o]
    ), d = s.onBlur, p = ye(i), g = K((A) => {
      d == null || d(A), !A.defaultPrevented && p(A) && (n == null || n.setFieldTouched(a, !0));
    }), x = Vn(n, a, "label"), h = Vn(n, a, "error"), b = Vn(n, a, "description"), S = Us(
      h == null ? void 0 : h.id,
      b == null ? void 0 : b.id,
      s["aria-describedby"]
    ), w = n.useState(
      () => !!(n != null && n.getError(a)) && n.getFieldTouched(a)
    );
    return s = F(E({
      id: c,
      "aria-labelledby": x == null ? void 0 : x.id,
      "aria-invalid": w
    }, s), {
      "aria-describedby": S || void 0,
      ref: ce(u, s.ref),
      onBlur: g
    }), s = jt(F(E({ store: n }, s), { name: a, getItem: m })), s;
  }
), Gi = at((e) => {
  const t = Ir(e);
  return z("input", t);
});
process.env.NODE_ENV !== "production" && (Gi.displayName = "FormField");
var bc = U(
  (e) => {
    var t = e, { store: n, name: r, value: o, checked: i, defaultChecked: s } = t, l = Z(t, ["store", "name", "value", "checked", "defaultChecked"]);
    const a = ie(Dt);
    n = n || a, Ke(
      n,
      process.env.NODE_ENV !== "production" && "FormCheckbox must be wrapped in a Form component"
    );
    const c = `${r}`, u = Pa({
      value: n.useValue(c),
      setValue: (m) => n == null ? void 0 : n.setValue(c, m)
    });
    return l = ni(E({ store: u, value: o, checked: i }, l)), l = Ir(E({
      store: n,
      name: c,
      "aria-labelledby": void 0
    }, l)), l;
  }
), Yi = at(
  (e) => {
    const t = bc(e);
    return z("input", t);
  }
);
process.env.NODE_ENV !== "production" && (Yi.displayName = "FormCheckbox");
var xc = U(
  (e) => {
    var t = e, { store: n, name: r, getItem: o } = t, i = Z(t, ["store", "name", "getItem"]);
    const s = ie(Dt);
    n = n || s, Ke(
      n,
      process.env.NODE_ENV !== "production" && "FormError must be wrapped in a Form component"
    );
    const l = Ve(i.id), a = Q(null), c = `${r}`, u = be(
      (d) => {
        const p = F(E({}, d), { id: l || d.id, name: c, type: "error" });
        return o ? o(p) : p;
      },
      [l, c, o]
    ), m = n.useState(() => {
      const d = n == null ? void 0 : n.getError(c);
      if (d != null && n != null && n.getFieldTouched(c))
        return d;
    });
    return i = F(E({
      id: l,
      role: "alert",
      children: m
    }, i), {
      ref: ce(a, i.ref)
    }), i = jt(F(E({ store: n }, i), { getItem: u })), i;
  }
), Xi = at((e) => {
  const t = xc(e);
  return z("div", t);
});
process.env.NODE_ENV !== "production" && (Xi.displayName = "FormError");
var Sc = U(
  (e) => {
    var t = e, n = Z(t, ["store"]);
    return n = Oi(n), n;
  }
), Ji = J((e) => {
  const t = Sc(e);
  return z("div", t);
});
process.env.NODE_ENV !== "production" && (Ji.displayName = "FormGroup");
var Cc = U(
  (e) => {
    var t = e, { store: n, name: r } = t, o = Z(t, ["store", "name"]);
    const i = ie(Dt);
    n = n || i, Ke(
      n,
      process.env.NODE_ENV !== "production" && "FormInput must be wrapped in a Form component"
    );
    const s = `${r}`, l = o.onChange, a = K((u) => {
      l == null || l(u), !u.defaultPrevented && (n == null || n.setValue(s, u.target.value));
    }), c = n.useValue(s);
    return o = F(E({
      value: c
    }, o), {
      onChange: a
    }), o = Lt(o), o = Ir(E({ store: n, name: s }, o)), o;
  }
), Qi = at((e) => {
  const t = Cc(e);
  return z("input", t);
});
process.env.NODE_ENV !== "production" && (Qi.displayName = "FormInput");
function Ec(e) {
  return e === "input" || e === "textarea" || e === "select" || e === "meter" || e === "progress";
}
var yc = U(
  (e) => {
    var t = e, { store: n, name: r, getItem: o } = t, i = Z(t, ["store", "name", "getItem"]);
    const s = ie(Dt);
    n = n || s, Ke(
      n,
      process.env.NODE_ENV !== "production" && "FormLabel must be wrapped in a Form component"
    );
    const l = Ve(i.id), a = Q(null), c = `${r}`, u = be(
      (h) => {
        const b = F(E({}, h), { id: l || h.id, name: c, type: "label" });
        return o ? o(b) : b;
      },
      [l, c, o]
    ), m = n.useState(
      (h) => h.items.find((b) => b.type === "field" && b.name === c)
    ), d = bt(m == null ? void 0 : m.element, "input"), p = Ec(d), g = i.onClick, x = K((h) => {
      if (g == null || g(h), h.defaultPrevented || p)
        return;
      const b = m == null ? void 0 : m.element;
      b && queueMicrotask(() => {
        const S = Qo(b, !0, !0);
        S == null || S.focus(), S == null || S.click();
      });
    });
    return i = F(E({
      id: l,
      render: p ? /* @__PURE__ */ f.jsx("label", {}) : /* @__PURE__ */ f.jsx("span", {}),
      htmlFor: p ? m == null ? void 0 : m.id : void 0
    }, i), {
      ref: ce(a, i.ref),
      onClick: x
    }), p || (i = F(E({}, i), {
      style: E({
        cursor: "default"
      }, i.style)
    })), i = jt(F(E({ store: n }, i), { getItem: u })), i;
  }
), es = at((e) => {
  const t = yc(e);
  return z("label", t);
});
process.env.NODE_ENV !== "production" && (es.displayName = "FormLabel");
function Io() {
  return new Promise((e) => requestAnimationFrame(() => e()));
}
function on(e) {
  return Object.keys(e).some((t) => ln(e[t]) ? on(e[t]) : !!e[t]);
}
function tt(e, t, n) {
  var r;
  const [o, ...i] = Array.isArray(t) ? t : `${t}`.split(".");
  return o == null || !e ? n : i.length ? tt(e[o], i, n) : (r = e[o]) != null ? r : n;
}
function wt(e, t, n) {
  const [r, ...o] = Array.isArray(t) ? t : `${t}`.split(".");
  if (r == null)
    return e;
  const i = r, s = Zs(i), a = (s ? e || [] : e || {})[i], c = o.length && (Array.isArray(a) || ln(a)) ? wt(a, o, n) : n;
  if (s) {
    const u = Number(i);
    if (e)
      return [
        ...e.slice(0, u),
        c,
        ...e.slice(u + 1)
      ];
    const m = [];
    return m[u] = c, m;
  }
  return le(Y({}, e), { [i]: c });
}
function Jn(e, t) {
  const n = {}, r = Object.keys(e);
  for (const o of r) {
    const i = e[o];
    Array.isArray(i) ? n[o] = i.map((s) => ln(s) ? Jn(s, t) : t) : ln(i) ? n[o] = Jn(i, t) : n[o] = t;
  }
  return n;
}
function ts(e, t = []) {
  return {
    get(r, o) {
      if (["toString", "valueOf", Symbol.toPrimitive].includes(o))
        return () => t.join(".");
      const i = [...t, o], s = i.join(".");
      if (e[s])
        return e[s];
      const l = new Proxy(r, ts(e, i));
      return e[s] = l, l;
    }
  };
}
function wc() {
  const e = /* @__PURE__ */ Object.create(null);
  return new Proxy(/* @__PURE__ */ Object.create(null), ts(e));
}
function _c(e = {}) {
  var t;
  const n = (t = e.store) == null ? void 0 : t.getState(), r = hr(e), o = W(
    e.values,
    n == null ? void 0 : n.values,
    e.defaultValues,
    {}
  ), i = W(
    e.errors,
    n == null ? void 0 : n.errors,
    e.defaultErrors,
    {}
  ), s = W(
    e.touched,
    n == null ? void 0 : n.touched,
    e.defaultTouched,
    {}
  ), l = le(Y({}, r.getState()), {
    values: o,
    errors: i,
    touched: s,
    validating: W(n == null ? void 0 : n.validating, !1),
    submitting: W(n == null ? void 0 : n.submitting, !1),
    submitSucceed: W(n == null ? void 0 : n.submitSucceed, 0),
    submitFailed: W(n == null ? void 0 : n.submitFailed, 0),
    valid: !on(i)
  }), a = Fe(l, r, e.store), c = /* @__PURE__ */ new Set(), u = /* @__PURE__ */ new Set(), m = async () => {
    a.setState("validating", !0), a.setState("errors", {});
    try {
      for (const d of c)
        await d(a.getState());
      return await Io(), !on(a.getState().errors);
    } finally {
      a.setState("validating", !1);
    }
  };
  return le(Y(Y({}, r), a), {
    names: wc(),
    setValues: (d) => a.setState("values", d),
    getValue: (d) => tt(a.getState().values, d),
    setValue: (d, p) => a.setState("values", (g) => {
      const x = tt(g, d), h = nn(p, x);
      return h === x ? g : wt(g, d, h);
    }),
    pushValue: (d, p) => a.setState("values", (g) => {
      const x = tt(g, d, []);
      return wt(g, d, [...x, p]);
    }),
    removeValue: (d, p) => a.setState("values", (g) => {
      const x = tt(g, d, []);
      return wt(g, d, [
        ...x.slice(0, p),
        null,
        ...x.slice(p + 1)
      ]);
    }),
    setErrors: (d) => a.setState("errors", d),
    getError: (d) => tt(a.getState().errors, d),
    setError: (d, p) => a.setState("errors", (g) => {
      const x = tt(g, d), h = nn(p, x);
      return h === x ? g : wt(g, d, h);
    }),
    setTouched: (d) => a.setState("touched", d),
    getFieldTouched: (d) => !!tt(a.getState().touched, d),
    setFieldTouched: (d, p) => a.setState("touched", (g) => {
      const x = tt(g, d), h = nn(p, x);
      return h === x ? g : wt(g, d, h);
    }),
    onValidate: (d) => (c.add(d), () => c.delete(d)),
    validate: m,
    onSubmit: (d) => (u.add(d), () => u.delete(d)),
    submit: async () => {
      a.setState("submitting", !0), a.setState("touched", Jn(a.getState().values, !0));
      try {
        if (await m()) {
          for (const d of u)
            await d(a.getState());
          if (await Io(), !on(a.getState().errors))
            return a.setState("submitSucceed", (d) => d + 1), !0;
        }
        return a.setState("submitFailed", (d) => d + 1), !1;
      } catch (d) {
        throw a.setState("submitFailed", (p) => p + 1), d;
      } finally {
        a.setState("submitting", !1);
      }
    },
    reset: () => {
      a.setState("values", o), a.setState("errors", i), a.setState("touched", s), a.setState("validating", !1), a.setState("submitting", !1), a.setState("submitSucceed", 0), a.setState("submitFailed", 0);
    }
  });
}
function Oc(e) {
  return Pi();
}
function Ic(e, t) {
  e = Li(e, t), ge(e, t, "values", "setValues"), ge(e, t, "errors", "setErrors"), ge(e, t, "touched", "setTouched");
  const n = be(
    (i) => e.useState(() => e.getValue(i)),
    [e]
  ), r = be(
    (i) => {
      i = K(i);
      const s = e.useState("items");
      q(() => e.onValidate(i), [s, i]);
    },
    [e]
  ), o = be(
    (i) => {
      i = K(i);
      const s = e.useState("items");
      q(() => e.onSubmit(i), [s, i]);
    },
    [e]
  );
  return ke(
    () => F(E({}, e), {
      useValue: n,
      useValidate: r,
      useSubmit: o
    }),
    []
  );
}
function ns(e = {}) {
  const t = Oc(), n = xt(() => _c(E(E({}, e), t)));
  return Ic(n, e);
}
function Ac(e, t) {
  return t.some(
    (n) => n.type === "field" && n.element === e
  );
}
function Pc(e) {
  return e.find(
    (t) => {
      var n;
      return t.type === "field" && ((n = t.element) == null ? void 0 : n.getAttribute("aria-invalid")) === "true";
    }
  );
}
var Lc = U(
  (e) => {
    var t = e, {
      store: n,
      validateOnChange: r = !0,
      validateOnBlur: o = !0,
      resetOnUnmount: i = !1,
      resetOnSubmit: s = !0,
      autoFocusOnSubmit: l = !0
    } = t, a = Z(t, [
      "store",
      "validateOnChange",
      "validateOnBlur",
      "resetOnUnmount",
      "resetOnSubmit",
      "autoFocusOnSubmit"
    ]);
    const c = Q(null), u = n.useState("values"), m = n.useState("submitSucceed"), d = n.useState("submitFailed"), p = n.useState("items"), g = fa(u);
    q(
      () => i ? n.reset : void 0,
      [i, n.reset]
    ), ga(() => {
      r && u !== g && n.validate();
    }, [r, u, g, n]), q(() => {
      s && m && n.reset();
    }, [s, m, n]);
    const [x, h] = ne(!1);
    q(() => {
      if (!x || !d)
        return;
      const _ = Pc(p), C = _ == null ? void 0 : _.element;
      C && (h(!1), C.focus(), Zt(C) && C.select());
    }, [l, d, p]);
    const b = a.onSubmit, S = K((_) => {
      b == null || b(_), !_.defaultPrevented && (_.preventDefault(), n.submit(), l && h(!0));
    }), w = a.onBlur, A = K((_) => {
      w == null || w(_), !_.defaultPrevented && o && Ac(_.target, n.getState().items) && n.validate();
    }), y = a.onReset, I = K((_) => {
      y == null || y(_), !_.defaultPrevented && (_.preventDefault(), n.reset());
    });
    a = he(
      a,
      (_) => /* @__PURE__ */ f.jsx(Dt.Provider, { value: n, children: _ }),
      [n]
    );
    const O = bt(c, a.as || "form");
    return a = F(E({
      role: O !== "form" ? "form" : void 0,
      noValidate: !0
    }, a), {
      ref: ce(c, a.ref),
      onSubmit: S,
      onBlur: A,
      onReset: I
    }), a;
  }
), Ar = J((e) => {
  const t = Lc(e);
  return z("form", t);
});
process.env.NODE_ENV !== "production" && (Ar.displayName = "Form");
var rs = pe(void 0), jc = U((e) => {
  var t = e, { store: n } = t, r = Z(t, ["store"]);
  const o = n.useState(
    (i) => i.orientation === "both" ? void 0 : i.orientation
  );
  return r = he(
    r,
    (i) => /* @__PURE__ */ f.jsx(rs.Provider, { value: n, children: i }),
    [n]
  ), r = E({
    role: "tablist",
    "aria-orientation": o
  }, r), r = xr(E({ store: n }, r)), r;
}), Pr = J((e) => {
  const t = jc(e);
  return z("div", t);
});
process.env.NODE_ENV !== "production" && (Pr.displayName = "TabList");
var Rc = U(
  (e) => {
    var t = e, { store: n, tabId: r, getItem: o } = t, i = Z(t, ["store", "tabId", "getItem"]);
    const s = Q(null), l = Ve(i.id), [a, c] = ne(!1);
    q(() => {
      const g = s.current;
      if (!g)
        return;
      const x = Ut(g);
      c(!!x.length);
    }, []);
    const u = be(
      (g) => {
        const x = F(E({}, g), { id: l || g.id, tabId: r });
        return o ? o(x) : x;
      },
      [l, r, o]
    ), m = n.panels.useState(
      () => {
        var g;
        return r || ((g = n.panels.item(l)) == null ? void 0 : g.tabId);
      }
    ), d = n.useState(
      (g) => !!m && g.selectedId === m
    );
    i = F(E({
      id: l,
      role: "tabpanel",
      "aria-labelledby": m || void 0
    }, i), {
      ref: ce(s, i.ref)
    });
    const p = li({ open: d });
    return i = Lt(E({ focusable: !a }, i)), i = bn(E({ store: p }, i)), i = jt(F(E({ store: n.panels }, i), { getItem: u })), i;
  }
), Lr = J((e) => {
  const t = Rc(e);
  return z("div", t);
});
process.env.NODE_ENV !== "production" && (Lr.displayName = "TabPanel");
function Nc(e = {}) {
  var t;
  const n = (t = e.store) == null ? void 0 : t.getState(), r = Ri(le(Y({}, e), {
    orientation: W(
      e.orientation,
      n == null ? void 0 : n.orientation,
      "horizontal"
    ),
    focusLoop: W(e.focusLoop, n == null ? void 0 : n.focusLoop, !0)
  })), o = hr(), i = le(Y({}, r.getState()), {
    selectedId: W(
      e.selectedId,
      n == null ? void 0 : n.selectedId,
      e.defaultSelectedId,
      void 0
    ),
    selectOnMove: W(
      e.selectOnMove,
      n == null ? void 0 : n.selectOnMove,
      !0
    )
  }), s = Fe(i, r, e.store);
  return s.setup(
    () => s.sync(() => {
      const { activeId: l, selectOnMove: a } = s.getState();
      if (!a || !l)
        return;
      const c = r.item(l);
      c && (c.dimmed || c.disabled || s.setState("selectedId", c.id));
    }, ["moves"])
  ), s.setup(
    () => s.syncBatch(
      (l) => s.setState("activeId", l.selectedId),
      ["selectedId"]
    )
  ), s.setup(
    () => s.sync(
      (l) => {
        if (l.selectedId !== void 0)
          return;
        const { activeId: a, renderedItems: c } = s.getState(), u = r.item(a);
        if (u && !u.disabled && !u.dimmed)
          s.setState("selectedId", u.id);
        else {
          const m = c.find(
            (d) => !d.disabled && !d.dimmed
          );
          s.setState("selectedId", m == null ? void 0 : m.id);
        }
      },
      ["selectedId", "renderedItems"]
    )
  ), s.setup(
    () => s.sync(
      (l) => {
        const a = l.renderedItems;
        if (a.length)
          return o.sync(
            (c) => {
              const u = c.renderedItems;
              u.some((d) => !d.tabId) && u.forEach((d, p) => {
                if (d.tabId)
                  return;
                const g = a[p];
                g && o.renderItem(le(Y({}, d), { tabId: g.id }));
              });
            },
            ["renderedItems"]
          );
      },
      ["renderedItems"]
    )
  ), le(Y(Y({}, r), s), {
    panels: o,
    setSelectedId: (l) => s.setState("selectedId", l),
    select: (l) => {
      s.setState("selectedId", l), r.move(l);
    }
  });
}
function Dc(e) {
  return Ni();
}
function Tc(e, t) {
  e = Di(e, t), ge(e, t, "selectedId", "setSelectedId"), ge(e, t, "selectOnMove");
  const n = xt(() => e.panels);
  return ke(() => F(E({}, e), { panels: n }), []);
}
function os(e = {}) {
  const t = Dc(), n = xt(() => Nc(E(E({}, e), t)));
  return Tc(n, e);
}
var Fc = U(
  (e) => {
    var t = e, {
      store: n,
      accessibleWhenDisabled: r = !0,
      getItem: o
    } = t, i = Z(t, [
      "store",
      "accessibleWhenDisabled",
      "getItem"
    ]);
    const s = ie(rs);
    n = n || s, Ke(
      n,
      process.env.NODE_ENV !== "production" && "Tab must be wrapped in a TabList component"
    );
    const l = Ve(), a = i.id || l, c = i.disabled, u = be(
      (x) => {
        const h = F(E({}, x), { dimmed: c });
        return o ? o(h) : h;
      },
      [c, o]
    ), m = i.onClick, d = K((x) => {
      m == null || m(x), !x.defaultPrevented && (n == null || n.setSelectedId(a));
    }), p = n.panels.useState(
      (x) => {
        var h;
        return (h = x.items.find((b) => b.tabId === a)) == null ? void 0 : h.id;
      }
    ), g = n.useState((x) => !!a && x.selectedId === a);
    return i = F(E({
      id: a,
      role: "tab",
      "aria-selected": g,
      "aria-controls": p || void 0
    }, i), {
      onClick: d
    }), i = gr(F(E({
      store: n
    }, i), {
      accessibleWhenDisabled: r,
      getItem: u,
      shouldRegisterItem: l ? i.shouldRegisterItem : !1
    })), i;
  }
), jr = at((e) => {
  const t = Fc(e);
  return z("button", t);
});
process.env.NODE_ENV !== "production" && (jr.displayName = "Tab");
var Mc = U(
  (e) => {
    var t = e, { store: n } = t, r = Z(t, ["store"]);
    return r = Ui(E({ store: n }, r)), r;
  }
), Rr = J((e) => {
  const t = Mc(e);
  return z("span", t);
});
process.env.NODE_ENV !== "production" && (Rr.displayName = "SelectArrow");
var kc = pe(!1), Nr = pe(void 0);
function Vc(e, t) {
  return e == null || t == null ? !1 : Array.isArray(e) ? e.includes(t) : e === t;
}
var Bc = U(
  (e) => {
    var t = e, {
      store: n,
      value: r,
      getItem: o,
      hideOnClick: i,
      setValueOnClick: s = r != null,
      preventScrollOnKeyDown: l = !0,
      focusOnHover: a = !0
    } = t, c = Z(t, [
      "store",
      "value",
      "getItem",
      "hideOnClick",
      "setValueOnClick",
      "preventScrollOnKeyDown",
      "focusOnHover"
    ]), u;
    const m = ie(Nr);
    n = n || m, Ke(
      n,
      process.env.NODE_ENV !== "production" && "SelectItem must be wrapped in a SelectList or SelectPopover component"
    );
    const d = Ve(c.id), p = c.disabled, g = be(
      (_) => {
        const C = F(E({}, _), {
          value: p ? void 0 : r,
          children: r
        });
        return o ? o(C) : C;
      },
      [p, r, o]
    ), x = n.useState(
      (_) => Array.isArray(_.value)
    );
    i = i ?? (r != null && !x);
    const h = c.onClick, b = ye(s), S = ye(i), w = K((_) => {
      h == null || h(_), !_.defaultPrevented && (ua(_) || la(_) || (b(_) && r != null && (n == null || n.setValue((C) => Array.isArray(C) ? C.includes(r) ? C.filter((N) => N !== r) : [...C, r] : r)), S(_) && (n == null || n.hide())));
    }), A = n.useState((_) => Vc(_.value, r));
    c = he(
      c,
      (_) => /* @__PURE__ */ f.jsx(kc.Provider, { value: A, children: _ }),
      [A]
    );
    const y = n.useState("contentElement"), I = n.useState((_) => _.activeId !== d && (n != null && n.item(_.activeId)) || _.value == null || r == null ? !1 : Array.isArray(_.value) ? _.value[_.value.length - 1] === r : _.value === r);
    c = F(E({
      id: d,
      role: oa(y),
      "aria-selected": A,
      children: r
    }, c), {
      autoFocus: (u = c.autoFocus) != null ? u : I,
      onClick: w
    }), c = gr(E({
      store: n,
      getItem: g,
      preventScrollOnKeyDown: l
    }, c));
    const O = ye(a);
    return c = Ai(F(E({
      store: n
    }, c), {
      // We have to disable focusOnHover when the popup is closed, otherwise
      // the active item will change to null (the container) when the popup is
      // closed by clicking on an item.
      focusOnHover: (_) => {
        if (!O(_))
          return !1;
        const C = n == null ? void 0 : n.getState();
        return !!(C != null && C.open);
      }
    })), c;
  }
), is = at((e) => {
  const t = Bc(e);
  return z("div", t);
});
process.env.NODE_ENV !== "production" && (is.displayName = "SelectItem");
var ss = U(
  (e) => {
    var t = e, {
      store: n,
      resetOnEscape: r = !0,
      hideOnEnter: o = !0,
      focusOnMove: i = !0,
      composite: s,
      alwaysVisible: l
    } = t, a = Z(t, [
      "store",
      "resetOnEscape",
      "hideOnEnter",
      "focusOnMove",
      "composite",
      "alwaysVisible"
    ]);
    const c = Q(null), u = Ve(a.id), m = n.useState("value"), d = Array.isArray(m), [p, g] = ne(m), x = n.useState("mounted");
    q(() => {
      x || g(m);
    }, [x, m]), r = r && !d;
    const h = a.onKeyDown, b = ye(r), S = ye(o), w = K((R) => {
      h == null || h(R), !R.defaultPrevented && (R.key === "Escape" && b(R) && n.setValue(p), (R.key === " " || R.key === "Enter") && Ae(R) && S(R) && (R.preventDefault(), n.hide()));
    });
    a = he(
      a,
      (R) => /* @__PURE__ */ f.jsx(Nr.Provider, { value: n, children: R }),
      [n]
    );
    const A = n.useState((R) => {
      var V;
      return (V = R.labelElement) == null ? void 0 : V.id;
    }), y = n.useState("combobox");
    s = s ?? !y, s && (a = E({ role: "listbox" }, a));
    const I = pa(c, "role", a.role), _ = (s || (I === "listbox" || I === "menu" || I === "tree" || I === "grid")) && d || void 0, C = fr(x, a.hidden, l), N = C ? F(E({}, a.style), { display: "none" }) : a.style;
    return a = F(E({
      id: u,
      "aria-labelledby": A,
      "aria-multiselectable": _,
      hidden: C
    }, a), {
      ref: ce(u ? n.setContentElement : null, c, a.ref),
      style: N,
      onKeyDown: w
    }), a = xr(F(E({ store: n }, a), { composite: s })), a = br(E({ store: n, typeahead: !y }, a)), a;
  }
), Hc = J((e) => {
  const t = ss(e);
  return z("div", t);
});
process.env.NODE_ENV !== "production" && (Hc.displayName = "SelectList");
var $c = U(
  (e) => {
    var t = e, { store: n, alwaysVisible: r } = t, o = Z(t, ["store", "alwaysVisible"]);
    return o = ss(E({ store: n, alwaysVisible: r }, o)), o = zi(E({ store: n, alwaysVisible: r }, o)), o;
  }
), as = J((e) => {
  const t = $c(e);
  return z("div", t);
});
process.env.NODE_ENV !== "production" && (as.displayName = "SelectPopover");
function Kc(e = {}) {
  var t = e, {
    combobox: n
  } = t, r = Wo(t, [
    "combobox"
  ]);
  const o = ir(
    r.store,
    n == null ? void 0 : n.omit(
      "value",
      "items",
      "renderedItems",
      "baseElement",
      "arrowElement",
      "anchorElement",
      "contentElement",
      "popoverElement",
      "disclosureElement"
    )
  ), i = o.getState(), s = Ri(le(Y({}, r), {
    store: o,
    virtualFocus: W(
      r.virtualFocus,
      i.virtualFocus,
      !0
    ),
    includesBaseElement: W(
      r.includesBaseElement,
      i.includesBaseElement,
      !1
    ),
    activeId: W(
      r.activeId,
      i.activeId,
      r.defaultActiveId,
      null
    ),
    orientation: W(
      r.orientation,
      i.orientation,
      "vertical"
    )
  })), l = cc(le(Y({}, r), {
    store: o,
    placement: W(
      r.placement,
      i.placement,
      "bottom-start"
    )
  })), a = new String(""), c = le(Y(Y({}, s.getState()), l.getState()), {
    combobox: W(i.combobox, !!n),
    value: W(
      r.value,
      i.value,
      r.defaultValue,
      a
    ),
    setValueOnMove: W(
      r.setValueOnMove,
      i.setValueOnMove,
      !1
    ),
    selectElement: W(i.selectElement, null),
    labelElement: W(i.labelElement, null)
  }), u = Fe(c, s, l, o);
  return u.setup(
    () => u.sync(
      (m) => {
        if (m.value !== a || !m.items.length)
          return;
        const d = m.items.find(
          (p) => !p.disabled && p.value != null
        );
        (d == null ? void 0 : d.value) != null && u.setState("value", d.value);
      },
      ["value", "items"]
    )
  ), u.setup(
    () => u.sync(
      (m) => {
        if (n || m.mounted)
          return;
        const d = iu(m.value), p = d[d.length - 1];
        if (p == null)
          return;
        const g = m.items.find(
          (x) => !x.disabled && x.value === p
        );
        g && u.setState("activeId", g.id);
      },
      ["mounted", "items", "value"]
    )
  ), u.setup(
    () => u.syncBatch(
      (m) => {
        const { mounted: d, value: p, activeId: g } = u.getState();
        if (!m.setValueOnMove && d || Array.isArray(p) || !m.moves || !g)
          return;
        const x = s.item(g);
        !x || x.disabled || x.value == null || u.setState("value", x.value);
      },
      ["setValueOnMove", "moves"]
    )
  ), le(Y(Y(Y({}, s), l), u), {
    setValue: (m) => u.setState("value", m),
    setSelectElement: (m) => u.setState("selectElement", m),
    setLabelElement: (m) => u.setState("labelElement", m)
  });
}
function Wc(e) {
  return E(E({}, Ni()), dc());
}
function zc(e, t) {
  return e = Di(e, t), e = fc(e, t), ge(e, t, "value", "setValue"), e;
}
function Zc(e = {}) {
  const t = Wc(), n = xt(
    () => Kc(E(E({}, e), t))
  );
  return zc(n, e);
}
function Uc(e) {
  return Array.from(e.selectedOptions).map((t) => t.value);
}
function Qt(e, t) {
  return () => {
    const n = t();
    if (!n)
      return;
    let r = 0, o = e.item(n);
    const i = o;
    for (; o && o.value == null; ) {
      const s = t(++r);
      if (!s)
        return;
      if (o = e.item(s), o === i)
        break;
    }
    return o == null ? void 0 : o.id;
  };
}
var qc = U(
  (e) => {
    var t = e, {
      store: n,
      name: r,
      form: o,
      required: i,
      showOnKeyDown: s = !0,
      moveOnKeyDown: l = !0,
      toggleOnClick: a = !1,
      toggleOnPress: c = !a
    } = t, u = Z(t, [
      "store",
      "name",
      "form",
      "required",
      "showOnKeyDown",
      "moveOnKeyDown",
      "toggleOnClick",
      "toggleOnPress"
    ]);
    c = a ? !1 : c;
    const m = u.onKeyDown, d = ye(s), p = ye(l), g = ye(c), h = n.useState("placement").split("-")[0], b = n.useState("value"), S = Array.isArray(b), w = K((j) => {
      var B;
      if (m == null || m(j), j.defaultPrevented)
        return;
      const { orientation: de, items: Se, activeId: k } = n.getState();
      (j.key === " " || j.key === "Enter") && g(j) && (j.preventDefault(), n.toggle());
      const ee = de !== "horizontal", se = de !== "vertical", ae = !!((B = Se.find(
        (H) => !H.disabled && H.value != null
      )) != null && B.rowId), Ce = {
        ArrowUp: (ae || ee) && Qt(n, n.up),
        ArrowRight: (ae || se) && Qt(n, n.next),
        ArrowDown: (ae || ee) && Qt(n, n.down),
        ArrowLeft: (ae || se) && Qt(n, n.previous)
      }[j.key];
      Ce && p(j) && (j.preventDefault(), n.move(Ce()));
      const Ie = h === "top" || h === "bottom";
      ({
        ArrowDown: Ie,
        ArrowUp: Ie,
        ArrowLeft: h === "left",
        ArrowRight: h === "right"
      })[j.key] && d(j) && (j.preventDefault(), n.show(), n.move(k));
    }), A = u.onMouseDown, y = K((j) => {
      if (A == null || A(j), j.defaultPrevented || j.button || j.ctrlKey || !g(j))
        return;
      const B = j.currentTarget;
      Wt(B, "focusin", () => {
        n.setDisclosureElement(B), n.toggle();
      });
    });
    u = he(
      u,
      (j) => /* @__PURE__ */ f.jsx(Nr.Provider, { value: n, children: j }),
      [n]
    );
    const [I, O] = ne(!1), _ = Q(!1);
    q(() => {
      const j = _.current;
      _.current = !1, !j && O(!1);
    }, [b]);
    const C = n.useState((j) => {
      var B;
      return (B = j.labelElement) == null ? void 0 : B.id;
    }), N = u["aria-label"], R = u["aria-labelledby"] || C, V = n.useState("items"), M = ke(
      // Filter out items without value and duplicate values.
      () => [...new Set(V.map((j) => j.value).filter((j) => j != null))],
      [V]
    );
    u = he(
      u,
      (j) => r ? /* @__PURE__ */ f.jsxs(f.Fragment, { children: [
        /* @__PURE__ */ f.jsx(
          "select",
          {
            style: {
              border: 0,
              clip: "rect(0 0 0 0)",
              height: "1px",
              margin: "-1px",
              overflow: "hidden",
              padding: 0,
              position: "absolute",
              whiteSpace: "nowrap",
              width: "1px"
            },
            tabIndex: -1,
            "aria-hidden": !0,
            "aria-label": N,
            "aria-labelledby": R,
            name: r,
            form: o,
            required: i,
            value: b,
            multiple: S,
            onFocus: () => {
              var B;
              return (B = n.getState().selectElement) == null ? void 0 : B.focus();
            },
            onChange: (B) => {
              _.current = !0, O(!0), n.setValue(
                S ? Uc(B.target) : B.target.value
              );
            },
            children: M.map((B) => /* @__PURE__ */ f.jsx("option", { value: B, children: B }, B))
          }
        ),
        j
      ] }) : j,
      [
        n,
        N,
        R,
        r,
        o,
        i,
        b,
        S,
        M
      ]
    );
    const L = /* @__PURE__ */ f.jsxs(f.Fragment, { children: [
      b,
      /* @__PURE__ */ f.jsx(Rr, {})
    ] }), T = n.useState("contentElement");
    return u = F(E({
      role: "combobox",
      "aria-autocomplete": "none",
      "aria-labelledby": C,
      "aria-haspopup": qo(T, "listbox"),
      "data-autofill": I ? "" : void 0,
      "data-name": r,
      children: L
    }, u), {
      ref: ce(n.setSelectElement, u.ref),
      onKeyDown: w,
      onMouseDown: y
    }), u = qi(E({ store: n, toggleOnClick: a }, u)), u = br(E({ store: n }, u)), u;
  }
), ls = J((e) => {
  const t = qc(e);
  return z("button", t);
});
process.env.NODE_ENV !== "production" && (ls.displayName = "Select");
const yn = pe({}), Dr = pe(null), Gc = "flex flex-row w-full", Uf = ({ defaultSelectedId: e, isRtl: t, children: n, className: r, ...o }) => {
  const i = os({ defaultSelectedId: e, orientation: "vertical" }), s = t ?? null;
  return /* @__PURE__ */ f.jsx(yn.Provider, { value: i, children: /* @__PURE__ */ f.jsx(Dr.Provider, { value: s, children: /* @__PURE__ */ f.jsx(
    "div",
    {
      className: [Gc, r].join(" "),
      "data-qa-name": o.id ? `dashboard_${o.id}` : "dashboard",
      ...o,
      children: n
    }
  ) }) });
};
var us = {
  color: void 0,
  size: void 0,
  className: void 0,
  style: void 0,
  attr: void 0
}, Ao = $e.createContext && $e.createContext(us), dt = globalThis && globalThis.__assign || function() {
  return dt = Object.assign || function(e) {
    for (var t, n = 1, r = arguments.length; n < r; n++) {
      t = arguments[n];
      for (var o in t)
        Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
    }
    return e;
  }, dt.apply(this, arguments);
}, Yc = globalThis && globalThis.__rest || function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++)
      t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
  return n;
};
function cs(e) {
  return e && e.map(function(t, n) {
    return $e.createElement(t.tag, dt({
      key: n
    }, t.attr), cs(t.child));
  });
}
function Be(e) {
  return function(t) {
    return $e.createElement(Xc, dt({
      attr: dt({}, e.attr)
    }, t), cs(e.child));
  };
}
function Xc(e) {
  var t = function(n) {
    var r = e.attr, o = e.size, i = e.title, s = Yc(e, ["attr", "size", "title"]), l = o || n.size || "1em", a;
    return n.className && (a = n.className), e.className && (a = (a ? a + " " : "") + e.className), $e.createElement("svg", dt({
      stroke: "currentColor",
      fill: "currentColor",
      strokeWidth: "0"
    }, n.attr, r, s, {
      className: a,
      style: dt(dt({
        color: e.color || n.color
      }, n.style), e.style),
      height: l,
      width: l,
      xmlns: "http://www.w3.org/2000/svg"
    }), i && $e.createElement("title", null, i), e.children);
  };
  return Ao !== void 0 ? $e.createElement(Ao.Consumer, null, function(n) {
    return t(n);
  }) : t(us);
}
function Jc(e) {
  return Be({ tag: "svg", attr: { viewBox: "0 0 512 512" }, child: [{ tag: "path", attr: { d: "M294.1 256L167 129c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.3 34 0L345 239c9.1 9.1 9.3 23.7.7 33.1L201.1 417c-4.7 4.7-10.9 7-17 7s-12.3-2.3-17-7c-9.4-9.4-9.4-24.6 0-33.9l127-127.1z" } }] })(e);
}
function Qc(e) {
  return Be({ tag: "svg", attr: { viewBox: "0 0 512 512" }, child: [{ tag: "path", attr: { d: "M443.5 420.2L336.7 312.4c20.9-26.2 33.5-59.4 33.5-95.5 0-84.5-68.5-153-153.1-153S64 132.5 64 217s68.5 153 153.1 153c36.6 0 70.1-12.8 96.5-34.2l106.1 107.1c3.2 3.4 7.6 5.1 11.9 5.1 4.1 0 8.2-1.5 11.3-4.5 6.6-6.3 6.8-16.7.6-23.3zm-226.4-83.1c-32.1 0-62.3-12.5-85-35.2-22.7-22.7-35.2-52.9-35.2-84.9 0-32.1 12.5-62.3 35.2-84.9 22.7-22.7 52.9-35.2 85-35.2s62.3 12.5 85 35.2c22.7 22.7 35.2 52.9 35.2 84.9 0 32.1-12.5 62.3-35.2 84.9-22.7 22.7-52.9 35.2-85 35.2z" } }] })(e);
}
const qe = (e) => {
  if (typeof document > "u")
    return e;
  let t = document == null ? void 0 : document.createElement("textarea");
  return t.innerHTML = e, t.value;
}, qf = (e) => [
  "ar",
  // Arabic
  "arc",
  // Aramaic
  "az",
  "aze",
  // Azeri
  "div",
  "dv",
  // Dhivehi/Maldivian
  "heb",
  "he",
  // Hebrew
  "kur",
  "ku",
  // Kurdish (Sorani)
  "per",
  "far",
  "fa",
  // Persian/Farsi
  "urd",
  "ur"
  // Urdu
].indexOf(e) != -1, xe = (e) => e ? "!text-right justify-end" : "text-left", Gf = (e, t) => (t.map((n, r) => {
  const o = new RegExp(`({[${r}]})+`);
  e = e.replace(o, n);
}), e), ed = "py-8 px-4 h-fit flex flex-row text-base font-Avenir items-center text-left flex-shrink-0 flex-grow-0 justify-between w-full hover:bg-grey-xlt", td = "border-t border-t-grey-lt first:border-none last:border-b last:border-b-grey-lt", nd = "bg-white rounded-lg shadow border-none", Yf = ({ title: e, subtitle: t, id: n, isRtl: r = !1, children: o, className: i, ...s }) => {
  const l = ie(yn), a = ie(Dr), c = a ?? r, u = l.useState().selectedId == n;
  return /* @__PURE__ */ f.jsxs(
    jr,
    {
      id: n,
      className: [
        ed,
        td,
        u ? nd : "",
        i || "",
        xe(c)
      ].join(" "),
      "data-qa-name": n ? `dashboard_item_${n}` : "dashboard_item",
      ...s,
      children: [
        o,
        (e || t) && /* @__PURE__ */ f.jsxs("div", { className: "flex-grow-0 flex-shrink w-48", children: [
          e && /* @__PURE__ */ f.jsx("h2", { className: "text-base font-extrabold min-w-fit", children: qe(e) }),
          t && u && /* @__PURE__ */ f.jsx("h3", { className: "!text-xs", children: qe(t) })
        ] }),
        /* @__PURE__ */ f.jsx(Jc, { className: "text-3xl ml-2" })
      ]
    }
  );
}, rd = "mr-4", Xf = ({ children: e, className: t, ...n }) => {
  const r = ie(yn);
  return /* @__PURE__ */ f.jsx(
    Pr,
    {
      store: r,
      className: [rd, t || ""].join(" "),
      "data-qa-name": n.id ? `dashboard_list_${n.id}` : "dashboard_list",
      ...n,
      children: e
    }
  );
}, od = "flex flex-col w-full bg-white rounded-xl shadow", Jf = ({ tabId: e, isRtl: t = !1, children: n, className: r, ...o }) => {
  const i = ie(yn), s = ie(Dr), l = s ?? t;
  return /* @__PURE__ */ f.jsx(
    Lr,
    {
      store: i,
      tabId: e,
      className: [od, xe(l), r || ""].join(" "),
      "data-qa-name": o.id ? `dashboard_panel_${o.id}` : "dashboard_panel",
      ...o,
      children: n
    }
  );
}, id = "px-6 pt-6 pb-8 border-b border-b-grey-lt last:border-none", Qf = ({ className: e, children: t, ...n }) => /* @__PURE__ */ f.jsx("div", { className: [id, e || ""].join(" "), ...n, children: t }), sd = "flex flex-col justify-items-stretch", e2 = ({
  title: e,
  storeProps: t,
  handleSubmit: n,
  onValidate: r,
  customValidation: o,
  isRtl: i = !1,
  children: s,
  ...l
}) => {
  const a = ns(t);
  return a.onValidate((c) => r == null ? void 0 : r(c)), a.useSubmit((c) => n(c)), o && a.useValidate((c) => {
    Object.keys(c.values).forEach((u) => {
      const m = o.find((d) => d.inputName === u && d.condition(a));
      m && a.setError(
        u,
        /* @__PURE__ */ f.jsx(ud, { isRtl: i, children: m.errorMessage })
      );
    });
  }), /* @__PURE__ */ f.jsxs(
    Ar,
    {
      store: a,
      ...l,
      className: [sd, l.className].join(" "),
      "data-qa-name": l.id ?? "form",
      children: [
        e && /* @__PURE__ */ f.jsx("h2", { className: "font-AvanteGarde-Bold text-xl text-bold", children: e }),
        s
      ]
    }
  );
}, ad = "mt-1 text-left text-sm text-alpha-red font-Avenir", t2 = ({ name: e, children: t, isRtl: n = !1, className: r, ...o }) => /* @__PURE__ */ f.jsx(Xi, { name: e, className: [ad, xe(n), r].join(" "), ...o, "data-qa-name": o.id ?? `form_error_${e}` });
function pn(e) {
  return Be({ tag: "svg", attr: { viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }, child: [{ tag: "path", attr: { d: "M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" } }, { tag: "line", attr: { x1: "12", y1: "9", x2: "12", y2: "13" } }, { tag: "line", attr: { x1: "12", y1: "17", x2: "12.01", y2: "17" } }] })(e);
}
const ld = "flex flex-row mt-1 align-middle items-center text-sm text-alpha-red font-Avenir", ud = ({ children: e, isRtl: t = !1, className: n, ...r }) => /* @__PURE__ */ f.jsxs("div", { className: [ld, xe(t), n].join(" "), ...r, children: [
  !t && /* @__PURE__ */ f.jsx(pn, { className: "mr-1" }),
  e,
  t && /* @__PURE__ */ f.jsx(pn, { className: "ml-1" })
] });
function cd(e) {
  return Be({ tag: "svg", attr: { viewBox: "0 0 1024 1024" }, child: [{ tag: "path", attr: { d: "M747.4 535.7c-.4-68.2 30.5-119.6 92.9-157.5-34.9-50-87.7-77.5-157.3-82.8-65.9-5.2-138 38.4-164.4 38.4-27.9 0-91.7-36.6-141.9-36.6C273.1 298.8 163 379.8 163 544.6c0 48.7 8.9 99 26.7 150.8 23.8 68.2 109.6 235.3 199.1 232.6 46.8-1.1 79.9-33.2 140.8-33.2 59.1 0 89.7 33.2 141.9 33.2 90.3-1.3 167.9-153.2 190.5-221.6-121.1-57.1-114.6-167.2-114.6-170.7zm-105.1-305c50.7-60.2 46.1-115 44.6-134.7-44.8 2.6-96.6 30.5-126.1 64.8-32.5 36.8-51.6 82.3-47.5 133.6 48.4 3.7 92.6-21.2 129-63.7z" } }] })(e);
}
function Po(e) {
  return Be({ tag: "svg", attr: { viewBox: "0 0 1024 1024" }, child: [{ tag: "path", attr: { d: "M699 353h-46.9c-10.2 0-19.9 4.9-25.9 13.3L469 584.3l-71.2-98.8c-6-8.3-15.6-13.3-25.9-13.3H325c-6.5 0-10.3 7.4-6.5 12.7l124.6 172.8a31.8 31.8 0 0 0 51.7 0l210.6-292c3.9-5.3.1-12.7-6.4-12.7z" } }, { tag: "path", attr: { d: "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z" } }] })(e);
}
function Lo(e) {
  return Be({ tag: "svg", attr: { viewBox: "0 0 1024 1024" }, child: [{ tag: "path", attr: { d: "M685.4 354.8c0-4.4-3.6-8-8-8l-66 .3L512 465.6l-99.3-118.4-66.1-.3c-4.4 0-8 3.5-8 8 0 1.9.7 3.7 1.9 5.2l130.1 155L340.5 670a8.32 8.32 0 0 0-1.9 5.2c0 4.4 3.6 8 8 8l66.1-.3L512 564.4l99.3 118.4 66 .3c4.4 0 8-3.5 8-8 0-1.9-.7-3.7-1.9-5.2L553.5 515l130.1-155c1.2-1.4 1.8-3.3 1.8-5.2z" } }, { tag: "path", attr: { d: "M512 65C264.6 65 64 265.6 64 513s200.6 448 448 448 448-200.6 448-448S759.4 65 512 65zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z" } }] })(e);
}
function dd(e) {
  return Be({ tag: "svg", attr: { viewBox: "0 0 1024 1024" }, child: [{ tag: "path", attr: { d: "M881 442.4H519.7v148.5h206.4c-8.9 48-35.9 88.6-76.6 115.8-34.4 23-78.3 36.6-129.9 36.6-99.9 0-184.4-67.5-214.6-158.2-7.6-23-12-47.6-12-72.9s4.4-49.9 12-72.9c30.3-90.6 114.8-158.1 214.7-158.1 56.3 0 106.8 19.4 146.6 57.4l110-110.1c-66.5-62-153.2-100-256.6-100-149.9 0-279.6 86-342.7 211.4-26 51.8-40.8 110.4-40.8 172.4S151 632.8 177 684.6C240.1 810 369.8 896 519.7 896c103.6 0 190.4-34.4 253.8-93 72.5-66.8 114.4-165.2 114.4-282.1 0-27.2-2.4-53.3-6.9-78.5z" } }] })(e);
}
function fd(e) {
  return Be({ tag: "svg", attr: { viewBox: "0 0 1024 1024" }, child: [{ tag: "path", attr: { d: "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z" } }, { tag: "path", attr: { d: "M464 336a48 48 0 1 0 96 0 48 48 0 1 0-96 0zm72 112h-48c-4.4 0-8 3.6-8 8v272c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V456c0-4.4-3.6-8-8-8z" } }] })(e);
}
const md = (e) => {
  if (e >= 100)
    return "w-full bg-alert-green";
  if (e >= 75)
    return "w-9/12 bg-alert-4";
  if (e >= 50)
    return "w-6/12 bg-alert-3";
  if (e >= 25)
    return "w-4/12 bg-alert-2";
  if (e > 0)
    return "w-2/12 bg-alert-1";
  if (e == 0)
    return "w-0";
}, vd = "rounded-full h-2 w-full bg-grey-lt", pd = "rounded-full h-2", gd = ({ progress: e, className: t, ...n }) => /* @__PURE__ */ f.jsx("div", { className: [vd, t].join(" "), ...n, children: /* @__PURE__ */ f.jsx("div", { className: [pd, md(e)].join(" ") }) });
function ds(e) {
  return Be({ tag: "svg", attr: { fill: "currentColor", viewBox: "0 0 16 16" }, child: [{ tag: "path", attr: { d: "M12.736 3.97a.733.733 0 0 1 1.047 0c.286.289.29.756.01 1.05L7.88 12.01a.733.733 0 0 1-1.065.02L3.217 8.384a.757.757 0 0 1 0-1.06.733.733 0 0 1 1.047 0l3.052 3.093 5.4-6.425a.247.247 0 0 1 .02-.022Z" } }] })(e);
}
const hd = "text-grey-md text-left text-sm font-Avenir", jo = "font-bold w-full", bd = "flex justify-items-center, px-1", en = "flex-grow-0 flex-shrink-0 mt-1", Ro = (e) => e >= 100 ? "text-alert-green" : e >= 75 ? "text-alert-4" : e >= 50 ? "text-alert-3" : e >= 25 ? "text-alert-2" : "text-alert-1", n2 = ({
  isRtl: e = !1,
  criteria: t,
  successTitle: n,
  title: r,
  className: o,
  ...i
}) => {
  var m, d, p;
  const s = {
    showValidCriteria: ((m = i.options) == null ? void 0 : m.showValidCriteria) ?? !1,
    hideStrengthMeter: ((d = i.options) == null ? void 0 : d.hideStrengthMeter) ?? !1,
    disableDynamicInvalidIconColours: ((p = i.options) == null ? void 0 : p.disableDynamicInvalidIconColours) ?? !1
  }, l = t.filter((g) => g.valid).length, a = t.length || 1, c = l / a * 100, u = l === a;
  return /* @__PURE__ */ f.jsx(f.Fragment, { children: /* @__PURE__ */ f.jsxs("div", { className: [hd, o].join(" "), ...i, children: [
    !s.hideStrengthMeter && /* @__PURE__ */ f.jsx(gd, { progress: c }),
    !s.showValidCriteria && u ? /* @__PURE__ */ f.jsxs("div", { className: "flex justify-between px-1 w-full", children: [
      /* @__PURE__ */ f.jsx("div", { className: [jo, xe(e)].join(" "), children: n }),
      /* @__PURE__ */ f.jsx(ds, { className: "text-alert-green text-lg" })
    ] }) : /* @__PURE__ */ f.jsx("div", { className: [jo, "px-1 mt-", xe(e)].join(" "), children: r }),
    t.map(
      (g) => (!g.valid || s.showValidCriteria) && /* @__PURE__ */ f.jsxs("div", { className: [bd, xe(e)].join(" "), children: [
        !e && (g.valid ? /* @__PURE__ */ f.jsx(
          Po,
          {
            className: [en, "mr-1 text-alert-green"].join(
              " "
            )
          }
        ) : /* @__PURE__ */ f.jsx(
          Lo,
          {
            className: [
              en,
              "mr-1",
              !s.disableDynamicInvalidIconColours && !s.hideStrengthMeter && !s.showValidCriteria ? Ro(c) : "text-alert-1"
            ].join(" ")
          }
        )),
        /* @__PURE__ */ f.jsx("span", { children: g.description }),
        e && (g.valid ? /* @__PURE__ */ f.jsx(
          Po,
          {
            className: [en, "ml-1 text-alert-green"].join(
              " "
            )
          }
        ) : /* @__PURE__ */ f.jsx(
          Lo,
          {
            className: [
              en,
              "ml-1",
              s.disableDynamicInvalidIconColours ? "text-alert-1" : Ro(c)
            ].join(" ")
          }
        ))
      ] })
    )
  ] }) });
}, xd = "block text-grey-dk text-sm text-left font-bold mb-0 font-Avenir", Bn = ({
  name: e,
  labelText: t,
  children: n,
  ...r
}) => /* @__PURE__ */ f.jsxs(es, { name: e, ...r, className: [xd, r.className].join(" "), "data-qa-name": r.id ?? `label_${e}`, children: [
  n,
  t && qe(t)
] });
function No(e) {
  return Be({ tag: "svg", attr: { viewBox: "0 0 24 24" }, child: [{ tag: "path", attr: { d: "M12 19c.946 0 1.81-.103 2.598-.281l-1.757-1.757c-.273.021-.55.038-.841.038-5.351 0-7.424-3.846-7.926-5a8.642 8.642 0 0 1 1.508-2.297L4.184 8.305c-1.538 1.667-2.121 3.346-2.132 3.379a.994.994 0 0 0 0 .633C2.073 12.383 4.367 19 12 19zm0-14c-1.837 0-3.346.396-4.604.981L3.707 2.293 2.293 3.707l18 18 1.414-1.414-3.319-3.319c2.614-1.951 3.547-4.615 3.561-4.657a.994.994 0 0 0 0-.633C21.927 11.617 19.633 5 12 5zm4.972 10.558-2.28-2.28c.19-.39.308-.819.308-1.278 0-1.641-1.359-3-3-3-.459 0-.888.118-1.277.309L8.915 7.501A9.26 9.26 0 0 1 12 7c5.351 0 7.424 3.846 7.926 5-.302.692-1.166 2.342-2.954 3.558z" } }] })(e);
}
function Do(e) {
  return Be({ tag: "svg", attr: { viewBox: "0 0 24 24" }, child: [{ tag: "path", attr: { d: "M12 9a3.02 3.02 0 0 0-3 3c0 1.642 1.358 3 3 3 1.641 0 3-1.358 3-3 0-1.641-1.359-3-3-3z" } }, { tag: "path", attr: { d: "M12 5c-7.633 0-9.927 6.617-9.948 6.684L1.946 12l.105.316C2.073 12.383 4.367 19 12 19s9.927-6.617 9.948-6.684l.106-.316-.105-.316C21.927 11.617 19.633 5 12 5zm0 12c-5.351 0-7.424-3.846-7.926-5C4.578 10.842 6.652 7 12 7c5.351 0 7.424 3.846 7.926 5-.504 1.158-2.578 5-7.926 5z" } }] })(e);
}
const Sd = "appearance-none border rounded w-full py-2 px-3 text-grey-dk leading-tight focus:outline-none focus:shadow-outline bg-white aria-invalid:border-alpha-red", r2 = ({ type: e, isRtl: t = !1, ...n }) => {
  var o;
  const r = e === "password";
  if (n.label)
    switch ((o = n.labelOptions) == null ? void 0 : o.position) {
      case "before":
        return /* @__PURE__ */ f.jsxs("div", { className: "flex", children: [
          /* @__PURE__ */ f.jsx(
            Bn,
            {
              name: n.name,
              labelText: n.label,
              className: [
                "flex grow-0 self-center mr-2",
                xe(t)
              ].join(" ")
            }
          ),
          r ? /* @__PURE__ */ f.jsx(tn, { isRtl: t, ...n }) : /* @__PURE__ */ f.jsx(Ht, { isRtl: t, ...n })
        ] });
      case "after":
        return /* @__PURE__ */ f.jsxs("div", { className: "flex", children: [
          r ? /* @__PURE__ */ f.jsx(tn, { isRtl: t, ...n }) : /* @__PURE__ */ f.jsx(Ht, { isRtl: t, ...n }),
          /* @__PURE__ */ f.jsx(
            Bn,
            {
              name: n.name,
              labelText: n.label,
              className: [
                "flex grow-0 self-center ml-2",
                xe(t)
              ].join(" ")
            }
          )
        ] });
      default:
        return /* @__PURE__ */ f.jsxs(f.Fragment, { children: [
          /* @__PURE__ */ f.jsx(
            Bn,
            {
              name: n.name,
              labelText: n.label,
              className: xe(t)
            }
          ),
          r ? /* @__PURE__ */ f.jsx(tn, { isRtl: t, ...n }) : /* @__PURE__ */ f.jsx(Ht, { isRtl: t, ...n })
        ] });
    }
  return /* @__PURE__ */ f.jsx(f.Fragment, { children: r ? /* @__PURE__ */ f.jsx(tn, { ...n }) : /* @__PURE__ */ f.jsx(Ht, { type: e, ...n }) });
}, tn = ({ isRtl: e = !1, ...t }) => {
  const [n, r] = ne(!1), o = "relative mr-2 bottom-7 float-right text-grey-md", i = "relative ml-2 top-7 float-left text-grey-md", s = (l) => {
    l.preventDefault(), r(!n);
  };
  return /* @__PURE__ */ f.jsxs(f.Fragment, { children: [
    e && (n ? /* @__PURE__ */ f.jsx(Do, { className: i, onClick: s }) : /* @__PURE__ */ f.jsx(No, { className: i, onClick: s })),
    /* @__PURE__ */ f.jsx(
      Ht,
      {
        type: n ? "text" : "password",
        isRtl: e,
        ...t
      }
    ),
    !e && (n ? /* @__PURE__ */ f.jsx(Do, { className: o, onClick: s }) : /* @__PURE__ */ f.jsx(No, { className: o, onClick: s }))
  ] });
}, Ht = ({ isRtl: e = !1, ...t }) => /* @__PURE__ */ f.jsx(
  Qi,
  {
    ...t,
    className: [
      Sd,
      xe(e),
      t.className
    ].join(" "),
    "data-qa-name": t.id ?? `input_${t.name}`
  }
), Cd = "mb-2", o2 = ({ children: e, className: t, ...n }) => /* @__PURE__ */ f.jsx(Ji, { ...n, className: [Cd, t].join(" "), children: e }), Ed = "flex flex-col text-sm font-Avenir text-grey-dk bg-alert-red-bg rounded p-4", i2 = ({ errors: e, isRtl: t = !1, className: n, ...r }) => !e || e.length === 0 ? null : /* @__PURE__ */ f.jsx("ul", { id: "validation-summary", className: [Ed, xe(t), n].join(" "), ...r, "data-qa-name": r.id ?? "validation_summary", children: e.map((i) => /* @__PURE__ */ f.jsxs("li", { className: ["flex flex-row my-1 align-middle items-center", xe(t)].join(" "), children: [
  !t && /* @__PURE__ */ f.jsx(pn, { className: "text-red-active text-lg mr-4" }),
  qe(i),
  t && /* @__PURE__ */ f.jsx(pn, { className: "text-red-active text-lg ml-4" })
] }, i)) }), s2 = ({ children: e, ...t }) => /* @__PURE__ */ f.jsx(dr, { ...t, children: e }), yd = "flex flex-row items-center", wd = "text-alpha-red text-2xl sm:text-4xl font-ItcAvantGarde-Bold font-bold", a2 = ({ variant: e, withText: t = !0, width: n = 51, height: r = 48, ...o }) => {
  let i, s;
  switch (e) {
    case "blank-red":
    default:
      s = `0 0 ${n} ${r}`, i = /* @__PURE__ */ f.jsx("svg", { width: n, height: r, viewBox: s, fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ f.jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M17.9517 5.78055L16.9575 6.82497L26.6648 17.0216C30.4065 13.213 32.8042 12.7832 35.3185 15.4243C37.307 17.5126 37.1905 19.8471 35.0854 22.0584C33.3894 23.8399 30.8739 24.5152 25.6705 24.454C17.9517 24.208 13.9758 25.3135 11.0524 28.5082L20.1151 38.0288C22.0454 36.3703 24.1494 36.0018 30.0556 36.1862C35.2602 36.3703 36.8397 36.3085 39.3539 35.6333C41.9847 34.9574 44.4407 33.4831 46.3115 31.518C52.5686 24.945 51.9835 14.0119 44.9081 6.57954C36.8397 -1.89736 25.5539 -2.2041 17.9517 5.78055ZM7.74618 48C12.0254 48 15.4947 44.357 15.4947 39.8629C15.4947 35.3696 12.0254 31.7259 7.74618 31.7259C3.46804 31.7259 0.0012178 35.3689 0 39.8629C0 44.357 3.46804 48 7.74618 48Z",
          fill: "#E42312"
        }
      ) });
  }
  return /* @__PURE__ */ f.jsxs(
    "div",
    {
      className: [yd, o.className].join(" "),
      ...o,
      "data-qa-name": o.id ?? "logo",
      children: [
        /* @__PURE__ */ f.jsx("div", { className: "scale-75 sm:scale-100 pr-3 sm:pr-6", children: i }),
        t && /* @__PURE__ */ f.jsx("h1", { className: wd, children: "Alpha" })
      ]
    }
  );
}, l2 = ({ className: e, ...t }) => /* @__PURE__ */ f.jsx("svg", { width: "32", height: "32", viewBox: "0 0 32 32", fill: "none", xmlns: "http://www.w3.org/2000/svg", className: e, ...t, children: /* @__PURE__ */ f.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2.875 5H29.125C30.1605 5 31 5.8565 31 6.91304V25.087C31 26.1435 30.1605 27 29.125 27H2.875C1.83947 27 1 26.1435 1 25.087V6.91304C1 5.8565 1.83947 5 2.875 5ZM4 9.63567V24H28V9.90504C27.9292 9.97786 27.8502 10.044 27.7631 10.1019L16.0349 19.1177L4.19211 9.78737C4.12302 9.74173 4.05892 9.6909 4 9.63567ZM6.6463 8L16.0297 15.5696L25.6822 8H6.6463Z", fill: "#09090A" }) }), u2 = (e) => /* @__PURE__ */ f.jsxs("svg", { width: "165", height: "165", viewBox: "0 0 165 165", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e, children: [
  /* @__PURE__ */ f.jsx("path", { d: "M81.7174 46.9999C82.6993 47.0128 83.6374 47.4086 84.3318 48.1029C85.0262 48.7973 85.422 49.7354 85.4348 50.7173V85.413C85.4348 86.3989 85.0432 87.3444 84.346 88.0416C83.6489 88.7387 82.7033 89.1304 81.7174 89.1304C80.7315 89.1304 79.786 88.7387 79.0888 88.0416C78.3917 87.3444 78 86.3989 78 85.413V50.7173C78.0129 49.7354 78.4086 48.7973 79.103 48.1029C79.7974 47.4086 80.7355 47.0128 81.7174 46.9999Z", fill: "#A21B10" }),
  /* @__PURE__ */ f.jsx("path", { d: "M81.7174 94.087C82.6993 94.0998 83.6374 94.4956 84.3318 95.19C85.0262 95.8843 85.422 96.8224 85.4348 97.8043V100.283C85.4348 101.269 85.0432 102.214 84.346 102.911C83.6489 103.608 82.7033 104 81.7174 104C80.7315 104 79.786 103.608 79.0888 102.911C78.3917 102.214 78 101.269 78 100.283V97.8043C78.0129 96.8224 78.4086 95.8843 79.103 95.19C79.7974 94.4956 80.7355 94.0998 81.7174 94.087Z", fill: "#A21B10" }),
  /* @__PURE__ */ f.jsx("path", { d: "M81.634 7.50001C82.0189 6.83334 82.9811 6.83334 83.366 7.5L147.885 119.25C148.27 119.917 147.789 120.75 147.019 120.75H17.9811C17.2113 120.75 16.7302 119.917 17.1151 119.25L81.634 7.50001Z", stroke: "#A21B10", strokeWidth: "6" })
] }), _d = (e) => /* @__PURE__ */ f.jsx("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e, children: /* @__PURE__ */ f.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.00022 2C9.55251 2 10.0002 2.44772 10.0002 3V4H12.7323C12.7441 3.99979 12.7559 3.99979 12.7677 4H15.0002C15.5525 4 16.0002 4.44772 16.0002 5C16.0002 5.55228 15.5525 6 15.0002 6H13.5781C13.0031 8.683 11.8622 11.1553 10.2865 13.2862C10.4431 13.4624 10.6034 13.6354 10.7675 13.8052C11.1512 14.2025 11.1402 14.8355 10.743 15.2192C10.3458 15.6029 9.71269 15.592 9.32898 15.1948C9.21785 15.0797 9.10824 14.9633 9.00016 14.8457C7.42864 16.5576 5.54731 17.9801 3.44517 19.0246C2.95057 19.2703 2.35041 19.0686 2.10467 18.574C1.85893 18.0793 2.06067 17.4792 2.55527 17.2334C4.52121 16.2567 6.27088 14.9105 7.71382 13.2862C6.82359 12.0819 6.07695 10.7743 5.49123 9.38958C5.27607 8.88093 5.51399 8.29417 6.02264 8.07901C6.53129 7.86385 7.11805 8.10177 7.33321 8.61042C7.78514 9.6788 8.34412 10.6959 9.00022 11.6467C10.1648 9.95967 11.0322 8.05211 11.5271 6H3.00022C2.44794 6 2.00022 5.55228 2.00022 5C2.00022 4.44772 2.44794 4 3.00022 4H8.00022V3C8.00022 2.44772 8.44794 2 9.00022 2ZM16.0002 10C16.379 10 16.7253 10.214 16.8946 10.5528L20.3856 17.5348C20.3921 17.5471 20.3984 17.5596 20.4043 17.5722L21.8946 20.5528C22.1416 21.0468 21.9414 21.6474 21.4474 21.8944C20.9535 22.1414 20.3528 21.9412 20.1058 21.4472L18.8822 19H13.1183L11.8946 21.4472C11.6477 21.9412 11.047 22.1414 10.553 21.8944C10.059 21.6474 9.8588 21.0468 10.1058 20.5528L11.5961 17.5722C11.6021 17.5596 11.6083 17.5471 11.6148 17.5348L15.1058 10.5528C15.2752 10.214 15.6214 10 16.0002 10ZM14.1183 17H17.8822L16.0002 13.2361L14.1183 17Z", fill: "#09090A" }) }), c2 = ({ className: e, ...t }) => /* @__PURE__ */ f.jsx("svg", { width: "20", height: "30", viewBox: "0 0 20 30", fill: "none", xmlns: "http://www.w3.org/2000/svg", className: e, ...t, children: /* @__PURE__ */ f.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10 29.1871C3.33333 20.0776 0 13.6819 0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10C20 13.6819 16.6667 20.0776 10 29.1871ZM17 10C17 6.13401 13.866 3 10 3C6.13401 3 3 6.13401 3 10C3 12.4245 5.32848 17.2264 10 24.0104C14.6715 17.2264 17 12.4245 17 10ZM13 10C13 11.6569 11.6569 13 10 13C8.34315 13 7 11.6569 7 10C7 8.34315 8.34315 7 10 7C11.6569 7 13 8.34315 13 10Z", fill: "#09090A" }) }), d2 = ({ className: e, ...t }) => /* @__PURE__ */ f.jsxs("svg", { width: "104", height: "104", viewBox: "0 0 104 104", fill: "none", xmlns: "http://www.w3.org/2000/svg", className: e, ...t, children: [
  /* @__PURE__ */ f.jsx("mask", { id: "mask0_402_14124", maskUnits: "userSpaceOnUse", x: "20", y: "87", width: "59", height: "12", children: /* @__PURE__ */ f.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M20.6855 87.0295H78.7606V98.0835H20.6855V87.0295Z", fill: "white" }) }),
  /* @__PURE__ */ f.jsx("g", { mask: "url(#mask0_402_14124)", children: /* @__PURE__ */ f.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M78.7606 92.5565C78.7606 95.6091 65.7601 98.0835 49.7231 98.0835C33.686 98.0835 20.6855 95.6091 20.6855 92.5565C20.6855 89.5043 33.686 87.0295 49.7231 87.0295C65.7601 87.0295 78.7606 89.5043 78.7606 92.5565Z", fill: "#D4D7DF" }) }),
  /* @__PURE__ */ f.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M38.8661 91.3473C37.716 91.3473 36.6504 90.7264 36.0852 89.7268L9.05534 41.9328C8.19311 40.4083 8.72592 38.4681 10.2419 37.5967L69.1378 7.44056L69.1598 7.42798C69.6387 7.1571 70.1805 7.01392 70.7261 7.01392C71.8762 7.01392 72.9418 7.63501 73.507 8.63462L100.537 56.4284C100.957 57.1702 101.062 58.031 100.834 58.8524C100.608 59.666 100.082 60.3441 99.3503 60.7647L40.4542 90.9209L40.4324 90.9332C39.9535 91.2041 39.412 91.3473 38.8666 91.3473H38.8661Z", fill: "#F4F5F7" }),
  /* @__PURE__ */ f.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M70.7258 5.80469C69.992 5.80469 69.2486 5.9885 68.5641 6.37548L9.66624 36.5328C7.55117 37.7288 6.80624 40.4132 8.00248 42.5281L35.0321 90.3221C35.8413 91.7527 37.3317 92.5566 38.8658 92.5566C39.5996 92.5566 40.3433 92.3728 41.0276 91.9858L99.9254 61.8288C102.04 60.6323 102.785 57.9481 101.589 55.8333L74.5596 8.03924C73.7503 6.60839 72.26 5.80469 70.7258 5.80469ZM70.7258 8.22329C71.4408 8.22329 72.103 8.60906 72.4542 9.22992L99.484 57.0237C100.015 57.9629 99.694 59.1557 98.7701 59.703L39.9252 89.8331L39.8807 89.856L39.8369 89.8805C39.535 90.0515 39.2083 90.138 38.8658 90.138C38.1509 90.138 37.4887 89.7523 37.1375 89.1314L10.1076 41.3376C9.57651 40.3985 9.8977 39.2059 10.8216 38.6583L69.6665 8.52828L69.711 8.5053L69.7548 8.48063C70.0566 8.30988 70.3834 8.22329 70.7258 8.22329Z", fill: "#A9AFBF" }),
  /* @__PURE__ */ f.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M54.3409 55.1262C55.438 54.5058 55.824 53.1151 55.2034 52.0178C54.583 50.9207 53.1923 50.5349 52.0953 51.1553L32.3471 62.3239C31.25 62.9443 30.8643 64.335 31.4846 65.4321C32.105 66.5292 33.4957 66.9152 34.5928 66.2948L54.3409 55.1262Z", fill: "#A9AFBF" }),
  /* @__PURE__ */ f.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M51.406 66.7934C52.5031 66.173 52.8891 64.7826 52.2684 63.6853C51.6481 62.5882 50.2574 62.2024 49.1603 62.8228L36.6353 69.9061C35.5382 70.5268 35.1522 71.9175 35.7728 73.0145C36.3932 74.1116 37.7839 74.4976 38.881 73.877L51.406 66.7934Z", fill: "#A9AFBF" }),
  /* @__PURE__ */ f.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M55.6941 74.3757C56.7911 73.7553 57.1771 72.3649 56.5565 71.2675C55.9362 70.1705 54.5455 69.7847 53.4484 70.4051L40.9234 77.4887C39.8263 78.1093 39.4403 79.4997 40.0609 80.5968C40.6813 81.6939 42.072 82.0799 43.1691 81.4593L55.6941 74.3757Z", fill: "#A9AFBF" }),
  /* @__PURE__ */ f.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M77.6194 28.7933L64.5669 36.1751C63.8723 36.5679 62.9822 36.3212 62.5892 35.6264L55.2074 22.5739C54.8146 21.879 55.0615 20.9892 55.7561 20.5962L68.8089 13.2146C69.5035 12.8216 70.3935 13.0685 70.7863 13.7631L78.1681 26.8159C78.5612 27.5105 78.3142 28.4005 77.6194 28.7933Z", fill: "#E42312" }),
  /* @__PURE__ */ f.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M40.7072 27.839H22.5687C21.9007 27.839 21.3594 27.2977 21.3594 26.6297C21.3594 25.9617 21.9007 25.4204 22.5687 25.4204H40.7072C41.3753 25.4204 41.9165 25.9617 41.9165 26.6297C41.9165 27.2977 41.3753 27.839 40.7072 27.839Z", fill: "#E42312" }),
  /* @__PURE__ */ f.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M21.8049 83.8837H3.66633C2.99831 83.8837 2.45703 83.3424 2.45703 82.6744C2.45703 82.0064 2.99831 81.4651 3.66633 81.4651H21.8049C22.4729 81.4651 23.0142 82.0064 23.0142 82.6744C23.0142 83.3424 22.4729 83.8837 21.8049 83.8837Z", fill: "#E42312" }),
  /* @__PURE__ */ f.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M91.6076 84.2067H73.4691C72.801 84.2067 72.2598 83.6654 72.2598 82.9974C72.2598 82.3294 72.801 81.7881 73.4691 81.7881H91.6076C92.2757 81.7881 92.8169 82.3294 92.8169 82.9974C92.8169 83.6654 92.2757 84.2067 91.6076 84.2067Z", fill: "#E42312" }),
  /* @__PURE__ */ f.jsx("mask", { id: "mask1_402_14124", maskUnits: "userSpaceOnUse", x: "1", y: "25", width: "14", height: "3", children: /* @__PURE__ */ f.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M1.69336 25.4204H14.9947V27.839H1.69336V25.4204Z", fill: "white" }) }),
  /* @__PURE__ */ f.jsx("g", { mask: "url(#mask1_402_14124)", children: /* @__PURE__ */ f.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M13.7854 27.839H2.90266C2.23464 27.839 1.69336 27.2977 1.69336 26.6297C1.69336 25.9617 2.23464 25.4204 2.90266 25.4204H13.7854C14.4534 25.4204 14.9947 25.9617 14.9947 26.6297C14.9947 27.2977 14.4534 27.839 13.7854 27.839Z", fill: "#E42312" }) }),
  /* @__PURE__ */ f.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M14.5491 75.2909H3.66633C2.99831 75.2909 2.45703 74.7496 2.45703 74.0816C2.45703 73.4136 2.99831 72.8723 3.66633 72.8723H14.5491C15.2171 72.8723 15.7584 73.4136 15.7584 74.0816C15.7584 74.7496 15.2171 75.2909 14.5491 75.2909Z", fill: "#E42312" }),
  /* @__PURE__ */ f.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M98.9583 75.3595H88.0755C87.4075 75.3595 86.8662 74.8182 86.8662 74.1502C86.8662 73.4822 87.4075 72.9409 88.0755 72.9409H98.9583C99.6263 72.9409 100.168 73.4822 100.168 74.1502C100.168 74.8182 99.6263 75.3595 98.9583 75.3595Z", fill: "#E42312" })
] }), f2 = ({ className: e, ...t }) => /* @__PURE__ */ f.jsx("svg", { width: "32", height: "32", viewBox: "0 0 32 32", fill: "none", xmlns: "http://www.w3.org/2000/svg", className: e, ...t, children: /* @__PURE__ */ f.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8.5 9.5C8.5 13.6421 11.8579 17 16 17C9.64873 17 4.5 22.1487 4.5 28.5C4.5 29.3284 5.17157 30 6 30C6.08518 30 6.1687 29.9929 6.25 29.9793C6.3313 29.9929 6.41482 30 6.5 30H26C26.8284 30 27.5 29.3284 27.5 28.5C27.5 22.1487 22.3513 17 16 17C20.1421 17 23.5 13.6421 23.5 9.5C23.5 5.35786 20.1421 2 16 2C11.8579 2 8.5 5.35786 8.5 9.5ZM24.3681 27C23.6596 23.021 20.1826 20 16 20C11.8174 20 8.3404 23.021 7.63193 27H24.3681ZM20.5 9.5C20.5 11.9853 18.4853 14 16 14C13.5147 14 11.5 11.9853 11.5 9.5C11.5 7.01472 13.5147 5 16 5C18.4853 5 20.5 7.01472 20.5 9.5Z", fill: "#09090A" }) }), m2 = (e) => /* @__PURE__ */ f.jsx("svg", { width: "104", height: "104", viewBox: "0 0 104 104", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e, children: /* @__PURE__ */ f.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M37.4886 71.2934L15.0355 50.9011C14.2361 50.1751 13.0049 50.2147 12.2539 50.9905L7.9128 55.4748C7.1361 56.2771 7.16686 57.5601 7.98113 58.3242L36.3358 84.9348C36.9747 85.5344 37.977 85.5086 38.5842 84.8769L96.1677 24.9716C96.9119 24.1975 96.9119 22.9738 96.1677 22.1996L91.8899 17.7493C91.1032 16.9309 89.7938 16.9306 89.0068 17.7486L37.4886 71.2934Z", fill: "#6FCF97" }) }), Od = (e) => e ? "text-white" : "text-slate-700", Id = (e) => {
  switch (e) {
    case "small":
      return "px-2 py-2";
    case "large":
      return "px-6 py-3";
    default:
      return "px-5 py-2.5";
  }
}, Ad = (e, t) => {
  if (t != null && t.color)
    switch (t.color) {
      case "red":
        return "bg-alpha-red border-alpha-red hover:bg-red-hover active:bg-red-active disabled:bg-grey-lt";
      case "saffron":
        return "bg-alpha-saffron border-alpha-saffron hover:bg-saffron-hover active:bg-saffron-active disabled:bg-grey-lt";
      case "sage":
        return "bg-alpha-sage border-alpha-sage hover:bg-sage-active active:bg-sage-active disabled:bg-grey-lt";
      case "navy":
        return "bg-alpha-navy border-alpha-navy hover:bg-navy-1 active:bg-navy-1-active disabled:bg-grey-lt";
      case "white":
        return "bg-white border-white hover:bg-grey-lt active:bg-grey-lt !text-grey-dk disabled:bg-grey-lt";
      case "grey":
        return "bg-grey-lt border-grey-lt hover:bg-grey-xlt active:bg-grey-lt !text-grey-dk disabled:bg-grey-lt";
    }
  else if (!e)
    return "bg-transparent text-black hover:text-red-hover active:text-red-active disabled:text-grey-lt";
  return "bg-alpha-red border-alpha-red hover:bg-red-hover active:bg-red-active disabled:bg-grey-lt";
}, Pd = (e) => {
  const t = [];
  return e != null && e.fillWidth ? t.push("w-full") : t.push("w-fit"), t.join(" ");
}, Ld = "btn rounded-xl font-bold font-ItcAvantGarde", jd = gn(
  ({
    primary: e = !0,
    disabled: t = !1,
    size: n = "medium",
    label: r,
    className: o,
    children: i,
    options: s,
    ...l
  }, a) => {
    const c = ke(() => {
      const u = Od(e), m = Id(n), d = Ad(e, s), p = Pd(s);
      return [u, m, d, p].join(" ");
    }, [e, n, s]);
    return /* @__PURE__ */ f.jsxs(
      cr,
      {
        type: "button",
        className: [Ld, c, o || ""].join(" "),
        ref: a,
        ...l,
        disabled: t,
        "data-qa-name": l.id ? `button_${l.id}` : r ? `button_${r}` : "button",
        children: [
          i,
          r && /* @__PURE__ */ f.jsx("div", { children: qe(r) })
        ]
      }
    );
  }
);
function Rd(e) {
  return Be({ tag: "svg", attr: { viewBox: "0 0 512 512" }, child: [{ tag: "path", attr: { d: "M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z" } }] })(e);
}
const fs = "flex w-fit text-sm text-grey-dk align-middle items-end", Nd = "w-4 h-4 p-0.5 border border-grey-md rounded items-center inline-flex self-center", Dd = "bg-grey-dk", Td = "bg-white", Fd = "text-white", Md = fs, kd = "mr-2 mt-1 h-5 w-9 appearance-none rounded-xl hover:cursor-pointer before:pointer-events-none before:absolute before:h-3.5 before:w-3.5 before:rounded-full before:bg-transparent before:content-[''] after:absolute after:z-[2] after:mt-0.5 after:h-4 after:w-4 after:rounded-full after:border-none after:bg-white after:transition-[background-color_0.2s,transform_0.2s] after:content-[''] ", Vd = "bg-toggle-navy after:ml-[1.0625rem]", Bd = "bg-toggle-grey after:ml-0.5 ", Hd = (e, t) => {
  switch (t) {
    case "toggle":
      return e ? Vd : Bd;
    case "checkbox":
    default:
      return e ? Dd : Td;
  }
}, $d = (e) => {
  switch (e) {
    case "toggle":
      return Md;
    case "checkbox":
    default:
      return fs;
  }
}, Kd = (e) => {
  switch (e) {
    case "toggle":
      return kd;
    case "checkbox":
    default:
      return Nd;
  }
}, v2 = gn(function({ name: t, text: n, variant: r = "checkbox", boxPosition: o = "before", isRtl: i = !1, className: s, children: l, ...a }, c) {
  const [u, m] = ne(a.defaultChecked ?? !1), [d, p] = ne(!1);
  return /* @__PURE__ */ f.jsxs(
    "label",
    {
      className: [
        $d(r),
        xe(i),
        s || ""
      ].join(" "),
      dir: i ? "rtl" : "ltr",
      "data-checked": u,
      "data-focus-visible": d || void 0,
      children: [
        /* @__PURE__ */ f.jsx(dr, { children: /* @__PURE__ */ f.jsx(
          Yi,
          {
            name: t,
            ref: c,
            clickOnEnter: !0,
            onFocusVisible: () => p(!0),
            onBlur: () => p(!1),
            onChange: (g) => {
              var x;
              m(g.target.checked), (x = a.onChange) == null || x.call(a, g);
            },
            ...a
          }
        ) }),
        o == "before" && /* @__PURE__ */ f.jsx(
          To,
          {
            name: t,
            checked: u,
            boxPosition: o,
            variant: r,
            isRtl: i,
            ...a
          }
        ),
        /* @__PURE__ */ f.jsxs("div", { className: ["font-Avenir text-grey-dk", xe(i)].join(" "), children: [
          l,
          n && qe(n)
        ] }),
        o == "after" && /* @__PURE__ */ f.jsx(
          To,
          {
            name: t,
            checked: u,
            boxPosition: o,
            variant: r,
            isRtl: i,
            ...a
          }
        )
      ]
    }
  );
}), Wd = (e, t = !1) => {
  if (e == "before" && !t || e == "after" && t)
    return "mr-2";
  if (e == "after" && !t || e == "before" && t)
    return "ml-2";
}, To = ({ className: e, variant: t = "checkbox", boxPosition: n = "before", checked: r, isRtl: o = !1, ...i }) => /* @__PURE__ */ f.jsx(
  "div",
  {
    className: [
      Kd(t),
      Hd(r, t),
      xe(o),
      Wd(n, o),
      e || ""
    ].join(" "),
    "data-checked": r,
    "data-qa-name": i.id ? `checkbox_${i.id}` : "checkbox",
    ...i,
    children: t == "checkbox" && r && /* @__PURE__ */ f.jsx(Rd, { className: Fd })
  }
), zd = "flex items-center relative max-w-fit cursor-default justify-between gap-2 font-Avenir", Zd = "z-50 flex flex-col overflow-auto overscroll-contain bg-white rounded border border-widget-light w-full min-w-max p-2 drop-shadow-lg", Ud = gn(
  ({ children: e, value: t, setValue: n, defaultValue: r, onTouch: o, options: i, icon: s = null, ...l }, a) => {
    var d, p, g, x;
    const c = Q(null), u = Zc({ value: t, setValue: n, defaultValue: r }), m = u.useState((h) => h.value || "Select an item");
    return /* @__PURE__ */ f.jsxs(f.Fragment, { children: [
      /* @__PURE__ */ f.jsxs(
        ls,
        {
          store: u,
          ref: a,
          className: [
            zd,
            (d = i == null ? void 0 : i.customClassNames) != null && d.select ? (p = i == null ? void 0 : i.customClassNames) == null ? void 0 : p.select : "",
            l.className ? l.className : ""
          ].join(" "),
          value: m,
          onBlur: (h) => {
            var S;
            if ((S = l.onBlur) == null || S.call(l, h), h.defaultPrevented)
              return;
            const b = u.getState().popoverElement;
            b != null && b.contains(h.relatedTarget) || o == null || o();
          },
          "data-qa-name": l.id ? `select_item_${l.name}` : "select_item",
          ...l,
          children: [
            s !== null && s,
            !(i != null && i.hideDefaultValue) && m,
            /* @__PURE__ */ f.jsx(Rr, { className: [
              i != null && i.hideCaratOnSmallScreen ? "hidden sm:block mr-2" : ""
            ].join(" ") })
          ]
        }
      ),
      /* @__PURE__ */ f.jsx(
        as,
        {
          store: u,
          modal: !0,
          gutter: 4,
          portalRef: c,
          className: [
            Zd,
            (g = i == null ? void 0 : i.customClassNames) != null && g.popover ? (x = i == null ? void 0 : i.customClassNames) == null ? void 0 : x.popover : ""
          ].join(" "),
          onBlur: (h) => {
            const b = c.current, S = u.getState().disclosureElement;
            b != null && b.contains(h.relatedTarget) || S != null && S.contains(h.relatedTarget) || o == null || o();
          },
          "data-qa-name": l.id ? `select_popover_${l.name}` : "select_popover",
          children: e
        }
      )
    ] });
  }
), qd = "flex items-center px-2 py-1 cursor-default hover:bg-widget-light rounded-sm font-Avenir aria-selected:font-bold aria-selected:bg-red-50 text-sm", Gd = gn(({ className: e, ...t }, n) => /* @__PURE__ */ f.jsx(
  is,
  {
    ref: n,
    className: [
      qd,
      e || ""
    ].join(" "),
    ...t
  }
)), Yd = (e) => {
  switch (e) {
    case "blur":
      return "backdrop-blur";
    case "transparent":
      return "bg-transparent";
    default:
      return "bg-gray-200";
  }
}, Xd = "fixed top-0 w-screen flex h-full z-50", Jd = "max-w-lg min-w-[20em] md:min-w-[35em] rounded overflow-hidden m-auto bg-white p-5", p2 = ({ show: e, options: t, className: n, children: r, ...o }) => {
  const i = Yd(t == null ? void 0 : t.backgroundEffect), s = Rl();
  return q(() => {
    e && s.show(), e || s.hide();
  }, [e]), /* @__PURE__ */ f.jsx(
    Ei,
    {
      store: s,
      className: [Xd, i].join(" "),
      ...o,
      "data-qa-name": o.id ? `modal_${o.id}` : "modal",
      children: /* @__PURE__ */ f.jsx("div", { className: [Jd, n, t != null && t.backgroundEffect ? "border border-gray-200" : ""].join(" "), children: r })
    }
  );
}, g2 = ({ children: e, ...t }) => /* @__PURE__ */ f.jsx(vi, { ...t, "data-qa-name": t.id ? `modalheading_${t.id}` : "modalheading", children: e }), h2 = ({ children: e, ...t }) => /* @__PURE__ */ f.jsx(
  fi,
  {
    as: jd,
    ...t,
    "data-qa-name": t.id ? `modaldismiss_${t.id}` : "modaldismiss",
    children: e
  }
), Qd = "flex flex-row items-center", ef = "mr-4", tf = "flex-grow text-lg", b2 = ({ imageUrl: e, userName: t, options: n, className: r, ...o }) => {
  var i, s, l, a, c, u;
  return /* @__PURE__ */ f.jsxs(
    "div",
    {
      className: [
        Qd,
        (i = n == null ? void 0 : n.customClassNames) != null && i.card ? (s = n == null ? void 0 : n.customClassNames) == null ? void 0 : s.card : "",
        r || ""
      ].join(" "),
      ...o,
      children: [
        /* @__PURE__ */ f.jsx("div", { id: "avatar_image", className: [
          ef,
          (l = n == null ? void 0 : n.customClassNames) != null && l.image ? (a = n == null ? void 0 : n.customClassNames) == null ? void 0 : a.image : ""
        ].join(" "), children: e ? /* @__PURE__ */ f.jsx("img", { src: e }) : /* @__PURE__ */ f.jsx(nf, {}) }),
        /* @__PURE__ */ f.jsx("div", { id: "account_name", className: [
          tf,
          (c = n == null ? void 0 : n.customClassNames) != null && c.username ? (u = n == null ? void 0 : n.customClassNames) == null ? void 0 : u.username : ""
        ].join(" "), children: /* @__PURE__ */ f.jsx("h2", { children: t }) })
      ]
    }
  );
}, nf = () => /* @__PURE__ */ f.jsxs("svg", { width: "80", height: "80", viewBox: "0 0 80 80", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
  /* @__PURE__ */ f.jsx("mask", { id: "mask0_457_6027", maskUnits: "userSpaceOnUse", x: "0", y: "0", width: "80", height: "80", children: /* @__PURE__ */ f.jsx("circle", { cx: "40", cy: "40", r: "40", fill: "#BFC3B9" }) }),
  /* @__PURE__ */ f.jsxs("g", { mask: "url(#mask0_457_6027)", children: [
    /* @__PURE__ */ f.jsx("circle", { cx: "40", cy: "40", r: "40", fill: "#575F4A" }),
    /* @__PURE__ */ f.jsx("path", { d: "M0 13H8C16.8366 13 24 20.1634 24 29V78H0V13Z", fill: "#FCDDA5" }),
    /* @__PURE__ */ f.jsx("path", { d: "M46 55.5C46 67.3741 36.1503 77 24 77C24 77 24 66.3317 24 54.4576C24 42.5835 24 34 24 34C36.1503 34 46 43.6259 46 55.5Z", fill: "#27375E" }),
    /* @__PURE__ */ f.jsx("circle", { cx: "73.5", cy: "31.5", r: "21.5", fill: "#FAD3D0" })
  ] })
] }), rf = "", of = (e) => {
  switch (e) {
    case "horizontal":
      return "w-full lg:max-w-full lg:flex";
    case "stacked":
    default:
      return "max-w-sm rounded overflow-hidden";
  }
}, x2 = ({ mode: e = "stacked", ...t }) => /* @__PURE__ */ f.jsx("div", { className: [rf, of(e), t.className].join(" "), children: t.children }), sf = "border-box w-screen min-h-screen mx-0 my-0 bg-gradient-to-t from-gradient-bg-start to-gradient-bg-end-2", S2 = ({ className: e, children: t }) => /* @__PURE__ */ f.jsx("div", { className: [sf, e].join(" "), children: t }), af = "flex flex-row text-sm font-Avenir text-grey-dk bg-alert-blue rounded p-4 content-start", lf = "text-azure text-base mt-0.5", C2 = ({ isRtl: e = !1, children: t, className: n, ...r }) => /* @__PURE__ */ f.jsxs(
  "div",
  {
    className: [
      af,
      n || ""
    ].join(" "),
    dir: e ? "rtl" : "ltr",
    ...r,
    children: [
      /* @__PURE__ */ f.jsx(fd, { className: [
        lf,
        xe(e),
        e ? "ml-2" : "mr-2"
      ].join(" ") }),
      /* @__PURE__ */ f.jsx("div", { children: t })
    ]
  }
), uf = "appearance-none border rounded w-full py-2 px-8 text-grey-dk leading-tight focus:outline-none focus:shadow-outline bg-white aria-invalid:border-alpha-red", cf = "relative ml-2 top-7 float-left text-xl max-w-fit", df = "relative mr-2 bottom-7 float-right text-grey-md text-xl max-w-fit", ff = ({ isRtl: e = !1, icon: t = null, className: n, ...r }) => /* @__PURE__ */ f.jsxs(f.Fragment, { children: [
  t && !e && /* @__PURE__ */ f.jsx("span", { className: cf, children: t }),
  /* @__PURE__ */ f.jsx(
    "input",
    {
      ...r,
      className: [
        uf,
        xe(e),
        n || "",
        t ? "px-10" : ""
      ].join(" "),
      "data-qa-name": r.id ?? `input_${r.name}`
    }
  ),
  t && e && /* @__PURE__ */ f.jsx("span", { className: df, children: t })
] }), mf = (e) => Object.keys(e).map((t) => qe(e[t].Text)), vf = (e) => {
  const t = Object.keys(e).find((n) => e[n].Selected);
  return t ? qe(e[t].Text) : "";
}, pf = "flex flex-row gap-2 w-fit", gf = "border bordergrey-lt rounded-xl", hf = "p-2 h-full w-10 block", bf = "sm:border-r", xf = "sm:flex overflow-hidden", E2 = ({ cultures: e, returnUrl: t, onSelectCallback: n = null, filtered: r = !1, isRtl: o = !1, options: i, className: s, ...l }) => {
  var w, A, y;
  const a = mf(e), c = vf(e), u = ns({ defaultValues: { language: c } }), m = u.useValue(u.names.language), [d, p] = ne(a), [g, x] = ne(""), h = (I) => {
    I.persist();
    const O = I.target.value;
    x(O), b(O);
  }, b = (I) => {
    const O = a.filter((_) => _.toLowerCase().includes(I.toLowerCase()));
    p(O);
  }, S = () => {
    x(""), p(a);
  };
  return q(() => {
    if (m === c)
      return;
    const I = Cf(e, m);
    if (I) {
      if (n !== null)
        n(e[I].Value);
      else {
        const O = new RegExp("(ui_locales%3d)(.)+(?=%26)"), _ = qe(t).replace(O, `ui_locales%3d${e[I].Value}`);
        window.location.replace(_);
      }
      S();
    }
  }, [m]), /* @__PURE__ */ f.jsx(
    Ar,
    {
      store: u,
      className: [
        pf,
        s || "",
        i != null && i.border ? gf : "",
        (w = i == null ? void 0 : i.customClasses) != null && w.form ? i.customClasses.form : ""
      ].join(" "),
      ...l,
      children: /* @__PURE__ */ f.jsxs(
        Gi,
        {
          as: Ud,
          name: u.names.language,
          icon: i != null && i.showIcon ? /* @__PURE__ */ f.jsx(Sf, { options: i, selectedLanguage: c }) : null,
          value: m,
          setValue: (I) => u.setValue(u.names.language, I),
          touchOnBlur: !1,
          onTouch: () => u.setFieldTouched(u.names.language, !0),
          options: {
            // If you show the con, let the Icon component handle the display exclusively
            hideDefaultValue: i == null ? void 0 : i.showIcon,
            hideCaratOnSmallScreen: i == null ? void 0 : i.showIcon,
            customClassNames: {
              select: [
                xf,
                i != null && i.border && !(i != null && i.showIcon) ? "p-2 sm:px-4 sm:py-2" : "",
                // if there's no Icon, the border needs some default padding
                (A = i == null ? void 0 : i.customClasses) != null && A.select ? i.customClasses.select : ""
              ].join(" "),
              popover: [
                (y = i == null ? void 0 : i.customClasses) != null && y.popover ? i.customClasses.popover : ""
              ].join(" ")
            }
          },
          children: [
            r && /* @__PURE__ */ f.jsx(
              ff,
              {
                id: "filterSearch",
                onChange: h,
                value: g,
                icon: /* @__PURE__ */ f.jsx(Qc, {}),
                className: "mb-2",
                isRtl: o
              }
            ),
            /* @__PURE__ */ f.jsx("div", { className: "overflow-x-scroll", children: d.map((I) => /* @__PURE__ */ f.jsx(Gd, { value: I, className: "px-2 py-1 hover:bg-grey-lt" }, I)) })
          ]
        }
      )
    }
  );
}, Sf = ({ options: e = void 0, selectedLanguage: t, ...n }) => /* @__PURE__ */ f.jsxs(f.Fragment, { children: [
  /* @__PURE__ */ f.jsx(
    _d,
    {
      className: [
        hf,
        e != null && e.border ? bf : ""
      ].join(" "),
      ...n
    }
  ),
  /* @__PURE__ */ f.jsx("span", { className: "hidden sm:flex", children: t })
] }), Cf = (e, t) => Object.keys(e).find((n) => qe(e[n].Text) === t), Ef = (e) => {
  if (!(e != null && e.color))
    return "border-alpha-red";
  switch (e.color) {
    case "saffron":
      return "border-alpha-saffron";
    case "sage":
      return "border-alpha-sage";
    case "navy":
      return "border-alpha-navy";
    case "white":
      return "border-white";
    case "grey":
      return "border-grey-lt";
    case "red":
    default:
      return "border-alpha-red";
  }
}, yf = "inline-block h-12 w-12 animate-spin rounded-full border-4 border-solid border-r-transparent align-[-0.125em] motion-reduce:animate-[spin_1.5s_linear_infinite]", y2 = ({ className: e, options: t = {}, ...n }) => /* @__PURE__ */ f.jsx(
  "div",
  {
    className: [
      yf,
      e,
      Ef(t)
    ].join(" "),
    role: "status",
    ...n,
    children: /* @__PURE__ */ f.jsx(
      "span",
      {
        className: "!absolute !-m-px !h-px !w-px !overflow-hidden !whitespace-nowrap !border-0 !p-0 ![clip:rect(0,0,0,0)]",
        children: "Loading..."
      }
    )
  }
), wf = "flex flex-col self-center w-full lg:max-w-6xl lg:p-8 p-4 mt-32", w2 = ({ className: e, children: t, ...n }) => /* @__PURE__ */ f.jsx(
  "div",
  {
    className: [
      wf,
      e || ""
    ].join(" "),
    "data-qa-name": n.id ? `page_${n.id}` : "page",
    ...n,
    children: t
  }
), _f = (e) => e === "bottom" ? "fixed max-md:relative bottom-0" : "fixed top-0", Of = "sm:px-11 px-3 py-5 w-full m-0 max-w-none flex flex-row justify-between items-center", _2 = ({ position: e, shadow: t = !1, className: n, children: r }) => /* @__PURE__ */ f.jsx("div", { className: [
  Of,
  t ? "shadow-lg" : "",
  e ? _f(e) : "",
  n || ""
].join(" "), children: r });
var If = /* @__PURE__ */ ((e) => (e.Google = "google", e.Apple = "apple", e))(If || {});
const Af = (e) => {
  switch (e) {
    case "apple":
      return "";
    case "google":
    default:
      return "";
  }
}, Pf = (e) => {
  switch (e) {
    case "apple":
      return /* @__PURE__ */ f.jsx(cd, { className: Fo });
    case "google":
    default:
      return /* @__PURE__ */ f.jsx(dd, { className: Fo });
  }
}, Lf = (e) => {
  const t = [];
  return e != null && e.fillWidth && t.push("w-full"), t.join(" ");
}, jf = "btn bg-white rounded-md shadow px-4 py-2 font-Avenir text-xs text-grey-md flex flex-row align-middle items-center justify-center", Fo = "text-lg mr-4", O2 = ({ variant: e, options: t, className: n, ...r }) => {
  const o = ke(() => {
    const i = Af(e), s = Lf(t);
    return [i, s].join(" ");
  }, [e, t]);
  return /* @__PURE__ */ f.jsxs(
    cr,
    {
      className: [jf, o, n].join(" "),
      ...r,
      "data-qa-name": r.id ?? `button_${e}`,
      children: [
        Pf(e),
        r.children
      ]
    }
  );
}, Rf = (e, t, n) => {
  if (!t)
    switch (n) {
      case "explore":
        t = "medium";
        break;
      case "find":
        t = "light";
        break;
      case "help":
        t = "extralight";
        break;
      case "signup":
      case "login":
      default:
        t = "primary";
        break;
    }
  switch (t) {
    case "medium":
      return `bg-${e}-2 active:bg-${e}-2-active hover: bg-${e}-2-active text-white`;
    case "light":
      return `bg-${e}-3 active:bg-${e}-3-active hover: bg-${e}-3-active text-${e}-1`;
    case "extralight":
      return `bg-${e}-4 active:bg-${e}-4-active hover: bg-${e}-4-active text-${e}-1`;
    case "primary":
    default:
      return `bg-${e}-1 active:bg-${e}-1-active hover: bg-${e}-1-active text-white`;
  }
}, Nf = (e) => `flex-${e}`, Df = "flex rounded-lg overflow-hidden px-6 py-4 text-sm m-auto items-center justify-center text-center max-w-xs mb-4 w-full max-w-sm", Tf = "bg-navy-1 active:bg-navy-1-active bg-navy-2 active:bg-navy-2-active bg-navy-3 active:bg-navy-3-active bg-navy-4 active:bg-navy-4-active", Ff = "bg-sage-1 active:bg-sage-1-active bg-sage-2 active:bg-sage-2-active bg-sage-3 active:bg-sage-3-active bg-sage-4 active:bg-sage-4-active", I2 = ({ color: e, type: t, flexDirection: n = "col", title: r, shade: o, isRtl: i = !1, children: s, className: l, ...a }) => /* @__PURE__ */ f.jsxs("div", { className: [Df, Nf(n), Rf(e, o, t), l].join(" "), ...a, children: [
  t === "signup" && /* @__PURE__ */ f.jsx(Mf, {}),
  t === "login" && /* @__PURE__ */ f.jsx(kf, {}),
  t === "explore" && /* @__PURE__ */ f.jsx(Vf, {}),
  !i && t === "find" && /* @__PURE__ */ f.jsx(Mo, {}),
  r && /* @__PURE__ */ f.jsx("h2", { className: "text-2xl font-ItcAvantGarde mb-4", children: r }),
  s,
  i && t === "find" && /* @__PURE__ */ f.jsx(Mo, {}),
  /* @__PURE__ */ f.jsx("span", { className: [Tf, Ff].join(" "), style: { display: "none" } })
] }), Mf = () => /* @__PURE__ */ f.jsxs("svg", { width: "90", height: "90", viewBox: "0 0 90 90", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
  /* @__PURE__ */ f.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M80.9789 66.1607C80.9789 68.3467 64.9109 70.1163 45.0955 70.1163C25.2774 70.1163 9.20935 68.344 9.20935 66.1607C9.20935 63.9747 25.2774 62.2051 45.0955 62.2051C64.9136 62.2051 80.9789 63.9747 80.9789 66.1607Z", fill: "#B0B4A8" }),
  /* @__PURE__ */ f.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M71.4662 66.1074H17.0112C16.2425 66.1074 15.6125 65.4775 15.6125 64.7088V27.2399C15.6125 26.4712 16.2425 25.8413 17.0112 25.8413H71.4662C72.2349 25.8413 72.8648 26.4712 72.8648 27.2399V64.7088C72.8648 65.4775 72.2349 66.1074 71.4662 66.1074Z", fill: "#EFF0EE" }),
  /* @__PURE__ */ f.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M39.6986 36.7097C39.6986 39.5123 37.4272 41.7837 34.6246 41.7837C31.8221 41.7837 29.5507 39.5123 29.5507 36.7097C29.5507 33.9072 31.8221 31.6357 34.6246 31.6357C37.4272 31.6384 39.6986 33.9098 39.6986 36.7097Z", fill: "#E42312" }),
  /* @__PURE__ */ f.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M44.5216 55.8553H24.7275C24.7275 55.8553 24.7115 43.7375 34.6246 43.7375C44.5216 43.7375 44.5216 55.8553 44.5216 55.8553Z", fill: "#E42312" }),
  /* @__PURE__ */ f.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M67.7242 36.7125H49.5369C48.7575 36.7125 48.1169 36.0746 48.1169 35.2925V35.1324C48.1169 34.353 48.7549 33.7124 49.5369 33.7124H67.7242C68.5036 33.7124 69.1441 34.3503 69.1441 35.1324V35.2925C69.1441 36.0719 68.5062 36.7125 67.7242 36.7125Z", fill: "#E42312" }),
  /* @__PURE__ */ f.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M67.7242 41.8851H49.5369C48.7575 41.8851 48.1169 41.2472 48.1169 40.4651V40.305C48.1169 39.5256 48.7549 38.885 49.5369 38.885H67.7242C68.5036 38.885 69.1441 39.5229 69.1441 40.305V40.4651C69.1441 41.2472 68.5062 41.8851 67.7242 41.8851Z", fill: "#E42312" }),
  /* @__PURE__ */ f.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M67.7242 47.1058H49.5369C48.7575 47.1058 48.1169 46.4679 48.1169 45.6858V45.5257C48.1169 44.7463 48.7549 44.1057 49.5369 44.1057H67.7242C68.5036 44.1057 69.1441 44.7436 69.1441 45.5257V45.6858C69.1441 46.4679 68.5062 47.1058 67.7242 47.1058Z", fill: "#E42312" }),
  /* @__PURE__ */ f.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M47.6445 50.0127H39.4503C39.1887 50.0127 38.9752 50.341 38.9752 50.744V58.423C38.9752 58.8261 39.1887 59.1544 39.4503 59.1544H47.6445C47.906 59.1544 48.1196 58.8261 48.1196 58.423V56.8776V54.4274V50.744C48.1196 50.3383 47.906 50.0127 47.6445 50.0127Z", fill: "#606951" }),
  /* @__PURE__ */ f.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M45.6641 54.099H44.0332V52.4682C44.0332 52.2013 43.817 51.9824 43.5501 51.9824C43.2832 51.9824 43.0644 52.1986 43.0644 52.4682V54.099H41.4335C41.1666 54.099 40.9478 54.3152 40.9478 54.5848C40.9478 54.8517 41.164 55.0679 41.4335 55.0679H43.0644V56.6987C43.0644 56.9656 43.2806 57.1818 43.5501 57.1818C43.817 57.1818 44.0332 56.9656 44.0332 56.6987V55.0679H45.6641C45.931 55.0679 46.1472 54.8517 46.1472 54.5848C46.1472 54.3152 45.931 54.099 45.6641 54.099Z", fill: "#EFF0EE" }),
  /* @__PURE__ */ f.jsx("path", { d: "M15.6125 21.1062V64.8822C15.6125 65.5575 16.1597 66.1047 16.835 66.1047H72.8648C73.5401 66.1047 74.0873 65.5575 74.0873 64.8822V21.1062C74.0873 20.431 73.5401 19.8838 72.8648 19.8838H16.8377C16.1597 19.8811 15.6125 20.431 15.6125 21.1062ZM24.885 22.1339C25.3494 21.6694 26.0781 21.6694 26.5399 22.1339C26.7374 22.3314 26.8708 22.665 26.8708 22.9292C26.8708 23.1935 26.7374 23.5245 26.5399 23.7246C26.3424 23.9248 26.0087 24.0556 25.6777 24.0556C25.3468 24.0556 25.0825 23.9222 24.8823 23.7246C24.6822 23.5271 24.5514 23.1935 24.5514 22.9292C24.5514 22.665 24.6848 22.3314 24.885 22.1339ZM21.5727 22.1339C22.0371 21.6694 22.7657 21.6694 23.2275 22.1339C23.425 22.3314 23.5585 22.665 23.5585 22.9292C23.5585 23.1935 23.425 23.5245 23.2275 23.7246C23.03 23.9222 22.6964 24.0556 22.4321 24.0556C22.1011 24.0556 21.8369 23.9222 21.6367 23.7246C21.4365 23.5271 21.3057 23.1935 21.3057 22.9292C21.3057 22.665 21.3751 22.3314 21.5727 22.1339ZM18.1962 22.1339C18.6607 21.6694 19.3893 21.6694 19.8511 22.1339C20.0486 22.3314 20.1821 22.665 20.1821 22.9292C20.1821 23.1935 20.0486 23.5245 19.8511 23.7246C19.6536 23.9248 19.3199 24.0556 19.0557 24.0556C18.9409 24.0556 18.8342 24.0396 18.7354 24.0102C18.303 23.8875 17.9587 23.5378 17.8786 23.0947C17.8679 23.0387 17.8626 22.9826 17.8626 22.9292C17.8653 22.665 17.9961 22.3314 18.1962 22.1339ZM71.2767 64.2523H18.5592C17.884 64.2523 17.3368 63.7051 17.3368 63.0299V27.0664C17.3368 26.3911 17.884 25.8439 18.5592 25.8439H71.2767C71.952 25.8439 72.4992 26.3911 72.4992 27.0664V63.0299C72.4992 63.7051 71.952 64.2523 71.2767 64.2523Z", fill: "#909685" })
] }), kf = () => /* @__PURE__ */ f.jsxs("svg", { width: "90", height: "90", viewBox: "0 0 90 90", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
  /* @__PURE__ */ f.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M80.9789 66.1607C80.9789 68.3467 64.9109 70.1163 45.0955 70.1163C25.2774 70.1163 9.20935 68.344 9.20935 66.1607C9.20935 63.9747 25.2774 62.2051 45.0955 62.2051C64.9136 62.2024 80.9789 63.9747 80.9789 66.1607Z", fill: "#939BAF" }),
  /* @__PURE__ */ f.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M72.6175 66.1395H17.1734C16.362 66.1395 15.6978 65.4418 15.6978 64.5897V21.4336C15.6978 20.5815 16.362 19.8837 17.1734 19.8837H72.6175C73.4288 19.8837 74.0931 20.5815 74.0931 21.4336V64.5897C74.0958 65.4418 73.4315 66.1395 72.6175 66.1395Z", fill: "#E9EBEF" }),
  /* @__PURE__ */ f.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M49.9246 34.167C49.9246 36.9695 47.6531 39.241 44.8506 39.241C42.048 39.241 39.7766 36.9695 39.7766 34.167C39.7766 31.3644 42.048 29.093 44.8506 29.093C47.6531 29.093 49.9246 31.3644 49.9246 34.167Z", fill: "#E42312" }),
  /* @__PURE__ */ f.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M54.7476 53.3098H34.9535C34.9535 53.3098 34.9375 41.1921 44.8505 41.1921C54.7476 41.1947 54.7476 53.3098 54.7476 53.3098Z", fill: "#E42312" }),
  /* @__PURE__ */ f.jsx("rect", { x: "29.7209", y: "51.6977", width: "30.1395", height: "7.11628", rx: "1", fill: "#27375E" }),
  /* @__PURE__ */ f.jsx("path", { d: "M39.7019 54.7033L40.8321 54.3349L41.0498 55.0047L39.9112 55.3731L40.6312 56.3526L40.0535 56.7712L39.3335 55.7833L38.6302 56.7461L38.0693 56.3191L38.7893 55.3731L37.6423 54.9796L37.86 54.3098L38.9986 54.7033V53.5145H39.7019V54.7033Z", fill: "#E9EBEF" }),
  /* @__PURE__ */ f.jsx("path", { d: "M45.6703 54.7033L46.8005 54.3349L47.0182 55.0047L45.8796 55.3731L46.5996 56.3526L46.0219 56.7712L45.3019 55.7833L44.5986 56.7461L44.0377 56.3191L44.7577 55.3731L43.6107 54.9796L43.8284 54.3098L44.967 54.7033V53.5145H45.6703V54.7033Z", fill: "#E9EBEF" }),
  /* @__PURE__ */ f.jsx("path", { d: "M51.6386 54.7033L52.7689 54.3349L52.9865 55.0047L51.8479 55.3731L52.5679 56.3526L51.9903 56.7712L51.2703 55.7833L50.567 56.7461L50.0061 56.3191L50.7261 55.3731L49.5791 54.9796L49.7968 54.3098L50.9354 54.7033V53.5145H51.6386V54.7033Z", fill: "#E9EBEF" }),
  /* @__PURE__ */ f.jsx("path", { d: "M15.6978 21.1062V64.8822C15.6978 65.5575 16.2449 66.1046 16.9202 66.1046H72.95C73.6253 66.1046 74.1725 65.5575 74.1725 64.8822V21.1062C74.1725 20.4309 73.6253 19.8837 72.95 19.8837H16.9202C16.2449 19.8811 15.6978 20.4282 15.6978 21.1062ZM24.9676 22.1338C25.432 21.6694 26.1606 21.6694 26.6224 22.1338C26.8199 22.3313 26.9534 22.6649 26.9534 22.9292C26.9534 23.1934 26.8199 23.5244 26.6224 23.7246C26.4249 23.9221 26.0912 24.0555 25.7603 24.0555C25.4293 24.0555 25.1651 23.9221 24.9649 23.7246C24.7647 23.5271 24.6339 23.1934 24.6339 22.9292C24.6339 22.6649 24.77 22.3313 24.9676 22.1338ZM21.6579 22.1338C22.1223 21.6694 22.851 21.6694 23.3127 22.1338C23.5102 22.3313 23.6437 22.6649 23.6437 22.9292C23.6437 23.1934 23.5102 23.5244 23.3127 23.7246C23.1152 23.9221 22.7816 24.0555 22.5173 24.0555C22.1863 24.0555 21.9221 23.9221 21.7219 23.7246C21.5244 23.5271 21.3909 23.1934 21.3909 22.9292C21.3909 22.6649 21.4577 22.3313 21.6579 22.1338ZM18.2814 22.1338C18.7459 21.6694 19.4745 21.6694 19.9363 22.1338C20.1338 22.3313 20.2673 22.6649 20.2673 22.9292C20.2673 23.1934 20.1338 23.5244 19.9363 23.7246C19.7388 23.9221 19.4051 24.0555 19.1409 24.0555C19.0261 24.0555 18.9194 24.0395 18.8206 24.0102C18.3882 23.8874 18.0439 23.5377 17.9638 23.0947C17.9531 23.0386 17.9478 22.9826 17.9478 22.9292C17.9478 22.6623 18.0813 22.3313 18.2814 22.1338ZM71.3593 64.2523H18.6418C17.9665 64.2523 17.4193 63.7051 17.4193 63.0298V27.0636C17.4193 26.3883 17.9665 25.8412 18.6418 25.8412H71.3593C72.0345 25.8412 72.5817 26.3883 72.5817 27.0636V63.0271C72.5844 63.7024 72.0372 64.2523 71.3593 64.2523Z", fill: "#68738E" })
] }), Vf = () => /* @__PURE__ */ f.jsx("svg", { width: "32", height: "32", viewBox: "0 0 32 32", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ f.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M29.7936 3.61639C25.6887 1.58798 20.7346 1.44309 16.4881 3.32662C12.2417 1.44309 7.28754 1.58798 3.18266 3.61639L2.33337 4.05105V28.7739C2.33337 29.7915 3.40915 30.4494 4.31504 29.9858C7.85373 28.2472 12.2417 28.2472 15.7804 29.9858L16.3466 30.2756L16.9128 29.9858C20.4515 28.2472 24.8394 28.2472 28.3781 29.9858C29.4417 30.4621 30.6429 29.6839 30.6429 28.5185V4.05105L29.7936 3.61639ZM18.9286 5.40909C19.2907 5.36092 19.6345 5.29573 19.973 5.23156C20.5926 5.11408 21.1943 5 21.8572 5V11L20.3929 10.1818L18.9286 11V5.40909ZM16.4881 27C19.9963 25.4338 24.0658 25.2915 27.7143 26.4305V5.92813C26.8724 5.64337 25.8901 5.35862 24.9078 5.21624V16.4641L20.698 13.9013L16.4881 16.4641V6.64002L15.9268 6.21288C12.559 4.64673 8.6298 4.64673 5.26195 5.92813V26.4305C6.80555 26.0034 8.48947 25.7186 10.1734 25.7186C12.2783 25.7186 14.5236 26.1457 16.4881 27Z", fill: "#FDFCFB" }) }), Mo = () => /* @__PURE__ */ f.jsxs("svg", { width: "48", height: "48", viewBox: "0 0 48 48", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
  /* @__PURE__ */ f.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M45.9762 43.8942C45.9762 45.3029 36.1589 46.4451 24.0486 46.4451C11.9383 46.4451 2.12097 45.3029 2.12097 43.8942C2.12097 42.4853 11.9383 41.3433 24.0486 41.3433C36.1589 41.3433 45.9762 42.4853 45.9762 43.8942Z", fill: "#A9AFBF" }),
  /* @__PURE__ */ f.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M13.0329 10.3275C13.0329 7.38383 10.6467 4.99756 7.70307 4.99756C4.75944 4.99756 2.37317 7.38383 2.37317 10.3275C2.37317 12.7187 3.94802 14.7422 6.11717 15.4174L7.70295 18.6338L9.28885 15.4174C11.458 14.7422 13.0329 12.7187 13.0329 10.3275Z", fill: "#E42312" }),
  /* @__PURE__ */ f.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M44.8844 23.1701C44.8844 34.6774 35.5558 44.0059 24.0486 44.0059C12.5413 44.0059 3.21277 34.6774 3.21277 23.1701C3.21277 11.6629 12.5413 2.33435 24.0486 2.33435C35.5558 2.33435 44.8844 11.6629 44.8844 23.1701Z", fill: "#7D879E" }),
  /* @__PURE__ */ f.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M44.8844 23.1701C44.8844 34.6774 35.5558 44.0059 24.0486 44.0059C12.5413 44.0059 3.21277 34.6774 3.21277 23.1701C3.21277 11.6629 12.5413 2.33435 24.0486 2.33435C35.5558 2.33435 44.8844 11.6629 44.8844 23.1701Z", fill: "#7D879E" }),
  /* @__PURE__ */ f.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M28.2374 2.75562L27.2392 5.09344L24.0486 8.70315L28.4392 19.454L33.0374 21.2055L32.9044 23.8418L36.0323 26.6001H38.4621L41.0202 31.7723L41.8943 33.9295C43.7919 30.7888 44.8844 27.1071 44.8844 23.1701C44.8844 13.0975 37.7371 4.69448 28.2374 2.75562Z", fill: "#27375E" }),
  /* @__PURE__ */ f.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10.8816 31.7723V28.7962L16.7057 25.6918V22.6921L13.1753 19.4539L11.9489 14.3891L5.93124 12.874C4.20157 15.9111 3.21277 19.425 3.21277 23.17C3.21277 34.6773 12.5413 44.0058 24.0487 44.0058C24.367 44.0058 24.6835 43.9976 24.9985 43.9834L27.2393 35.8383L22.1271 31.7723H10.8816Z", fill: "#27375E" }),
  /* @__PURE__ */ f.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M44.2069 6.78096C44.2069 3.83744 41.8207 1.45117 38.877 1.45117C35.9335 1.45117 33.5472 3.83744 33.5472 6.78096C33.5472 9.17236 35.1221 11.1958 37.2912 11.8709L38.877 15.0874L40.4629 11.8709C42.6321 11.1958 44.2069 9.17236 44.2069 6.78096Z", fill: "#E42312" }),
  /* @__PURE__ */ f.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M40.7551 6.78098C40.7551 7.81823 39.9143 8.65901 38.8771 8.65901C37.8398 8.65901 36.999 7.81823 36.999 6.78098C36.999 5.74374 37.8398 4.90295 38.8771 4.90295C39.9143 4.90295 40.7551 5.74374 40.7551 6.78098Z", fill: "#FDFCFB" }),
  /* @__PURE__ */ f.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M28.2069 29.1065C28.2069 26.163 25.8207 23.7767 22.877 23.7767C19.9335 23.7767 17.5472 26.163 17.5472 29.1065C17.5472 31.4979 19.1221 33.5214 21.2912 34.1964L22.877 37.413L24.4629 34.1964C26.6321 33.5214 28.2069 31.4979 28.2069 29.1065Z", fill: "#E42312" }),
  /* @__PURE__ */ f.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M24.7552 29.1065C24.7552 30.1438 23.9143 30.9846 22.8771 30.9846C21.8399 30.9846 20.999 30.1438 20.999 29.1065C20.999 28.0693 21.8399 27.2285 22.8771 27.2285C23.9143 27.2285 24.7552 28.0693 24.7552 29.1065Z", fill: "#FDFCFB" })
] }), Bf = "flex justify-center items-top", Hf = "flex flex-col gap-2 items-center disabled:pointer-events-none w-8 mb-4", $f = "w-8 h-8 pt-[0.18rem] box-border border-solid rounded-full text-lg font-bold flex justify-center items-center z-10", Kf = "text-xs font-bold -mx-2 sm:-mx-6", Wf = "mt-[0.95rem] -mx-0.5 z-0 block border-t-[3px] w-10 sm:w-20 border-solid", A2 = ({
  currentStepId: e,
  steps: t = [],
  isRtl: n = !1,
  ...r
}) => {
  var u, m, d;
  const o = os({ defaultSelectedId: e }), i = o.useState().activeId, s = {
    canClickForward: ((u = r.options) == null ? void 0 : u.canClickForward) ?? !1,
    canClickBack: ((m = r.options) == null ? void 0 : m.canClickBack) ?? !1,
    showCompleteCheck: ((d = r.options) == null ? void 0 : d.showCompleteCheck) ?? !1
  }, l = (p) => t.findIndex((g) => g.id === i) > t.findIndex((g) => g.id === p), a = (p) => p === i, c = (p) => t.findIndex((g) => g.id === i) < t.findIndex((g) => g.id === p);
  return q(() => {
    o.setActiveId(e), o.setSelectedId(e);
  }, [e, o]), /* @__PURE__ */ f.jsxs("div", { ...r, children: [
    /* @__PURE__ */ f.jsx(
      Pr,
      {
        store: o,
        "aria-label": "Stepper",
        className: [
          Bf,
          n ? "flex-row-reverse" : "flex-row",
          xe(n)
        ].join(" "),
        children: t.map((p, g) => /* @__PURE__ */ f.jsxs(f.Fragment, { children: [
          /* @__PURE__ */ f.jsxs(
            jr,
            {
              id: p.id,
              store: o,
              className: Hf,
              disabled: p.disabled || l(p.id) && !s.canClickBack || c(p.id) && !s.canClickForward,
              children: [
                /* @__PURE__ */ f.jsx(
                  "div",
                  {
                    className: [
                      $f,
                      !l(p.id) && (a(p.id) ? "text-white border-0 bg-red-400" : "border-red-800 text-red-800 border-[3px]"),
                      l(p.id) && "bg-red-400 text-white border-0"
                    ].join(" "),
                    children: s.showCompleteCheck && l(p.id) ? /* @__PURE__ */ f.jsx(ds, { className: "text-3xl pb-0.5 pr-0.5" }) : g + 1
                  }
                ),
                /* @__PURE__ */ f.jsx(
                  "div",
                  {
                    className: [
                      Kf,
                      a(p.id) || l(p.id) ? "text-red-400" : "text-red-800"
                    ].join(" "),
                    children: p.title
                  }
                )
              ]
            },
            p.id
          ),
          g !== t.length - 1 && /* @__PURE__ */ f.jsx(
            "div",
            {
              className: [
                Wf,
                l(p.id) ? "border-red-400" : "border-red-800"
              ].join(" ")
            }
          )
        ] }))
      }
    ),
    t.map((p) => /* @__PURE__ */ f.jsx(Lr, { tabId: p.id, store: o, children: p.content }))
  ] });
};
export {
  a2 as AlphaLogo,
  b2 as AvatarCard,
  jd as Button,
  x2 as Card,
  v2 as Checkbox,
  Uf as Dashboard,
  Yf as DashboardItem,
  Xf as DashboardItemList,
  Jf as DashboardPanel,
  Qf as DashboardPanelSection,
  l2 as EnvelopeIcon,
  u2 as FailureIcon,
  e2 as Form,
  n2 as FormCriteria,
  t2 as FormError,
  ud as FormErrorDisplay,
  o2 as FormGroup,
  r2 as FormInput,
  Bn as FormLabel,
  S2 as FullPageContainer,
  C2 as InlineToast,
  E2 as LanguageDropdown,
  _d as LanguageIcon,
  y2 as Loader,
  c2 as LocationIcon,
  p2 as Modal,
  h2 as ModalDismiss,
  g2 as ModalHeading,
  w2 as Page,
  Ud as Select,
  Gd as SelectItem,
  d2 as SendEmailIcon,
  _2 as SliceContainer,
  O2 as SocialLoginButton,
  If as SocialLoginButtonVariant,
  A2 as Stepper,
  gd as StrengthMeter,
  m2 as SuccessCheck,
  f2 as UserIcon,
  i2 as ValidationSummary,
  s2 as VisuallyHidden,
  I2 as Widget,
  qe as decodeHtml,
  xe as getRTLClasses,
  Gf as interpolateIntoString,
  qf as isRtlLanguage
};
